(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ CacheProvider; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ ThemeContext; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* reexport */ css_browser_esm; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withEmotionCache": function() { return /* reexport */ withEmotionCache; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/core/node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/emotion-element-04d85134.browser.esm.js






var emotion_element_04d85134_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css);

;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css_browser_esm.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var core_browser_esm_Noop = function Noop() {
  return null;
};

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(core_browser_esm_Noop, null);


    return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
  });
});




/***/ }),

/***/ 51667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#262D34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.9999 11H6.41394L11.7069 5.707L10.2929 4.293L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowLeft);

/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 54204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// UNUSED EXPORTS: ButtonGroup

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/button/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-primitive/dist/index.esm.js
var index_esm = __webpack_require__(5144);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-utils/dist/index.esm.js
var dist_index_esm = __webpack_require__(81725);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root{--loading-black:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' color='gray'><circle opacity='.25' cx='12' cy='12' r='10' stroke='currentColor' stroke-width='4'></circle><path opacity='.75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path></svg>\");--loading-white:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' color='white'><circle opacity='.25' cx='12' cy='12' r='10' stroke='currentColor' stroke-width='4'></circle><path opacity='.75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path></svg>\");--transition-timing:300ms cubic-bezier(0.075,0.82,0.165,1);--disabledColor:var(--color-action-disabled);--disabledTextColor:var(--color-text-disabled)}.button-module_button__4s-13{display:flex;align-items:center;justify-content:center;border-radius:var(--size-border-radius-base);font-weight:600;border:none;cursor:pointer;transition:.3s cubic-bezier(.075,.82,.165,1);-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;--loading-indicator:var(--loading-white);color:var(--textColor)}.button-module_button__4s-13:focus{z-index:1}.button-module_button__4s-13[aria-disabled=true],.button-module_button__4s-13[aria-disabled=true] i{cursor:not-allowed}.button-module_button__4s-13[aria-disabled=true]:focus{box-shadow:none}.button-module_fullWidth__VcGx7{width:100%}.button-module_sm__3vw92{padding:.25rem .5rem;font-size:var(--size-font-body-small);line-height:var(--size-line-height-text-body-small)}.button-module_md__3WEO6{padding:.5rem 1rem}.button-module_lg__2rekF,.button-module_md__3WEO6{font-size:var(--size-font-body);line-height:var(--size-line-height-text-body)}.button-module_lg__2rekF{padding:.75rem 1.5rem}.button-module_blue__3wLUv{--backgroundColor:var(--color-action-default);--textColor:var(--color-text-inverse);--hoverColor:var(--color-action-hovered);--focusColor:var(--color-blue-50);--activeColor:var(--color-action-pressed);background-color:var(--backgroundColor)}.button-module_blue__3wLUv:focus{box-shadow:0 0 0 2px var(--color-white),0 0 0 4px var(--focusColor)}.button-module_blue__3wLUv[aria-disabled=false]:active{background-color:var(--activeColor)}.button-module_blue__3wLUv[aria-disabled=false]:hover:not(:active){transition:var(--transition-timing);background-color:var(--hoverColor)}.button-module_blue__3wLUv[aria-disabled=true]{background-color:var(--disabledColor);color:var(--disabledTextColor)}.button-module_black__2ElLH{--backgroundColor:var(--color-action-neutral-default);--textColor:var(--color-text-inverse);--hoverColor:var(--color-action-neutral-hovered);--focusColor:var(--color-blue-50);--activeColor:var(--color-action-neutral-pressed);background-color:var(--backgroundColor)}.button-module_black__2ElLH:focus{box-shadow:0 0 0 2px var(--color-white),0 0 0 4px var(--focusColor)}.button-module_black__2ElLH[aria-disabled=false]:active{background-color:var(--activeColor)}.button-module_black__2ElLH[aria-disabled=false]:hover:not(:active){transition:var(--transition-timing);background-color:var(--hoverColor)}.button-module_black__2ElLH[aria-disabled=true]{background-color:var(--disabledColor);color:var(--disabledTextColor)}.button-module_white__1yiJT{--loading-indicator:var(--loading-black);--backgroundColor:var(--color-surface-default);--borderColor:var(--color-gray-50);--textColor:var(--color-text-default);--hoverColor:var(--color-gray-5);--focusColor:var(--color-blue-50);--activeColor:var(--color-gray-10);background-color:var(--backgroundColor);color:var(--textColor);outline:1px solid var(--borderColor)}.button-module_white__1yiJT:focus{box-shadow:0 0 0 2px var(--color-white),0 0 0 4px var(--focusColor)}.button-module_white__1yiJT[aria-disabled=false]:active{background-color:var(--activeColor)}.button-module_white__1yiJT[aria-disabled=false]:hover:not(:active){transition:var(--transition-timing);background-color:var(--hoverColor)}.button-module_white__1yiJT[aria-disabled=true]{color:var(--disabledTextColor);border:none;background-color:var(--disabledColor)}.button-module_red__3h_Cv{--backgroundColor:var(--color-red-60);--textColor:var(--color-text-inverse);--hoverColor:var(--color-red-80);--focusColor:var(--color-blue-50);--activeColor:var(--color-red-90);background-color:var(--backgroundColor)}.button-module_red__3h_Cv:focus{box-shadow:0 0 0 2px var(--color-white),0 0 0 4px var(--focusColor)}.button-module_red__3h_Cv[aria-disabled=false]:active{background-color:var(--activeColor)}.button-module_red__3h_Cv[aria-disabled=false]:hover:not(:active){transition:var(--transition-timing);background-color:var(--hoverColor)}.button-module_red__3h_Cv[aria-disabled=true]{background-color:var(--disabledColor);color:var(--disabledTextColor)}.button-module_ghost__3Lssz{background-color:transparent;color:var(--backgroundColor);border:none}.button-module_ghost__3Lssz:focus{background-color:var(--color-white);box-shadow:0 0 0 2px var(--focusColor)}.button-module_ghost__3Lssz[aria-disabled=false]:active{background-color:transparent;color:var(--activeColor)}.button-module_ghost__3Lssz[aria-disabled=false]:hover:not(:active){transition:var(--transition-timing);background-color:var(--color-gray-10);color:var(--hoverColor)}.button-module_ghost__3Lssz[aria-disabled=true]{background-color:var(--disabledColor);color:var(--disabledTextColor)}.button-module_loading__2UsWm{background:var(--loading-indicator) no-repeat 50%;margin-right:1rem;height:20px;width:20px;-webkit-animation:button-module_spin__2k7Km 1s linear infinite;animation:button-module_spin__2k7Km 1s linear infinite}@-webkit-keyframes button-module_spin__2k7Km{to{transform:rotate(1turn)}}@keyframes button-module_spin__2k7Km{to{transform:rotate(1turn)}}.button-module_iconOnly__1ARTt{display:inline-flex;align-items:center;justify-content:center;padding:0;width:auto}.button-module_iconOnly__1ARTt.button-module_sm__3vw92{width:28px;height:28px}.button-module_iconOnly__1ARTt.button-module_md__3WEO6{width:36px;height:36px}.button-module_iconOnly__1ARTt.button-module_lg__2rekF{width:46px;height:46px}.button-module_iconOnly__1ARTt[aria-disabled=true]{color:var(--color-icon-disabled)}.button-module_iconOnly__1ARTt.button-module_ghost__3Lssz,.button-module_iconOnly__1ARTt.button-module_ghost__3Lssz[aria-disabled=false]:active,.button-module_iconOnly__1ARTt.button-module_ghost__3Lssz[aria-disabled=false]:focus,.button-module_iconOnly__1ARTt.button-module_ghost__3Lssz[aria-disabled=false]:hover,.button-module_iconOnly__1ARTt.button-module_white__1yiJT,.button-module_iconOnly__1ARTt.button-module_white__1yiJT[aria-disabled=false]:active,.button-module_iconOnly__1ARTt.button-module_white__1yiJT[aria-disabled=false]:focus,.button-module_iconOnly__1ARTt.button-module_white__1yiJT[aria-disabled=false]:hover{color:var(--color-icon-default)}.button-module_buttonGroup__216p5{display:inline-flex;align-items:center;justify-content:center;padding:0;width:auto}.button-module_buttonGroup__216p5 .button-module_button__4s-13:first-of-type{border-right:1px solid hsla(0,0%,100%,.3)}.button-module_buttonGroup__216p5 .button-module_button__4s-13:last-of-type{border-top-left-radius:0;border-bottom-left-radius:0}.button-module_buttonGroup__216p5 .button-module_button__4s-13:not(:first-of-type):not(:last-of-type){border-radius:0;border-right:1px solid hsla(0,0%,100%,.3)}.button-module_buttonGroup__216p5 .button-module_button__4s-13:first-of-type{border-top-right-radius:0;border-bottom-right-radius:0}.button-module_buttonGroup__216p5 .button-module_iconOnly__1ARTt.button-module_sm__3vw92{width:28px;height:28px}.button-module_buttonGroup__216p5 .button-module_iconOnly__1ARTt.button-module_md__3WEO6{width:40px;height:40px}.button-module_buttonGroup__216p5 .button-module_iconOnly__1ARTt.button-module_lg__2rekF{width:48px;height:48px}";
var styles = {"button":"button-module_button__4s-13","fullWidth":"button-module_fullWidth__VcGx7","sm":"button-module_sm__3vw92","md":"button-module_md__3WEO6","lg":"button-module_lg__2rekF","blue":"button-module_blue__3wLUv","black":"button-module_black__2ElLH","white":"button-module_white__1yiJT","red":"button-module_red__3h_Cv","ghost":"button-module_ghost__3Lssz","loading":"button-module_loading__2UsWm","spin":"button-module_spin__2k7Km","iconOnly":"button-module_iconOnly__1ARTt","buttonGroup":"button-module_buttonGroup__216p5"};
styleInject(css_248z);

var _a;
var ButtonGroupContextProvider = (_a = (0,dist_index_esm/* createContext */.kr)({
    name: 'ButtonGroupContext',
    strict: false,
}), _a[0]), useButtonGroupContext = _a[1];

var DESCRIPTION_NAME$1 = 'ButtonGroup';
var ButtonGroup = react.forwardRef(function (props, ref) {
    var children = props.children, as = props.as, variant = props.variant, size = props.size, color = props.color, buttonGroupProps = __rest(props, ["children", "as", "variant", "size", "color"]);
    var context = react.useMemo(function () { return ({ size: size, variant: variant, color: color }); }, [size, variant, color]);
    return (react.createElement(ButtonGroupContextProvider, { value: context },
        react.createElement(index_esm/* Primitive */.WV, __assign({ as: as, ref: ref, role: "group", className: clsx_m(styles.buttonGroup) }, buttonGroupProps), children)));
});
ButtonGroup.displayName = DESCRIPTION_NAME$1;

var DESCRIPTION_NAME = 'Button';
var DESCRIPTION_DEFAULT_TAG = 'button';
var Button = react.forwardRef(function (props, ref) {
    var _a = props.as, as = _a === void 0 ? DESCRIPTION_DEFAULT_TAG : _a, className = props.className, _b = props.color, color = _b === void 0 ? 'blue' : _b, _c = props.size, size = _c === void 0 ? 'md' : _c, _d = props.variant, variant = _d === void 0 ? 'solid' : _d, _e = props.isLoading, isLoading = _e === void 0 ? false : _e, _f = props.iconOnly, iconOnly = _f === void 0 ? false : _f, _g = props.fullWidth, fullWidth = _g === void 0 ? false : _g, _h = props.disabled, disabled = _h === void 0 ? false : _h, onClick = props.onClick, children = props.children, buttonProps = __rest(props, ["as", "className", "color", "size", "variant", "isLoading", "iconOnly", "fullWidth", "disabled", "onClick", "children"]);
    var buttonGroupContext = useButtonGroupContext();
    var classes = clsx_m(styles.button, styles[(buttonGroupContext === null || buttonGroupContext === void 0 ? void 0 : buttonGroupContext.size) || size], styles[(buttonGroupContext === null || buttonGroupContext === void 0 ? void 0 : buttonGroupContext.color) || color], styles[(buttonGroupContext === null || buttonGroupContext === void 0 ? void 0 : buttonGroupContext.variant) || variant], fullWidth && styles.fullWidth, iconOnly && styles.iconOnly, className);
    function handleClick(event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        onClick && onClick(event);
    }
    return (react.createElement(index_esm/* Primitive */.WV, __assign({ type: "button", className: classes, ref: ref, as: as, "aria-disabled": disabled, onClick: handleClick }, buttonProps),
        isLoading && react.createElement("span", { className: styles.loading, "aria-hidden": true }),
        children));
});
Button.displayName = DESCRIPTION_NAME;




/***/ }),

/***/ 5144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WV": function() { return /* binding */ Primitive; }
/* harmony export */ });
/* unused harmony exports Root, extendPrimitive */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/
var NAME = 'Primitive';
var DEFAULT_TAG = 'div';
var Primitive = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, forwardedRef) {
    var _a = props.as, Comp = _a === void 0 ? DEFAULT_TAG : _a, primitiveProps = __rest(props, ["as"]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, __assign({}, primitiveProps, { ref: forwardedRef }));
});
Primitive.displayName = NAME;
/* -----------------------------------------------------------------------------------------------*/
var Root = (/* unused pure expression or super */ null && (Primitive));

function extendPrimitive(Comp, config) {
    var Extended = React.forwardRef(function (props, forwardedRef) {
        var As = Comp;
        var propsWithDefaults = __assign(__assign({}, config.defaultProps), props);
        return React.createElement(As, __assign({}, propsWithDefaults, { ref: forwardedRef }));
    });
    Extended.displayName = config.displayName || 'Extended' + Comp.displayName;
    return Extended;
}




/***/ }),

/***/ 81725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Me": function() { return /* binding */ useId; },
/* harmony export */   "kr": function() { return /* binding */ createContext; }
/* harmony export */ });
/* unused harmony exports isBrowser, useDisclosure, useLayoutEffect, useMedia, useWindowSize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */
function createContext(options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? true : _a, _b = options.errorMessage, errorMessage = _b === void 0 ? 'useContext: `context` is undefined. Seems you forgot to wrap component within the Provider' : _b, name = options.name;
    var Context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
    Context.displayName = name;
    function useContext() {
        var _a;
        var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(Context);
        if (!context && strict) {
            var error = new Error(errorMessage);
            error.name = 'ContextError';
            (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context,
    ];
}

/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */
var useLayoutEffect = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document)
    ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect
    : function () { };

// We `toString()` to prevent bundlers from trying to `import { useId } from 'react';`
var useReactId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()] || (function () { return undefined; });
var count = 0;
var useId = function useId(deterministicId) {
    var _a = react__WEBPACK_IMPORTED_MODULE_0__.useState(useReactId()), id = _a[0], setId = _a[1];
    // React versions older than 18 will have client-side ids only.
    useLayoutEffect(function () {
        if (!deterministicId)
            setId(function (reactId) { return reactId !== null && reactId !== void 0 ? reactId : String(count++); });
    }, [deterministicId]);
    return deterministicId || (id ? "wartek-".concat(id) : '');
};

var isBrowser = typeof window !== 'undefined';

var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (isBrowser) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia = function (query, defaultState) {
    var _a = React.useState(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    React.useEffect(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};

var useDisclosure = function (props) {
    if (props === void 0) { props = {}; }
    var onClose = props.onClose, onOpen = props.onOpen, isOpen = props.isOpen;
    var _a = React.useState(isOpen || false), isOpenState = _a[0], setIsOpen = _a[1];
    var onCloseAction = React.useCallback(function () {
        setIsOpen(false);
        onClose && onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onOpenAction = React.useCallback(function () {
        setIsOpen(true);
        onOpen && onOpen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onToggle = React.useCallback(function () {
        var action = isOpenState ? onCloseAction : onOpenAction;
        action && action();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenState]);
    return {
        isOpen: !!isOpenState,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
    };
};

var useWindowSize = function () {
    var _a = useState({
        innerWidth: 0,
        innerHeight: 0,
    }), windowSize = _a[0], setWindowSize = _a[1];
    useLayoutEffect$1(function () {
        var updateSize = function () {
            setWindowSize({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            });
        };
        updateSize();
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', updateSize);
        return function () { return window === null || window === void 0 ? void 0 : window.removeEventListener('resize', updateSize); };
    }, []);
    return windowSize;
};




/***/ }),

/***/ 35884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Spinner; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/spinner/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/spinner/dist/index.esm.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root{--sm-size:18px;--md-size:23px;--lg-size:32px;--sm-border-size:3px;--md-border-size:4.5px;--lg-border-size:6px}@-webkit-keyframes Spinner-module_spinner__1U4Km{0%{transform:translate3d(-50%,-50%,0) rotate(0deg)}to{transform:translate3d(-50%,-50%,0) rotate(1turn)}}@keyframes Spinner-module_spinner__1U4Km{0%{transform:translate3d(-50%,-50%,0) rotate(0deg)}to{transform:translate3d(-50%,-50%,0) rotate(1turn)}}.Spinner-module_spinner__1U4Km{display:block;position:relative}.Spinner-module_spinner__1U4Km:before{-webkit-animation:Spinner-module_spinner__1U4Km 1s cubic-bezier(.5,0,.5,1) infinite;animation:Spinner-module_spinner__1U4Km 1s cubic-bezier(.5,0,.5,1) infinite;-webkit-animation-play-state:inherit;animation-play-state:inherit;border:solid var(--sm-border-size) var(--color-border-disabled);border-bottom-color:#1c87c9;border-radius:50%;content:\"\";height:100%;position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);width:100%;will-change:transform;box-sizing:content-box}.Spinner-module_sm__6J_L6{width:var(--sm-size);height:var(--sm-size)}.Spinner-module_sm__6J_L6.Spinner-module_spinner__1U4Km:before{border:solid var(--sm-border-size) var(--color-border-disabled)}.Spinner-module_md__3JfcB{width:var(--md-size);height:var(--md-size)}.Spinner-module_md__3JfcB.Spinner-module_spinner__1U4Km:before{border:solid var(--md-border-size) var(--color-border-disabled)}.Spinner-module_lg__1zUOp{width:var(--lg-size);height:var(--lg-size)}.Spinner-module_lg__1zUOp.Spinner-module_spinner__1U4Km:before{border:solid var(--lg-border-size) var(--color-border-disabled)}.Spinner-module_blue__Ulru5.Spinner-module_spinner__1U4Km:before{border-bottom-color:var(--color-interactive-default)}";
var styles = {"spinner":"Spinner-module_spinner__1U4Km","sm":"Spinner-module_sm__6J_L6","md":"Spinner-module_md__3JfcB","lg":"Spinner-module_lg__1zUOp","blue":"Spinner-module_blue__Ulru5"};
styleInject(css_248z);

var Spinner = function (props) {
    var _a = props.size, size = _a === void 0 ? 'md' : _a, spinnerProps = __rest(props, ["size"]);
    var ariaLabel = ['spinner', size].join('_');
    return (react.createElement("div", __assign({ className: clsx_m(styles.spinner, styles.blue, styles[size]), "aria-label": ariaLabel }, spinnerProps)));
};




/***/ }),

/***/ 89004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Text; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/text/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-primitive/dist/index.esm.js
var index_esm = __webpack_require__(5144);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Text-module_text-helper__1qBVh{font-weight:var(--font-weight-helper);font-size:var(--size-font-helper);line-height:var(--size-line-height-text-helper);font-family:var(--font-family-helper)}.Text-module_text-helper-bold__1uFG2{font-weight:var(--font-weight-helper-bold);font-size:var(--size-font-helper-bold);line-height:var(--size-line-height-text-helper-bold);font-family:var(--font-family-helper-bold)}.Text-module_text-body-sm__3mFjZ{font-weight:var(--font-weight-body-small);font-family:var(--font-family-body-small)}.Text-module_text-body-sm-bold__2mhWb,.Text-module_text-body-sm__3mFjZ{font-size:var(--size-font-body-small);line-height:var(--size-line-height-text-body-small)}.Text-module_text-body-sm-bold__2mhWb{font-weight:600;font-family:var(--font-family-body-small-bold)}.Text-module_text-body__2g3QX{font-weight:var(--font-weight-body)}.Text-module_text-body-bold__1qoeV,.Text-module_text-body__2g3QX{font-size:var(--size-font-body);line-height:var(--size-line-height-text-body);font-family:var(--font-family-body)}.Text-module_text-body-bold__1qoeV{font-weight:600}.Text-module_text-body-lg__30alA{font-weight:var(--font-weight-body-large);font-size:var(--size-font-body-large);line-height:var(--size-line-height-text-body-large);font-family:var(--font-family-body-large)}.Text-module_text-action__3jqA6{font-weight:var(--font-weight-action);font-size:var(--size-font-action);line-height:var(--size-line-height-text-action);font-family:var(--font-family-action)}.Text-module_text-subheading__mhOFK{font-weight:var(--font-weight-subheading);font-size:var(--size-font-subheading);line-height:var(--size-line-height-text-subheading);font-family:var(--font-family-subheading)}.Text-module_text-heading-sm__1OENu{font-weight:var(--font-weight-heading-sm);font-size:var(--size-font-heading-sm);line-height:var(--size-line-height-text-heading-sm);font-family:var(--font-family-heading-sm)}.Text-module_text-heading-md__20l_t{font-weight:var(--font-weight-heading-md);font-size:var(--size-font-heading-md);line-height:var(--size-line-height-text-heading-md);font-family:var(--font-family-heading-md)}.Text-module_text-heading-lg__cdImx{font-weight:var(--font-weight-heading-lg);font-size:var(--size-font-heading-lg);line-height:var(--size-line-height-text-heading-lg);font-family:var(--font-family-heading-lg)}.Text-module_text-display-sm__3jb57{font-weight:var(--font-weight-display-sm);font-size:var(--size-font-display-sm);line-height:var(--size-line-height-text-display-sm);font-family:var(--font-family-display-sm)}.Text-module_text-display-md__CrIx4{font-weight:var(--font-weight-display-md);font-size:var(--size-font-display-md);line-height:var(--size-line-height-text-display-md);font-family:var(--font-family-display-md)}.Text-module_text-display-lg__B-b-A{font-weight:var(--font-weight-display-lg);font-size:var(--size-font-display-lg);line-height:var(--size-line-height-text-display-lg);font-family:var(--font-family-display-lg)}.Text-module_text-headline-xs__1essY{font-weight:var(--font-weight-headline-xs);font-size:var(--size-font-headline-xs);line-height:var(--size-line-height-text-headline-xs);font-family:var(--font-family-headline-xs)}.Text-module_text-headline-sm__Eiwfr{font-weight:var(--font-weight-headline-sm);font-size:var(--size-font-headline-sm);line-height:var(--size-line-height-text-headline-sm);font-family:var(--font-family-headline-sm)}.Text-module_text-headline-md__1kZdd{font-weight:var(--font-weight-headline-md);font-size:var(--size-font-headline-md);line-height:var(--size-line-height-text-headline-md);font-family:var(--font-family-headline-md)}.Text-module_text-headline-lg__5q1Ma{font-weight:var(--font-weight-headline-lg);font-size:var(--size-font-headline-lg);line-height:var(--size-line-height-text-headline-lg);font-family:var(--font-family-headline-lg)}.Text-module_text-eyebrow-sm__3-NZk{font-weight:var(--font-weight-eyebrow-sm);font-size:var(--size-font-eyebrow-sm);line-height:var(--size-line-height-text-eyebrow-sm);font-family:var(--font-family-eyebrow-sm)}.Text-module_text-eyebrow-md__1YX4G{font-weight:var(--font-weight-eyebrow-md);font-size:var(--size-font-eyebrow-md);line-height:var(--size-line-height-text-eyebrow-md);font-family:var(--font-family-eyebrow-md)}.Text-module_text-eyebrow-lg__151te{font-weight:var(--font-weight-eyebrow-lg);font-size:var(--size-font-eyebrow-lg);line-height:var(--size-line-height-text-eyebrow-lg);font-family:var(--font-family-eyebrow-lg)}.Text-module_default__1uYUZ{color:var(--color-text-default)}.Text-module_subdued__NNMAh{color:var(--color-text-subdued)}.Text-module_disabled__11nLJ{color:var(--color-text-disabled)}.Text-module_critical__2GC0D{color:var(--color-text-critical)}.Text-module_inverse__33t1w{color:var(--color-text-inverse)}.Text-module_inverse-subdued__1zzat{color:var(--color-text-inverse-subdued)}.Text-module_warning__whGKu{color:var(--color-text-warning)}.Text-module_success__1n6DA{color:var(--color-text-success)}.Text-module_informational__22hiN{color:var(--color-text-informational)}.Text-module_primary__124Yo{color:var(--color-primary)}.Text-module_inherit__13ig2{color:inherit}";
var styles = {"text-helper":"Text-module_text-helper__1qBVh","text-helper-bold":"Text-module_text-helper-bold__1uFG2","text-body-sm":"Text-module_text-body-sm__3mFjZ","text-body-sm-bold":"Text-module_text-body-sm-bold__2mhWb","text-body":"Text-module_text-body__2g3QX","text-body-bold":"Text-module_text-body-bold__1qoeV","text-body-lg":"Text-module_text-body-lg__30alA","text-action":"Text-module_text-action__3jqA6","text-subheading":"Text-module_text-subheading__mhOFK","text-heading-sm":"Text-module_text-heading-sm__1OENu","text-heading-md":"Text-module_text-heading-md__20l_t","text-heading-lg":"Text-module_text-heading-lg__cdImx","text-display-sm":"Text-module_text-display-sm__3jb57","text-display-md":"Text-module_text-display-md__CrIx4","text-display-lg":"Text-module_text-display-lg__B-b-A","text-headline-xs":"Text-module_text-headline-xs__1essY","text-headline-sm":"Text-module_text-headline-sm__Eiwfr","text-headline-md":"Text-module_text-headline-md__1kZdd","text-headline-lg":"Text-module_text-headline-lg__5q1Ma","text-eyebrow-sm":"Text-module_text-eyebrow-sm__3-NZk","text-eyebrow-md":"Text-module_text-eyebrow-md__1YX4G","text-eyebrow-lg":"Text-module_text-eyebrow-lg__151te","default":"Text-module_default__1uYUZ","subdued":"Text-module_subdued__NNMAh","disabled":"Text-module_disabled__11nLJ","critical":"Text-module_critical__2GC0D","inverse":"Text-module_inverse__33t1w","inverse-subdued":"Text-module_inverse-subdued__1zzat","warning":"Text-module_warning__whGKu","success":"Text-module_success__1n6DA","informational":"Text-module_informational__22hiN","primary":"Text-module_primary__124Yo","inherit":"Text-module_inherit__13ig2","textHelper":"Text-module_text-helper__1qBVh","textHelperBold":"Text-module_text-helper-bold__1uFG2","textBodySm":"Text-module_text-body-sm__3mFjZ","textBodySmBold":"Text-module_text-body-sm-bold__2mhWb","textBody":"Text-module_text-body__2g3QX","textBodyBold":"Text-module_text-body-bold__1qoeV","textBodyLg":"Text-module_text-body-lg__30alA","textAction":"Text-module_text-action__3jqA6","textSubheading":"Text-module_text-subheading__mhOFK","textHeadingSm":"Text-module_text-heading-sm__1OENu","textHeadingMd":"Text-module_text-heading-md__20l_t","textHeadingLg":"Text-module_text-heading-lg__cdImx","textDisplaySm":"Text-module_text-display-sm__3jb57","textDisplayMd":"Text-module_text-display-md__CrIx4","textDisplayLg":"Text-module_text-display-lg__B-b-A","textHeadlineXs":"Text-module_text-headline-xs__1essY","textHeadlineSm":"Text-module_text-headline-sm__Eiwfr","textHeadlineMd":"Text-module_text-headline-md__1kZdd","textHeadlineLg":"Text-module_text-headline-lg__5q1Ma","textEyebrowSm":"Text-module_text-eyebrow-sm__3-NZk","textEyebrowMd":"Text-module_text-eyebrow-md__1YX4G","textEyebrowLg":"Text-module_text-eyebrow-lg__151te","$default$":"Text-module_default__1uYUZ","inverseSubdued":"Text-module_inverse-subdued__1zzat"};
styleInject(css_248z);

var DESCRIPTION_NAME = 'Text';
var DESCRIPTION_DEFAULT_TAG = 'p';
var Text = react.forwardRef(function (props, ref) {
    var _a = props.as, as = _a === void 0 ? DESCRIPTION_DEFAULT_TAG : _a, _b = props.variant, variant = _b === void 0 ? 'body' : _b, _c = props.color, color = _c === void 0 ? 'default' : _c, className = props.className, textProps = __rest(props, ["as", "variant", "color", "className"]);
    var classes = clsx_m(styles[color], styles['text-' + variant]);
    return (react.createElement(index_esm/* Primitive */.WV, __assign({ as: as, className: clsx_m(className, classes) }, textProps, { ref: ref })));
});
Text.displayName = DESCRIPTION_NAME;




/***/ }),

/***/ 55086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VW": function() { return /* binding */ ToastProvider; },
  "pm": function() { return /* binding */ useToast; }
});

// UNUSED EXPORTS: Toast, ToastContainer

;// CONCATENATED MODULE: ./node_modules/@wartek-id/toast/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__(85611);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Toast-module_toastContainer__oLgA5{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;max-height:100%;width:90%;overflow:hidden;padding:.75rem;margin-bottom:.5rem;position:fixed;z-index:150}@media (min-width:768px){.Toast-module_toastContainer__oLgA5{max-width:596px}}.Toast-module_hasToast__3OUFD{pointer-events:none}.Toast-module_entered__1_hgi{transform:translateZ(0) scale(1)}.Toast-module_top-left__2DD62{top:0;left:0}.Toast-module_top-left__2DD62 .Toast-module_entering__fYSgH,.Toast-module_top-left__2DD62 .Toast-module_exited__3urW5,.Toast-module_top-left__2DD62 .Toast-module_exiting__tEmJA{transform:translate3d(-120%,0,0) scale(.9)}.Toast-module_top-center__539jA{top:0;left:50%;transform:translate3d(-50%);transform:translateX(-50%)}.Toast-module_top-center__539jA .Toast-module_entering__fYSgH,.Toast-module_top-center__539jA .Toast-module_exited__3urW5,.Toast-module_top-center__539jA .Toast-module_exiting__tEmJA{transform:translate3d(0,-120%,0) scale(.9)}.Toast-module_top-right__2qpkt{top:0;right:0}.Toast-module_top-right__2qpkt .Toast-module_entering__fYSgH,.Toast-module_top-right__2qpkt .Toast-module_exited__3urW5,.Toast-module_top-right__2qpkt .Toast-module_exiting__tEmJA{transform:translate3d(120%,0,0) scale(.9)}.Toast-module_bottom-left__3yg9P{bottom:0;left:0}.Toast-module_bottom-left__3yg9P .Toast-module_entering__fYSgH,.Toast-module_bottom-left__3yg9P .Toast-module_exited__3urW5,.Toast-module_bottom-left__3yg9P .Toast-module_exiting__tEmJA{transform:translate3d(-120%,0,0) scale(.9)}.Toast-module_bottom-center__1iwoc{bottom:0;left:50%;transform:translate3d(-50%);transform:translateX(-50%)}.Toast-module_bottom-center__1iwoc .Toast-module_entering__fYSgH,.Toast-module_bottom-center__1iwoc .Toast-module_exited__3urW5,.Toast-module_bottom-center__1iwoc .Toast-module_exiting__tEmJA{transform:translate3d(0,120%,0) scale(.9)}.Toast-module_bottom-right__vezie{bottom:0;right:0}.Toast-module_bottom-right__vezie .Toast-module_entering__fYSgH,.Toast-module_bottom-right__vezie .Toast-module_exited__3urW5,.Toast-module_bottom-right__vezie .Toast-module_exiting__tEmJA{transform:translate3d(120%,0,0) scale(.9)}.Toast-module_toast__2U5-M{margin-bottom:.5rem;display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;text-align:left;background-color:var(--color-surface-foreground);transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transform-origin:top;z-index:150;font-size:.875rem;box-shadow:0 0 2px rgba(0,0,0,.2),0 2px 10px rgba(0,0,0,.1);border-radius:var(--size-border-radius-base)}.Toast-module_toastParagraph__35LAp{color:var(--color-white);flex:1;display:flex;padding:.75rem 0}.Toast-module_toastParagraphIcon__2imNl{flex:0;padding:0 12px 0 16px;display:flex;justify-content:center}.Toast-module_toastParagraphText__vp1wr{flex:1 1 0;padding-right:1rem;font-size:15px;line-height:22px;overflow:hidden;text-overflow:ellipsis}.Toast-module_toastContentContainer__3DoRw{flex:1;padding-left:16px}.Toast-module_toastParagraphIcon__2imNl+.Toast-module_toastContentContainer__3DoRw{padding-left:0}@media (min-width:768px){.Toast-module_toastContentContainer__3DoRw{display:flex;max-width:596px;justify-content:space-between;align-items:flex-start;padding-right:16px}.Toast-module_toastParagraphText__vp1wr{flex:1 1 0%;width:100%}.Toast-module_toastContentContainer__3DoRw .Toast-module_button__2HLA5{flex:0}}@supports (-webkit-line-clamp:2){.Toast-module_toastParagraphText__vp1wr{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}}.Toast-module_button__2HLA5{background-color:transparent;font-weight:var(--font-weight-body);font-size:var(--size-font-body);line-height:var(--size-line-height-text-body);display:block;border:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;color:#91bcfd;width:100%;text-transform:capitalize;position:relative;padding:0;text-align:left}";
var styles = {"toastContainer":"Toast-module_toastContainer__oLgA5","hasToast":"Toast-module_hasToast__3OUFD","entered":"Toast-module_entered__1_hgi","top-left":"Toast-module_top-left__2DD62","entering":"Toast-module_entering__fYSgH","exiting":"Toast-module_exiting__tEmJA","exited":"Toast-module_exited__3urW5","top-center":"Toast-module_top-center__539jA","top-right":"Toast-module_top-right__2qpkt","bottom-left":"Toast-module_bottom-left__3yg9P","bottom-center":"Toast-module_bottom-center__1iwoc","bottom-right":"Toast-module_bottom-right__vezie","toast":"Toast-module_toast__2U5-M","toastParagraph":"Toast-module_toastParagraph__35LAp","toastParagraphIcon":"Toast-module_toastParagraphIcon__2imNl","toastParagraphText":"Toast-module_toastParagraphText__vp1wr","toastContentContainer":"Toast-module_toastContentContainer__3DoRw","button":"Toast-module_button__2HLA5","topLeft":"Toast-module_top-left__2DD62","topCenter":"Toast-module_top-center__539jA","topRight":"Toast-module_top-right__2qpkt","bottomLeft":"Toast-module_bottom-left__3yg9P","bottomCenter":"Toast-module_bottom-center__1iwoc","bottomRight":"Toast-module_bottom-right__vezie"};
styleInject(css_248z);

function useToast() {
    var addToast = (0,dist/* useToasts */.e1)().addToast;
    return function toast(_a) {
        var message = _a.message, addToastParams = __rest(_a, ["message"]);
        addToast(message, addToastParams);
    };
}
var ToastContainer = function (_a) {
    var hasToasts = _a.hasToasts, children = _a.children, _b = _a.placement, placement = _b === void 0 ? 'top-center' : _b;
    var containerClass = clsx_m(styles.toastContainer, styles[placement], !hasToasts && styles.hasToast);
    return (react.createElement("div", { "aria-live": "polite", className: containerClass }, children));
};
var Toast = function (_a) {
    var children = _a.children, transitionDuration = _a.transitionDuration, transitionState = _a.transitionState, onDismiss = _a.onDismiss, _b = _a.type, type = _b === void 0 ? 'default' : _b, icon = _a.icon, actionLabel = _a.actionLabel, onActionLabelClicked = _a.onActionLabelClicked;
    var toastClasses = clsx_m(styles.toast, styles[transitionState]);
    var onClick = function () {
        onDismiss();
        if (onActionLabelClicked) {
            onActionLabelClicked();
        }
    };
    return (react.createElement("div", { className: toastClasses, style: {
            transitionDuration: "".concat(transitionDuration, "ms"),
        } },
        react.createElement("div", { className: styles.toastParagraph, title: children },
            (icon || type === 'success') && (react.createElement("div", { className: styles.toastParagraphIcon }, type === 'success' ? react.createElement(CheckMarkIcon, null) : icon)),
            react.createElement("div", { className: styles.toastContentContainer },
                react.createElement("div", { className: styles.toastParagraphText, dangerouslySetInnerHTML: { __html: children } }),
                actionLabel && (react.createElement("button", { className: styles.button, onClick: onClick }, actionLabel))))));
};
var ToastProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react.createElement(dist/* ToastProvider */.VW, __assign({ components: { ToastContainer: ToastContainer, Toast: Toast } }, props), children));
};
var CheckMarkIcon = function () { return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { d: "M8.99997 16.1701L4.82997 12.0001L3.40997 13.4101L8.99997 19.0001L21 7.00009L19.59 5.59009L8.99997 16.1701Z", fill: "#F5F5F5" }))); };




/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(88593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(76907);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fy": function() { return /* binding */ DEFAULT_VALUE_AKSI_NYATA_FORM_IMPROVEMENT; },
/* harmony export */   "Ki": function() { return /* binding */ useGetKeyValueQuery; },
/* harmony export */   "QK": function() { return /* binding */ MILKvKeys; },
/* harmony export */   "q8": function() { return /* binding */ useGetKeyPairValue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32407);





var MILKvKeys;
(function(MILKvKeys) {
    MILKvKeys["FeatureFlag"] = "feature_flag";
    MILKvKeys["WebinarEntries"] = "webinar_entries";
    MILKvKeys["PendaftaranKomunitas"] = "ikm_info_page";
    MILKvKeys["IKMDocuments"] = "ikm_document";
    MILKvKeys["IKMFilter"] = "ikm_community_filter";
    MILKvKeys["IKMCommunityRecommendation"] = "ikm_recommended_community";
    MILKvKeys["RKMMContributionBanner"] = "rkmm_kontribusi_banner";
    MILKvKeys["LearningSeries"] = "learning_series";
    MILKvKeys["TopicSpeed"] = "topic_speed";
    MILKvKeys["DisabledMateriVideo"] = "disabled_materi_video";
    MILKvKeys["FAQSertifikatMandiri"] = "faq_sertifikat_mandiri";
    MILKvKeys["AksiNyataFormFlowImprovement"] = "aksi_nyata_form_flow_improvement";
    MILKvKeys["JurnalPembelajranFormFlowImprovement"] = "jurnal_pembelajaran_form_flow_improvement";
    MILKvKeys["TopicSurveyBanner"] = "topic_survey";
    MILKvKeys["TopikReferensiTab"] = "topik_referensi_tab";
    MILKvKeys["FeaturedAksiNyata"] = "featured_aksi_nyata";
    MILKvKeys["TopicListUpdateInformation"] = "topic_list_update_information";
})(MILKvKeys || (MILKvKeys = {}));
var keyValueUrl =  true ? "https://mil-kv.guru.belajar.id" + "/kv" : 0;
function fetchKeyValue(key) {
    return typeof key === "undefined" ? Promise.reject(new Error("invalid Key")) : axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(keyValueUrl, "/").concat(key, ".json"));
}
function fetchKeyValueQuery(key) {
    return typeof key === "undefined" ? Promise.reject(new Error("invalid Key")) : axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat("https://api.belajar.id", "/microlearnings/cms/kv?key=").concat(key));
}
var DEFAULT_VALUE_AKSI_NYATA_FORM_IMPROVEMENT = {
    INITIAL_CONFIRM: {
        title: "Kumpulkan umpan balik",
        subtitle: "Minta umpan balik dari hasil Aksi Nyata yang telah Anda lakukan",
        items: [
            "<p>Kumpulkan <strong>umpan balik dari sasaran Aksi Nyata Anda.</strong></p>",
            "<p>Umpan balik bisa dikumpulkan dalam bentuk formulir, rekap jawaban, atau tangkapan layar. <br />{{url}}</p>",
            "<p>Masukkan umpan balik ke dalam dokumen Aksi Nyata Anda.</p>", 
        ],
        urlTitle: "Lihat contoh umpan balik",
        urlTarget: "https://guru.kemdikbud.go.id.com"
    },
    BEFORE_FORM: {
        title: "Lanjut ke Lembar Aksi Nyata?",
        subtitle: "Cek ulang kelengkapan Aksi Nyata Anda",
        options: [
            "Aksi Nyata sudah dilakukan",
            "Dokumen Aksi Nyata telah dibuat dalam bentuk PDF",
            "Laporan umpan balik telah disertakan di dalam dokumen Aksi Nyata", 
        ]
    },
    FORM: {
        uploadField: {
            title: "Unggah dokumen Aksi Nyata Anda",
            descriptionPoints: [
                "Pastikan dokumen lengkap",
                "Pastikan terdapat laporan umpan balik", 
            ]
        }
    },
    AFTER_FORM: {
        title: "Apakah anda yakin mengumpulkan Aksi Nyata?",
        subtitle: "Pastikan Aksi Nyata memenuhi kriteria di bawah ini untuk mempermudah memperoleh validasi",
        highlightedPoints: [
            "Tidak plagiat karya Aksi Nyata orang lain",
            "Aktifitas Aksi Nyata sesuai dengan panduan",
            "Dokumentasi lengkap",
            "Menyertakan laporan umpan balik di dalam dokumen", 
        ],
        buttonTitle: "Kumpulkan"
    }
};
function useGetKeyPairValue(key) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queryConfig = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        keyValueUrl,
        key
    ], function() {
        return fetchKeyValue(key);
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, queryConfig), {
        onError: function(error) {
            return (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(error);
        },
        enabled: enabled
    }));
}
function useGetKeyValueQuery(key) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queryConfig = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        keyValueUrl,
        key
    ], function() {
        return fetchKeyValueQuery(key);
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, queryConfig), {
        onError: function(error) {
            return (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(error);
        },
        enabled: enabled
    }));
}


/***/ }),

/***/ 99270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ub": function() { return /* reexport */ EmptyState; },
  "Px": function() { return /* reexport */ EmptyStateAction; },
  "ox": function() { return /* reexport */ EmptyStateImage; },
  "fK": function() { return /* reexport */ EmptyStateWithIllustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-keyed-flatten-children/index.js
var react_keyed_flatten_children = __webpack_require__(23262);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(54204);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(89004);
;// CONCATENATED MODULE: ./components/EmptyState/EmptyState.tsx











function EmptyStateAction(props) {
    var _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Button */.z, (0,_object_spread/* default */.Z)({
        fullWidth: true,
        color: props.color || "blue",
        size: "md",
        className: (_className = props.className) !== null && _className !== void 0 ? _className : "w-full mb-4"
    }, props));
}
function EmptyState(_param) {
    var _withHeader = _param.withHeader, withHeader = _withHeader === void 0 ? true : _withHeader, _fullscreen = _param.fullscreen, fullscreen = _fullscreen === void 0 ? true : _fullscreen, title = _param.title, description = _param.description, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "withHeader",
        "fullscreen",
        "title",
        "description",
        "className",
        "children"
    ]);
    var containerClasses = (0,clsx_m/* default */.Z)("flex flex-col justify-center text-sm", fullscreen ? withHeader ? "h-full--without-header px-5" : "h-full px-5" : "", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: containerClasses
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                as: "h2",
                variant: "heading-md",
                className: "mb-2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                className: "pb-4",
                color: "subdued",
                children: description
            }),
            react.Children.map((0,react_keyed_flatten_children/* default */.Z)(children), function(child) {
                if (typeof child === "object" && child.type === EmptyStateAction) {
                    var _props = child.props, href = _props.href, props = (0,_object_without_properties/* default */.Z)(_props, [
                        "href"
                    ]);
                    if (href) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateAction, (0,_object_spread/* default */.Z)({}, props))
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateAction, (0,_object_spread/* default */.Z)({}, props));
                }
            })
        ]
    }));
}
function EmptyStateImage(_param) {
    var _imageSrc = _param.imageSrc, imageSrc = _imageSrc === void 0 ? "" : _imageSrc, props = (0,_object_without_properties/* default */.Z)(_param, [
        "imageSrc"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center mb-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            src: imageSrc,
            alt: "",
            width: "120",
            height: "120"
        }))
    });
}
function EmptyStateWithIllustration(_param) {
    var _withHeader = _param.withHeader, withHeader = _withHeader === void 0 ? true : _withHeader, _fullscreen = _param.fullscreen, fullscreen = _fullscreen === void 0 ? true : _fullscreen, title = _param.title, description = _param.description, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "withHeader",
        "fullscreen",
        "title",
        "description",
        "className",
        "children"
    ]);
    var containerClasses = (0,clsx_m/* default */.Z)("flex flex-col justify-center text-sm", fullscreen ? withHeader ? "h-full--without-header px-5" : "h-full px-5" : "", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: containerClasses
    }, props), {
        children: [
            react.Children.map((0,react_keyed_flatten_children/* default */.Z)(children), function(child) {
                var ref;
                if (!/*#__PURE__*/ react.isValidElement(child)) {
                    return;
                }
                if (typeof child === "object" && child.type === EmptyStateImage) {
                    var props = child.props;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateImage, (0,_object_spread/* default */.Z)({}, props));
                }
                if ((child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : ref.as) === "EmptyStateImageSvg") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({}, child === null || child === void 0 ? void 0 : child.props))
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                as: "h2",
                variant: "heading-md",
                className: "mb-2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                className: "pb-4",
                color: "subdued",
                children: description
            }),
            react.Children.map((0,react_keyed_flatten_children/* default */.Z)(children), function(child) {
                if (typeof child === "object" && child.type === EmptyStateAction) {
                    var _props = child.props, href = _props.href, props = (0,_object_without_properties/* default */.Z)(_props, [
                        "href"
                    ]);
                    if (href) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateAction, (0,_object_spread/* default */.Z)({}, props))
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateAction, (0,_object_spread/* default */.Z)({}, props));
                }
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./components/EmptyState/index.ts



/***/ }),

/***/ 71130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CustomErrorFallback; },
  "Z": function() { return /* binding */ CustomErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./configs/routes.ts
var routes = __webpack_require__(90294);
// EXTERNAL MODULE: ./utils/androidHandler.ts
var utils_androidHandler = __webpack_require__(84494);
// EXTERNAL MODULE: ./utils/auth/index.tsx + 4 modules
var auth = __webpack_require__(23475);
// EXTERNAL MODULE: ./utils/customError.ts
var customError = __webpack_require__(97512);
// EXTERNAL MODULE: ./utils/router.ts
var utils_router = __webpack_require__(81670);
// EXTERNAL MODULE: ./components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(8008);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
;// CONCATENATED MODULE: ./public/images/errors/img-no-connection.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgImgNoConnection = function SvgImgNoConnection(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M60 115C90.3757 115 115 90.3757 115 60C115 29.6243 90.3757 5 60 5C29.6243 5 5 29.6243 5 60C5 90.3757 29.6243 115 60 115Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M86.57 96.3696H37.5C36.59 96.3696 35.85 97.1096 35.85 98.0196V98.3496C35.85 99.2596 36.59 99.9996 37.5 99.9996H86.57C87.48 99.9996 88.22 99.2596 88.22 98.3496V98.0196C88.22 97.1096 87.48 96.3696 86.57 96.3696Z",
    fill: "#CECECE"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M86.4 27.3198C86.41 20.6098 79.66 19.8698 78.5 19.9798C81.11 20.0298 83.16 22.0598 82.96 24.4398L82.05 36.7698L85.48 38.1598",
    fill: "#03317A"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M81.76 84.76L78.56 83.46L77.61 96.12C77.45 98.29 75.49 99.99 73.1 100.02C80.75 99.98 81.08 93.84 81.08 92.88C81.08 92.84 81.1 92.8 81.11 92.77L81.75 84.78L81.76 84.76Z",
    fill: "#010A33"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M86.2599 28.9696L81.7599 84.7596L78.5599 83.4596L82.7799 27.5796L86.2599 28.9596V28.9696Z",
    fill: "#00216B"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M77.62 96.1096C77.44 98.2996 75.47 99.9996 73.06 99.9996H36.36C33.7 99.9996 31.61 97.9496 31.79 95.5296L32.76 82.7596L32.83 82.6896L34.99 80.6696L34.37 89.0796L33.96 94.4696C33.89 95.4896 34.77 96.3496 35.88 96.3496H73.71C74.74 96.3496 75.57 95.6296 75.63 94.7096L76.06 89.0796L76.32 85.5496L80.55 29.6696L82.78 27.5796L77.63 96.1096H77.62Z",
    fill: "#003370"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M78.55 83.6499L77.61 96.1199C77.59 96.3899 77.54 96.6599 77.47 96.9099C77.41 97.1199 77.33 97.3199 77.24 97.4999C77.18 97.6299 77.11 97.7599 77.03 97.8699C76.99 97.9499 76.94 98.0199 76.89 98.1099C76.76 98.2799 76.63 98.4399 76.48 98.5899C76.01 99.0699 75.44 99.4499 74.79 99.6999C74.66 99.7399 74.54 99.7899 74.39 99.8299C74.12 99.8999 73.83 99.9599 73.54 99.9899C73.43 99.9899 73.3 100.01 73.19 100.01H64.86L67.9 96.3699L73.98 89.0999L76.24 86.3999L78.55 83.6499Z",
    fill: "#012456"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M82.98 24.45L82.78 27.59L80.55 29.67L80.82 25.51C80.9 24.49 80.01 23.63 78.9 23.63H41.05C40.04 23.63 39.19 24.35 39.13 25.26L38.55 33.03L38.43 34.81L38.22 37.52L37.23 50.75L36.62 59.01L34.73 84.33L32.49 86.42L34.68 57.01L35.13 50.97L36.18 36.91L36.32 35.12L37.15 23.88C37.32 21.69 39.3 19.98 41.71 19.98H78.42C81.07 19.98 83.17 22.03 82.98 24.44H82.99L82.98 24.45Z",
    fill: "#094C89"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M50.22 19.98L47.18 23.62L38.47 34.02L36.17 36.77L36.3 35.12L37.14 23.88C37.3 21.69 39.29 19.98 41.7 19.98H50.22Z",
    fill: "#176E94"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M80.54 29.6699L76.3 85.5799L76.05 89.0999H34.35L34.71 84.3299L80.54 29.6699Z",
    fill: "#BADEE2"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M76.24 86.3999L76.05 89.0999H73.98L76.24 86.3999Z",
    fill: "#80B8BF"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M80.8 25.5099L80.54 29.6699L34.71 84.3299L38.2 37.5199L38.46 34.0199L47.17 23.6299H78.87C79.98 23.6299 80.88 24.4899 80.79 25.5099H80.8Z",
    fill: "#E4F4F4"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M76.0399 89.0996L75.6199 94.7296C75.5599 95.6496 74.7299 96.3696 73.6999 96.3696H35.8699C34.7599 96.3696 33.8699 95.5096 33.9499 94.4896L34.3599 89.0996H76.0499H76.0399Z",
    fill: "#458CFF"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M81.76 84.76L78.56 83.46L77.61 96.12C77.45 98.29 75.49 99.99 73.1 100.02C80.75 99.98 81.08 93.84 81.08 92.88C81.08 92.84 81.1 92.8 81.11 92.77",
    fill: "#010A33"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M59.23 27.62C59.96 27.62 60.56 27.04 60.56 26.33C60.56 25.62 59.96 25.04 59.23 25.04C58.5 25.04 57.9 25.62 57.9 26.33C57.9 27.04 58.5 27.62 59.23 27.62Z",
    fill: "#00295D"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M77.44 97.0098L77.28 99.1598C76.22 99.6698 74.85 99.9998 73.1 99.9998C75.15 99.9698 76.87 98.7298 77.43 97.0098H77.44Z",
    fill: "#00125E"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M76.04 89.0996L75.63 94.7296C75.57 95.6496 74.74 96.3696 73.71 96.3696H67.9L73.98 89.0996H76.04Z",
    fill: "#2560E0"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M47.18 23.6196L38.47 34.0196L38.54 33.0296L39.12 25.2596C39.19 24.3496 40.03 23.6196 41.05 23.6196H47.18Z",
    fill: "#CAF3F9"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M74.3099 58.8196C73.6899 58.0396 73.0099 57.3196 72.2699 56.6496C71.5199 55.9196 70.7099 55.2596 69.8699 54.6596C69.5899 54.4596 69.1999 54.5096 68.9799 54.7796L66.6599 57.5296C66.3999 57.8396 66.4799 58.2896 66.8099 58.5096C67.7899 59.1696 68.6899 59.9396 69.4999 60.8096C69.8399 61.1796 70.1799 61.5496 70.4999 61.9396C71.3699 62.9996 72.8899 63.1796 73.9399 62.3096C75.0199 61.4196 75.1599 59.8896 74.3099 58.8296V58.8196Z",
    fill: "#80B8BF"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M66.7499 64.1594C65.8899 63.2094 64.9099 62.3994 63.8799 61.7494C63.5999 61.5794 63.2299 61.6494 63.0199 61.8994L60.6799 64.7094C60.4099 65.0294 60.4999 65.5194 60.8699 65.7094C61.7799 66.1894 62.5999 66.8494 63.2799 67.6594L63.3199 67.7094C64.1499 68.7994 65.7099 68.9694 66.7599 68.0594C67.8199 67.2094 67.9999 65.6794 67.1299 64.6194C66.9999 64.4594 66.8699 64.2994 66.7499 64.1494V64.1594Z",
    fill: "#80B8BF"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M59.9699 70.4897C59.3699 69.7097 58.4499 69.1797 57.3799 69.0597C55.2899 68.8397 53.3999 70.3597 53.1899 72.4597C53.0999 73.3097 53.3099 74.1397 53.7299 74.8497C54.3199 75.8197 55.3599 76.5097 56.5999 76.6497C58.6899 76.8597 60.5699 75.3397 60.7899 73.2497C60.8999 72.2197 60.5799 71.2497 59.9899 70.4997H59.9799L59.9699 70.4897Z",
    fill: "#80B8BF"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M67.6199 48.6196C66.9099 48.0296 65.8599 48.1296 65.2699 48.8296L63.1099 51.4196C61.8699 51.0696 60.6099 50.8196 59.3099 50.6796C53.3799 50.0496 47.5699 51.7596 42.9599 55.4896C41.8999 56.3796 41.7399 57.8696 42.5899 58.9696C43.0399 59.4796 43.6199 59.7896 44.2499 59.8496C44.8799 59.9196 45.5399 59.7396 46.0499 59.3396C49.6399 56.3996 54.1699 55.0296 58.8099 55.5296C59.0699 55.5596 59.3199 55.6196 59.5899 55.6596L56.0899 59.8496C53.4999 60.0196 50.9499 60.9496 48.7799 62.7196C47.7199 63.5696 47.5599 65.0996 48.4099 66.1596C48.8199 66.7096 49.4199 66.9996 50.0499 67.0696L44.8899 73.2496C44.4299 73.7996 44.2999 74.5996 44.6399 75.2296C44.9299 75.7596 45.4199 76.0096 45.9099 76.0696C46.4499 76.1196 46.9999 75.9296 47.3699 75.4796L67.8199 50.9596C68.4099 50.2496 68.3199 49.1996 67.6099 48.6196H67.6199Z",
    fill: "#80B8BF"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M48.7799 62.7195C50.6899 61.1695 52.8899 60.2695 55.1499 59.9595L49.3399 66.8895C48.9799 66.7395 48.6599 66.4995 48.4099 66.1695C47.5599 65.0995 47.7199 63.5795 48.7799 62.7195Z",
    fill: "#BADEE2"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M62.4599 51.2398L58.8599 55.5398C58.8599 55.5398 58.8299 55.5298 58.8099 55.5298C54.1699 55.0298 49.6399 56.3998 46.0499 59.3398C45.5399 59.7498 44.8799 59.9198 44.2499 59.8598C43.6199 59.7898 43.0399 59.4898 42.5899 58.9798C41.7399 57.8698 41.8899 56.3898 42.9599 55.4898C47.5699 51.7598 53.3799 50.0498 59.3099 50.6798C60.3799 50.7898 61.4399 50.9798 62.4599 51.2398Z",
    fill: "#BADEE2"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M73.78 61.8998C72.73 62.7698 71.2 62.5998 70.33 61.5298C70.02 61.1398 69.68 60.7698 69.33 60.3998C68.52 59.5298 67.62 58.7598 66.64 58.0998C66.31 57.8698 66.23 57.4198 66.49 57.1198L68.81 54.3698C69.03 54.1098 69.42 54.0498 69.7 54.2598C70.55 54.8598 71.36 55.5198 72.11 56.2498C72.84 56.9198 73.53 57.6398 74.14 58.4198C75 59.4798 74.85 61.0098 73.78 61.8998Z",
    fill: "#0E43C1"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M66.6 67.6697C65.55 68.5797 63.98 68.4097 63.16 67.3197L63.12 67.2597C62.44 66.4497 61.62 65.7897 60.71 65.3197C60.34 65.1197 60.25 64.6297 60.51 64.3097L62.85 61.4997C63.07 61.2397 63.43 61.1697 63.71 61.3497C64.75 61.9897 65.72 62.7997 66.59 63.7497C66.7 63.9097 66.84 64.0697 66.97 64.2297C67.83 65.2897 67.66 66.8197 66.6 67.6697Z",
    fill: "#0E43C1"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M60.62 72.8496C60.39 74.9396 58.51 76.4596 56.42 76.2496C55.19 76.1096 54.15 75.4296 53.56 74.4496C53.14 73.7396 52.93 72.9196 53.02 72.0596C53.23 69.9596 55.12 68.4296 57.21 68.6596C58.28 68.7696 59.2 69.3096 59.8 70.0896H59.82C60.41 70.8496 60.72 71.8196 60.62 72.8496Z",
    fill: "#0E43C1"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M67.66 50.5696L47.21 75.0796C46.84 75.5296 46.29 75.7296 45.75 75.6796C45.36 75.6196 44.97 75.4596 44.68 75.1196C44.61 75.0396 44.54 74.9396 44.48 74.8296C44.13 74.1996 44.27 73.4096 44.73 72.8496L49.89 66.6696C49.26 66.6096 48.66 66.3196 48.25 65.7596C47.39 64.6996 47.55 63.1696 48.62 62.3196C50.78 60.5596 53.34 59.6196 55.92 59.4496L59.42 55.2596C59.16 55.2196 58.91 55.1596 58.65 55.1296C54.01 54.6296 49.47 55.9996 45.88 58.9396C45.37 59.3496 44.71 59.5196 44.08 59.4496C43.45 59.3896 42.87 59.0896 42.42 58.5696C41.57 57.4696 41.73 55.9796 42.79 55.0896C47.41 51.3596 53.22 49.6496 59.15 50.2796C60.45 50.4096 61.71 50.6596 62.94 51.0096L65.1 48.4196C65.66 47.7696 66.62 47.6396 67.32 48.1196C67.36 48.1396 67.41 48.1696 67.45 48.2096V48.2296C68.16 48.8096 68.26 49.8596 67.66 50.5696Z",
    fill: "#0E43C1"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M66.3369 31.9466L53.7793 31.7054C51.957 31.6705 50.4515 33.1193 50.4165 34.9415C50.3815 36.7637 51.8303 38.2692 53.6526 38.3042L66.2102 38.5453C68.0324 38.5803 69.538 37.1315 69.573 35.3093C69.608 33.4871 68.1591 31.9815 66.3369 31.9466Z",
    fill: "#CE0000"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M53.65 37.1498C54.7711 37.1498 55.68 36.241 55.68 35.1198C55.68 33.9987 54.7711 33.0898 53.65 33.0898C52.5289 33.0898 51.62 33.9987 51.62 35.1198C51.62 36.241 52.5289 37.1498 53.65 37.1498Z",
    fill: "#540C00"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M53.36 37.1498C54.4811 37.1498 55.39 36.241 55.39 35.1198C55.39 33.9987 54.4811 33.0898 53.36 33.0898C52.2388 33.0898 51.33 33.9987 51.33 35.1198C51.33 36.241 52.2388 37.1498 53.36 37.1498Z",
    fill: "#E4F4F4"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M60.8399 35.0498C60.8399 35.4798 60.7599 35.8398 60.5999 36.1398C60.4399 36.4398 60.2199 36.6698 59.9399 36.8298C59.6599 36.9898 59.3499 37.0698 58.9999 37.0698C58.6499 37.0698 58.3399 36.9898 58.0599 36.8298C57.7799 36.6698 57.5599 36.4398 57.3999 36.1398C57.2399 35.8398 57.1599 35.4798 57.1599 35.0498C57.1599 34.6198 57.2399 34.2598 57.3999 33.9598C57.5599 33.6598 57.7799 33.4298 58.0599 33.2698C58.3399 33.1098 58.6499 33.0298 58.9999 33.0298C59.3499 33.0298 59.6599 33.1098 59.9399 33.2698C60.2199 33.4298 60.4399 33.6598 60.5999 33.9598C60.7599 34.2598 60.8399 34.6198 60.8399 35.0498ZM59.9999 35.0498C59.9999 34.6298 59.9099 34.3198 59.7299 34.0998C59.5499 33.8798 59.3099 33.7698 59.0099 33.7698C58.7099 33.7698 58.4699 33.8798 58.2899 34.0998C58.1099 34.3198 58.0199 34.6398 58.0199 35.0498C58.0199 35.4598 58.1099 35.7798 58.2899 35.9998C58.4699 36.2198 58.7099 36.3298 59.0099 36.3298C59.3099 36.3298 59.5499 36.2198 59.7299 35.9998C59.9099 35.7798 59.9999 35.4598 59.9999 35.0498Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M61.45 37.0098V33.0898H64.05V33.7698H62.2799V34.6998H63.8699V35.3798H62.2799V36.9998H61.45V37.0098Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "M64.6099 37.0098V33.0898H67.2099V33.7698H65.4399V34.6998H67.0299V35.3798H65.4399V36.9998H64.6099V37.0098Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "M48.58 36.9897L46.61 38.9397C46.36 39.1897 46.36 39.5797 46.61 39.8297C46.86 40.0797 47.25 40.0797 47.5 39.8297L49.47 37.8797C49.72 37.6297 49.72 37.2397 49.47 36.9897C49.22 36.7397 48.83 36.7397 48.58 36.9897Z",
    fill: "#CE0000"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M48.0899 34.49H45.3199C44.9699 34.47 44.6899 34.76 44.6899 35.11C44.6899 35.46 44.9699 35.74 45.3199 35.74H48.0899C48.4399 35.76 48.7199 35.47 48.7199 35.12C48.7199 34.94 48.6499 34.79 48.5299 34.67C48.4099 34.55 48.2599 34.49 48.0899 34.48V34.49Z",
    fill: "#CE0000"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M46.6599 30.3999C46.4099 30.6499 46.4099 31.0399 46.6599 31.2899L48.6099 33.2599C48.8599 33.5099 49.2499 33.5099 49.4999 33.2599C49.7499 33.0099 49.7499 32.6199 49.4999 32.3699L47.5499 30.3999C47.2999 30.1499 46.9099 30.1499 46.6599 30.3999Z",
    fill: "#CE0000"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "M48.62 62.3197C50.67 60.6497 53.09 59.7097 55.54 59.4897L49.57 66.6197C49.06 66.4997 48.59 66.2197 48.25 65.7597C47.39 64.6997 47.55 63.1697 48.62 62.3197Z",
    fill: "#2560E0"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "M62.7 50.9499L59.13 55.2099C58.97 55.1799 58.81 55.1499 58.65 55.1299C54.01 54.6299 49.47 55.9999 45.88 58.9399C45.37 59.3499 44.71 59.5199 44.08 59.4499C43.45 59.3899 42.87 59.0899 42.42 58.5699C41.57 57.4699 41.73 55.9799 42.79 55.0899C47.41 51.3599 53.22 49.6499 59.15 50.2799C60.37 50.3999 61.55 50.6299 62.7 50.9499Z",
    fill: "#2560E0"
  })));
};
/* harmony default export */ var img_no_connection = (SvgImgNoConnection);
;// CONCATENATED MODULE: ./public/images/errors/img-maintenance.svg
var img_maintenance_path, img_maintenance_path2, img_maintenance_path3, img_maintenance_path4, img_maintenance_path5, img_maintenance_path6, img_maintenance_path7, img_maintenance_path8, img_maintenance_path9, img_maintenance_path10, img_maintenance_path11, img_maintenance_path12, img_maintenance_path13, img_maintenance_path14, img_maintenance_path15, img_maintenance_path16;
function img_maintenance_extends() { img_maintenance_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return img_maintenance_extends.apply(this, arguments); }

var SvgImgMaintenance = function SvgImgMaintenance(props) {
  return /*#__PURE__*/react.createElement("svg", img_maintenance_extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), img_maintenance_path || (img_maintenance_path = /*#__PURE__*/react.createElement("path", {
    d: "M115 60C115 73.26 110.31 85.42 102.5 94.92C100.76 97.03 98.87 99.01 96.84 100.83C94.71 102.76 92.42 104.53 90 106.1C81.37 111.73 71.07 115 60 115C48.93 115 39.61 112.03 31.25 106.9C28.64 105.29 26.18 103.48 23.89 101.49C23.64 101.27 23.39 101.06 23.15 100.83C21.59 99.43 20.12 97.94 18.75 96.37C10.19 86.68 5 73.95 5 60C5 29.62 29.62 5 60 5C90.38 5 115 29.62 115 60Z",
    fill: "#EAEAEA"
  })), img_maintenance_path2 || (img_maintenance_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M62.5105 24.6699L60.2105 25.7099C60.2105 25.7099 59.3205 26.5499 58.0305 28.0499L57.8905 27.8699C57.5105 27.4099 57.5605 26.7499 57.9705 26.3299L60.1705 24.1299C60.5905 23.7099 61.2505 23.6699 61.7105 24.0399L62.5005 24.6799L62.5105 24.6699Z",
    fill: "#E6A703"
  })), img_maintenance_path3 || (img_maintenance_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M60.9704 25.3599L59.8404 24.4699L60.1804 24.1299C60.6004 23.7099 61.2604 23.6699 61.7204 24.0399L62.5104 24.6799L65.5304 27.0799C65.0704 27.3399 64.6104 27.6199 64.1804 27.9299L60.9704 25.3799V25.3599ZM85.0004 26.1199C83.6804 25.5399 82.2904 25.1099 80.8504 24.8499L80.1404 18.6499C80.0704 18.0699 79.5804 17.6299 78.9904 17.6299H76.5704C77.1604 17.6299 77.6504 18.0799 77.7104 18.6499L78.4204 24.8499C80.5604 25.2399 82.5604 25.9799 84.3804 26.9999C84.8904 27.2799 85.3604 27.5899 85.8304 27.9099L86.8904 27.0599C86.2904 26.7099 85.6704 26.3899 85.0204 26.1199H85.0004ZM64.1804 59.2199L60.7704 61.9299L60.4204 61.5799L58.5304 63.3399C58.5304 63.3399 60.2504 63.6899 61.3104 63.3099C61.3304 63.3099 61.3404 63.3099 61.3604 63.2899C61.4504 63.2599 61.5204 63.2099 61.6004 63.1599C61.6404 63.1399 61.6804 63.1299 61.7104 63.0999L61.8304 62.9999L65.5204 60.0599C65.0504 59.7999 64.6104 59.5199 64.1704 59.2099L64.1804 59.2199ZM76.2204 32.6999C75.8204 32.6499 75.4104 32.6299 75.0004 32.6299C68.9604 32.6299 64.0704 37.5299 64.0704 43.5599C64.0704 48.2799 67.0504 52.2899 71.2404 53.8299C71.5504 53.9399 71.8804 54.0399 72.2104 54.1199C73.1004 54.3599 74.0504 54.4799 75.0104 54.4799C75.4104 54.4799 75.8104 54.4599 76.2004 54.4099C75.0704 54.2799 73.9904 53.9699 72.9904 53.5399C72.6304 53.3799 72.2804 53.1999 71.9404 52.9999C68.6804 51.1099 66.5004 47.5699 66.5004 43.5499C66.5004 37.9199 70.7604 33.2799 76.2304 32.6899L76.2204 32.6999ZM99.9104 40.8599H99.8904L93.7104 40.1399C93.2204 37.4299 92.1604 34.9299 90.6504 32.7499L94.5304 27.8699C94.8904 27.4099 94.8504 26.7499 94.4404 26.3299L92.2404 24.1299C91.8204 23.7099 91.1604 23.6699 90.7004 24.0399L89.8704 24.6599C88.7304 27.3699 86.2204 31.8999 83.4604 36.6399C85.0004 38.5199 85.9304 40.9499 85.9304 43.5699C85.9304 49.6099 81.0304 54.4999 75.0004 54.4999C74.0304 54.4999 73.0904 54.3699 72.2004 54.1399C71.8704 54.0599 71.5404 53.9499 71.2304 53.8499C69.4904 55.9099 67.5904 57.9899 65.5504 60.0899C67.3904 61.1499 69.4204 61.8999 71.5804 62.2899L72.2904 68.4899C72.3604 69.0699 72.8504 69.5099 73.4404 69.5099H76.5604C77.1604 69.5099 77.6504 69.0599 77.7104 68.4899L78.4204 62.2899C81.1404 61.7999 83.6504 60.7399 85.8204 59.2299L90.0704 62.6099L90.7104 63.1199C91.1704 63.4799 91.8304 63.4399 92.2504 63.0299L94.4504 60.8299C94.8704 60.4099 94.9104 59.7499 94.5404 59.2899L93.4804 57.9599L90.6604 54.4099C92.1704 52.2299 93.2304 49.7299 93.7204 47.0099L98.5304 46.4599L99.9204 46.3099C100.5 46.2499 100.94 45.7599 100.94 45.1699V42.0399C100.94 41.4499 100.49 40.9599 99.9204 40.8999L99.9104 40.8599Z",
    fill: "#CF7E00"
  })), img_maintenance_path4 || (img_maintenance_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M60.5004 67.2498V69.8498C60.5004 70.3298 60.1404 70.7398 59.6404 70.7998L54.5004 71.3898C54.1004 73.5598 53.2504 75.6498 51.9504 77.5298L55.1704 81.5898C55.4804 81.9698 55.4504 82.5198 55.1004 82.8698L53.2604 84.7098C52.9204 85.0498 52.3704 85.0898 51.9804 84.7798L47.9304 81.5598C46.0504 82.8498 43.9504 83.7098 41.7704 84.0998L41.1804 89.2598C41.1304 89.7398 40.7204 90.1098 40.2304 90.1098H37.6404C37.5104 90.1098 37.3804 90.0798 37.2704 90.0298C36.3804 89.6998 35.5004 88.3498 35.5004 88.3498L36.5804 88.3898L36.0904 84.0998C35.3604 83.9698 34.6304 83.7798 33.9104 83.5398C43.7204 78.4098 49.6904 71.2498 58.7804 66.4098L58.7404 65.1198C58.7404 65.1198 60.0704 65.9898 60.4104 66.8798C60.4604 66.9998 60.5004 67.1198 60.5004 67.2598V67.2498ZM93.4804 57.9398C92.4904 59.5498 91.3604 61.1298 90.0704 62.5998L90.7104 63.1098C91.1704 63.4698 91.8304 63.4298 92.2504 63.0198L94.4504 60.8198C94.8704 60.3998 94.9104 59.7398 94.5404 59.2798L93.4804 57.9498V57.9398ZM71.2404 53.8398C71.5504 53.9498 71.8804 54.0498 72.2104 54.1298C73.1004 54.3698 74.0504 54.4898 75.0104 54.4898C75.4104 54.4898 75.8104 54.4698 76.2004 54.4198C75.0704 54.2898 73.9904 53.9798 72.9904 53.5498C72.6304 53.3898 71.5904 54.0298 71.2504 53.8298L71.2404 53.8398ZM85.8204 59.2198L86.8904 60.0698C85.0504 61.1298 83.0204 61.8798 80.8504 62.2798L80.1404 68.4798C80.0704 69.0598 79.5804 69.4998 78.9904 69.4998H76.5504C77.1504 69.4998 77.6404 69.0498 77.7004 68.4798L78.4104 62.2798C81.1304 61.7898 83.6404 60.7298 85.8104 59.2198H85.8204ZM93.7204 46.9798L98.5304 46.4298C98.5104 46.5198 98.4804 46.6298 98.4504 46.7198L96.1404 46.9798C95.6504 49.6998 94.5904 52.2098 93.0804 54.3798L94.5004 56.1798C94.1704 56.7698 93.8404 57.3598 93.4804 57.9298L90.6604 54.3798C92.1704 52.1998 93.2304 49.6998 93.7204 46.9798ZM102.35 40.8598L100.43 40.6798C100.23 40.6898 100.07 40.7498 99.9204 40.8598L93.7204 40.1398C93.2304 37.4298 92.1704 34.9298 90.6604 32.7498L94.5404 27.8698C94.9004 27.4098 94.8604 26.7498 94.4504 26.3298L92.2504 24.1298C92.0304 23.9098 91.7204 23.7898 91.4304 23.7898C91.7804 23.7198 93.3604 23.4598 94.2904 23.8698C94.4304 23.9298 94.5604 24.0098 94.6804 24.1298L96.8804 26.3298C97.3004 26.7498 97.3404 27.4098 96.9704 27.8698L93.0904 32.7498C94.6004 34.9298 95.6604 37.4298 96.1504 40.1398L99.9504 40.5798L102.35 40.8598ZM100.95 41.9998V45.1298C100.95 45.7198 100.5 46.2098 99.9304 46.2698L98.5404 46.4198C99.2204 44.1698 99.6504 42.2398 99.9104 40.8498H99.9304C100.51 40.9098 100.95 41.3998 100.95 41.9898V41.9998Z",
    fill: "#7C3B00"
  })), img_maintenance_path5 || (img_maintenance_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M85.5705 95.3098H31.3305C30.0326 95.3098 28.9805 96.362 28.9805 97.6598V97.6698C28.9805 98.9677 30.0326 100.02 31.3305 100.02H85.5705C86.8683 100.02 87.9205 98.9677 87.9205 97.6698V97.6598C87.9205 96.362 86.8683 95.3098 85.5705 95.3098Z",
    fill: "#0E43B8"
  })), img_maintenance_path6 || (img_maintenance_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M67.0605 95.3098H31.3305C30.0326 95.3098 28.9805 96.362 28.9805 97.6598V97.6698C28.9805 98.9677 30.0326 100.02 31.3305 100.02H67.0605C68.3583 100.02 69.4105 98.9677 69.4105 97.6698V97.6598C69.4105 96.362 68.3583 95.3098 67.0605 95.3098Z",
    fill: "#6BB4EE"
  })), img_maintenance_path7 || (img_maintenance_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M43.8704 41.1899L38.5104 41.1599C37.8404 41.1599 37.2904 41.6999 37.2804 42.3699C37.2804 43.0499 37.8204 43.5899 38.4904 43.5999L43.8504 43.6299C44.5204 43.6299 45.0704 43.0899 45.0804 42.4199C45.0804 41.7399 44.5404 41.1999 43.8704 41.1899Z",
    fill: "#0B5FEF"
  })), img_maintenance_path8 || (img_maintenance_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M46.6104 37.0997L42.8404 33.2897C42.3704 32.8097 41.5904 32.8097 41.1104 33.2897C40.6304 33.7597 40.6304 34.5397 41.1104 35.0197L44.8804 38.8297C45.3504 39.3097 46.1304 39.3097 46.6104 38.8297C46.8504 38.5897 46.9704 38.2797 46.9704 37.9597C46.9704 37.6397 46.8504 37.3397 46.6204 37.0997H46.6104Z",
    fill: "#0B5FEF"
  })), img_maintenance_path9 || (img_maintenance_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M50.2504 29.5498C49.5804 29.5498 49.0304 30.0898 49.0204 30.7598L48.9904 36.1198C48.9904 36.7998 49.5304 37.3398 50.2004 37.3498C50.8704 37.3498 51.4204 36.8098 51.4304 36.1398L51.4604 30.7798C51.4604 30.0998 50.9204 29.5598 50.2504 29.5498Z",
    fill: "#0B5FEF"
  })), img_maintenance_path10 || (img_maintenance_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M103.36 41.9999V45.1299C103.36 45.7199 102.91 46.2099 102.34 46.2699L98.4404 46.7199C98.4804 46.6299 98.5004 46.5199 98.5204 46.4299L99.9104 46.2799C100.49 46.2199 100.93 45.7299 100.93 45.1399V42.0099C100.93 41.4199 100.48 40.9299 99.9104 40.8699C100.05 40.7599 100.26 40.6599 100.46 40.6499L102.34 40.8699C102.92 40.9299 103.36 41.4199 103.36 42.0099V41.9999Z",
    fill: "#020A11"
  })), img_maintenance_path11 || (img_maintenance_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M96.8604 60.8099L94.6604 63.0099C94.5404 63.1199 94.4104 63.1999 94.2804 63.2599C93.3404 63.6999 91.7304 63.4099 91.4004 63.3499C91.7104 63.3499 92.0004 63.2299 92.2404 63.0099L94.4404 60.8099C94.8604 60.3899 94.9004 59.7299 94.5304 59.2699L93.4704 57.9399C93.8304 57.3599 94.1604 56.7699 94.4904 56.1899L96.9504 59.2699C97.3104 59.7299 97.2804 60.3899 96.8604 60.8099Z",
    fill: "#020A11"
  })), img_maintenance_path12 || (img_maintenance_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M90.7005 24.0298L89.8605 24.6898C89.8605 24.6898 89.8705 24.6698 89.8705 24.6498L90.6905 24.0298H90.7005Z",
    fill: "#CF7E00"
  })), img_maintenance_path13 || (img_maintenance_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M34.7104 83.1199L34.7904 83.8099C34.5004 83.7299 34.2004 83.6499 33.9104 83.5399C32.5204 83.0799 31.1904 82.4199 29.9404 81.5599L25.8804 84.7799C25.5004 85.0899 24.9504 85.0499 24.6004 84.7099L23.1804 83.2699C23.5304 83.6199 24.0904 83.6499 24.4604 83.3499L28.5204 80.1099C30.4004 81.4199 32.5004 82.2599 34.6604 82.6599L34.7104 83.0999V83.1199ZM31.0804 60.6999C27.5304 64.2499 27.5304 70.0099 31.0804 73.5499C31.3204 73.7899 31.5604 74.0099 31.8204 74.2099C28.9604 70.6399 29.2004 65.4299 32.5004 62.1199C35.8104 58.8099 41.0304 58.5899 44.6004 61.4499C44.3904 61.1899 44.1604 60.9299 43.9304 60.6999C40.3804 57.1599 34.6204 57.1599 31.0804 60.6999ZM55.0904 54.2299L53.6704 52.8099C54.0104 53.1499 54.0504 53.6999 53.7404 54.0899L50.5204 58.1399C51.8304 60.0199 52.6704 62.1299 53.0604 64.2999L54.1904 64.4299C53.7404 62.7199 52.9904 61.0799 51.9404 59.5699L55.1604 55.5199C55.4704 55.1299 55.4404 54.5799 55.0904 54.2399V54.2299ZM39.7504 46.4299L39.8104 46.9899L40.3404 51.5699C40.7804 51.6499 41.2104 51.7499 41.6304 51.8799L41.1904 47.9799C41.1904 47.8299 41.1404 47.6699 41.0704 47.5099C40.7404 46.7799 39.7904 46.0799 39.5104 45.8799C39.5904 45.9699 39.6504 46.0799 39.7004 46.1999C39.7204 46.2699 39.7404 46.3399 39.7504 46.4199V46.4299ZM21.9404 69.9799L18.3504 69.5799L17.3604 69.4599L16.7804 69.3899C16.5604 69.3699 16.3404 69.2499 16.2004 69.1099C16.3104 69.2599 17.0704 70.3699 17.8704 70.7099C17.9204 70.7299 17.9604 70.7599 18.0104 70.7699C18.1304 70.8099 18.2304 70.8299 18.3404 70.8299L22.2204 71.2799C22.1004 70.8399 22.0104 70.4199 21.9304 69.9899L21.9404 69.9799ZM50.5004 76.1199C51.4904 74.6999 52.2204 73.1399 52.6804 71.5299C47.3804 75.6299 41.4204 79.5599 34.7004 83.1199L35.2404 87.8299C35.3004 88.3199 35.7104 88.6899 36.2104 88.6899H38.8004C39.2904 88.6899 39.7104 88.3299 39.7504 87.8299L40.3404 82.6899C42.5104 82.2899 44.6104 81.4399 46.5004 80.1399L50.5504 83.3799C50.9404 83.6699 51.4904 83.6499 51.8304 83.2999L53.6704 81.4799C54.0104 81.1299 54.0504 80.5699 53.7404 80.1999L50.5204 76.1399L50.5004 76.1199ZM54.9104 69.7599L58.1904 69.3799C58.6704 69.3199 59.0504 68.9099 59.0504 68.4099V66.2399C57.7204 67.4199 56.3404 68.5799 54.9104 69.7499V69.7599Z",
    fill: "#CF7E00"
  })), img_maintenance_path14 || (img_maintenance_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M89.2404 25.1899L85.8204 27.9199C85.3504 27.5999 84.8804 27.2999 84.3704 27.0099C82.5604 25.9899 80.5604 25.2399 78.4104 24.8599L77.7004 18.6599C77.6404 18.0799 77.1504 17.6399 76.5604 17.6399H73.4304C72.8404 17.6399 72.3504 18.0899 72.2904 18.6599L71.5704 24.8599C68.8604 25.3499 66.3604 26.4099 64.1804 27.9199L60.9704 25.3699L59.3004 24.0399C58.8404 23.6799 58.1804 23.7099 57.7604 24.1299L55.5604 26.3299C55.1404 26.7499 55.1004 27.4099 55.4704 27.8699L56.8104 29.5499L59.3504 32.7499C57.8404 34.9299 56.7804 37.4299 56.2904 40.1399L50.5804 40.7899L50.0904 40.8499C49.5104 40.9199 49.0704 41.4099 49.0704 41.9999V45.1199C49.0704 45.3799 49.1504 45.6299 49.3104 45.8099C49.4904 46.0699 49.7704 46.2299 50.1004 46.2699L56.3004 46.9799C56.7904 49.6999 57.8504 52.2099 59.3604 54.3799L55.4804 59.2599C55.1204 59.7199 55.1504 60.3799 55.5704 60.7999L57.7704 62.9999C58.1904 63.4199 58.8504 63.4599 59.3104 63.0899L64.1904 59.2099C64.6404 59.5199 65.0804 59.7999 65.5604 60.0699C67.6104 57.9799 69.5004 55.8899 71.2404 53.8299C67.0504 52.2899 64.0704 48.2699 64.0704 43.5599C64.0704 37.5199 68.9704 32.6299 75.0004 32.6299C78.3104 32.6299 81.2804 34.0999 83.3004 36.4299C83.3604 36.4899 83.4104 36.5599 83.4604 36.6299C86.2104 31.9099 88.7104 27.3899 89.8604 24.6799L89.2404 25.1699V25.1899ZM58.2204 64.8799L53.0604 64.2899C52.6704 62.1199 51.8204 60.0199 50.5204 58.1299L53.7404 54.0799C54.0504 53.6899 54.0104 53.1399 53.6704 52.7999L51.8304 50.9599C51.4904 50.6099 50.9404 50.5799 50.5504 50.8899L46.5004 54.1099C44.6204 52.7999 42.5104 51.9599 40.3404 51.5599L39.7504 46.4199C39.7404 46.3399 39.7304 46.2699 39.7004 46.1999C39.5704 45.8199 39.2104 45.5599 38.7904 45.5599H36.2004C35.7104 45.5599 35.2904 45.9199 35.2304 46.4199L35.1504 47.1899L34.6404 51.5699C32.4704 51.9699 30.3804 52.8199 28.5004 54.1199L25.8904 52.0499L24.4404 50.8999C24.0604 50.5899 23.5104 50.6199 23.1604 50.9699L21.3204 52.8099C20.9804 53.1499 20.9404 53.6999 21.2504 54.0899L22.0904 55.1399L24.4804 58.1399C23.1904 60.0199 22.3304 62.1299 21.9404 64.2999L16.7904 64.8899C16.3104 64.9399 15.9404 65.3499 15.9404 65.8399V68.4299C15.9404 68.9199 16.3004 69.3399 16.7904 69.3999L21.9404 69.9899C22.3304 72.1599 23.1904 74.2499 24.4804 76.1299L21.2604 80.1899C20.9504 80.5699 20.9904 81.1199 21.3304 81.4699L23.1704 83.2899C23.5204 83.6399 24.0804 83.6699 24.4504 83.3699L28.5104 80.1299C30.3904 81.4399 32.4904 82.2799 34.6504 82.6799L34.7004 83.1199C41.4204 79.5499 47.3904 75.6199 52.6804 71.5299C52.8304 71.0099 52.9504 70.4899 53.0404 69.9799L54.9104 69.7699C56.3504 68.5999 57.7204 67.4399 59.0504 66.2599V65.8399C59.0504 65.3499 58.6704 64.9299 58.1904 64.8899L58.2204 64.8799ZM43.9404 73.5499C40.3904 77.0999 34.6304 77.0999 31.0904 73.5499C27.5404 70.0099 27.5404 64.2499 31.0904 60.6999C34.6304 57.1599 40.3904 57.1599 43.9404 60.6999C47.4804 64.2499 47.4804 70.0099 43.9404 73.5499ZM62.4004 24.5699L60.9604 25.3599L59.2904 24.0299C58.9704 23.7699 58.5504 23.7099 58.1804 23.8499C58.6004 23.6499 60.4404 22.6099 62.3904 24.5699H62.4004Z",
    fill: "#E6A703"
  })), img_maintenance_path15 || (img_maintenance_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M50.0804 40.85L50.5704 40.79C50.0204 42.38 49.5704 44.06 49.2904 45.82C49.1404 45.63 49.0504 45.38 49.0504 45.13V42.01C49.0504 41.42 49.5004 40.93 50.0704 40.86L50.0804 40.85ZM59.3004 24.03C58.8404 23.67 58.1804 23.7 57.7604 24.12L55.5604 26.32C55.1404 26.74 55.1004 27.4 55.4704 27.86L56.8104 29.54C58.7304 27.09 60.3204 25.81 60.3204 25.81L60.9804 25.35L59.3104 24.02L59.3004 24.03ZM23.1704 50.96L21.3304 52.8C20.9904 53.14 20.9504 53.69 21.2604 54.08L22.1004 55.13C23.4104 53.95 24.6804 52.93 25.9004 52.05L24.4504 50.9C24.0704 50.59 23.5204 50.62 23.1704 50.97V50.96ZM38.8004 45.56H36.2104C35.7204 45.56 35.3004 45.92 35.2404 46.42L35.1604 47.19C37.1004 46.55 38.6604 46.3 39.7004 46.2C39.5704 45.82 39.2104 45.56 38.7904 45.56H38.8004Z",
    fill: "#F3C922"
  })), img_maintenance_path16 || (img_maintenance_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M99.9102 40.8604H99.8902C99.6301 42.2504 99.2102 44.1804 98.5202 46.4304L99.9102 46.2804C100.49 46.2204 100.94 45.7204 100.94 45.1404V42.0004C100.94 41.4204 100.49 40.9204 99.9102 40.8604ZM99.9302 40.5804L96.1302 40.1404C95.6402 37.4404 94.5802 34.9304 93.0702 32.7504L96.9602 27.8704C97.3202 27.4104 97.2902 26.7504 96.8602 26.3304L94.6602 24.1304C94.5402 24.0104 94.4202 23.9304 94.2702 23.8704C93.3402 23.4604 91.7702 23.7104 91.4102 23.7904C91.7102 23.7904 92.0102 23.9004 92.2402 24.1304L94.4402 26.3304C94.8502 26.7504 94.9002 27.4104 94.5302 27.8704L90.6502 32.7504C92.1602 34.9304 93.2102 37.4404 93.7102 40.1404L99.8902 40.8604H99.9102C100.05 40.7604 100.22 40.7004 100.42 40.6904L102.34 40.8604L99.9302 40.5804ZM93.7102 46.9804C93.2102 49.7004 92.1602 52.2104 90.6502 54.3904L93.4702 57.9404C93.8402 57.3604 94.1702 56.7804 94.5002 56.1904L93.0702 54.3904C94.5802 52.2104 95.6402 49.7004 96.1302 46.9804L98.4402 46.7204C98.4802 46.6304 98.5002 46.5204 98.5202 46.4304L93.7102 46.9804ZM85.8102 59.2204C83.6302 60.7304 81.1302 61.7904 78.4102 62.2804L77.7002 68.4904C77.6402 69.0604 77.1502 69.5104 76.5502 69.5104H78.9902C79.5702 69.5104 80.0702 69.0604 80.1402 68.4904L80.8402 62.2804C83.0102 61.8804 85.0502 61.1304 86.8802 60.0704L85.8102 59.2204ZM72.9702 53.5604C72.6402 53.4104 71.7202 53.9504 71.3202 53.8704C71.6002 53.9704 71.8902 54.0704 72.1902 54.1404C73.0902 54.3704 74.0302 54.5004 75.0002 54.5004C75.4002 54.5004 75.8002 54.4804 76.1802 54.4304C75.0502 54.3004 73.9702 54.0004 72.9702 53.5604ZM94.5302 59.2704L93.4702 57.9404C92.4802 59.5504 91.3602 61.1304 90.0602 62.6004L90.7002 63.1104C91.1602 63.4704 91.8102 63.4204 92.2402 63.0104L94.4402 60.8104C94.8602 60.3904 94.9002 59.7304 94.5302 59.2704ZM54.9302 69.7604L58.2102 69.3804C58.6902 69.3204 59.0702 68.9104 59.0702 68.4204V66.2504C57.7402 67.4304 56.3602 68.5904 54.9302 69.7604ZM34.7102 83.1104C34.4502 83.2604 34.1802 83.4004 33.9102 83.5404C34.1302 83.6204 34.3602 83.6904 34.5802 83.7404C34.6502 83.7704 34.7202 83.7904 34.7902 83.8004L34.7102 83.1204V83.1104Z",
    fill: "#7C3B00"
  })));
};
/* harmony default export */ var img_maintenance = (SvgImgMaintenance);
;// CONCATENATED MODULE: ./components/ErrorBoundary/index.tsx
















function CustomErrorBoundary(param) {
    var resetKeys = param.resetKeys, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
        resetKeys: resetKeys,
        FallbackComponent: CustomErrorFallback,
        children: children
    });
}
function CustomErrorFallback(param) {
    var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var router = (0,next_router.useRouter)();
    var ref = (0,auth/* useAuthProvider */.pL)(false), login = ref.login, status = ref.status;
    react.useEffect(function() {
        if (status === "success") {
            resetErrorBoundary();
            window.location.reload();
        }
    }, [
        status,
        resetErrorBoundary
    ]);
    if ((0,_instanceof/* default */.Z)(error, customError/* CustomError */.sH) === false) {
        throw error;
    }
    // @ts-expect-error error is not an Error object
    var title = error.title, description = error.description;
    var session = (0,auth/* useAuth */.aC)().session;
    var basePath = (0,utils_router/* getRouterBasePath */.L)(router.asPath);
    var ref1;
    var pathName = (ref1 = routes/* ROUTE_PATH_NAMES */.N === null || routes/* ROUTE_PATH_NAMES */.N === void 0 ? void 0 : routes/* ROUTE_PATH_NAMES */.N[basePath]) !== null && ref1 !== void 0 ? ref1 : "Beranda";
    var fallbackBasePath = Boolean(session) ? "/home" : "/";
    var notFoundErrorBasePath = Object.keys(routes/* ROUTE_PATH_NAMES */.N).includes(basePath) ? basePath : fallbackBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* LayoutWithHeader */.d, {
        title: "",
        onClickBack: function() {
            return dist_history/* backToApp */.NU(function() {
                resetErrorBoundary();
                router.back();
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState/* EmptyStateWithIllustration */.fK, {
                title: title,
                description: description,
                children: [
                    (0,_instanceof/* default */.Z)(error, customError/* SessionError */.zM) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateImage */.ox, {
                                "data-testid": "error-boundary-image",
                                imageSrc: "/images/errors/img-session-expired.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-primary",
                                color: "black",
                                onClick: function() {
                                    return dist_history/* backToApp */.NU(login);
                                },
                                children: androidHandler.enabled ? "Kembali ke Beranda" : "Login"
                            })
                        ]
                    }),
                    (0,_instanceof/* default */.Z)(error, customError/* ForbiddenError */.lY) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateImage */.ox, {
                                "data-testid": "error-boundary-image",
                                imageSrc: "/images/errors/img-no-access.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-primary",
                                color: "black",
                                onClick: function() {
                                    return dist_history/* backToApp */.NU(login);
                                },
                                children: androidHandler.enabled ? "Kembali ke Beranda" : "Coba Masuk Lagi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-secondary",
                                color: "white",
                                onClick: function() {
                                    return window.location.href = "https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/10078077553817-Tampilan-Error-di-Platform-Merdeka-Mengajar-Versi-Web";
                                },
                                children: "Hubungi Bantuan"
                            })
                        ]
                    }),
                    (0,_instanceof/* default */.Z)(error, customError/* NotFoundError */.dR) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateImage */.ox, {
                                "data-testid": "error-boundary-image",
                                imageSrc: "/images/errors/img-not-found.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-primary",
                                color: "black",
                                onClick: function() {
                                    return dist_history/* backToApp */.NU(function() {
                                        return router.push("/".concat(notFoundErrorBasePath));
                                    });
                                },
                                children: [
                                    "Kembali ke ",
                                    pathName
                                ]
                            })
                        ]
                    }),
                    ((0,_instanceof/* default */.Z)(error, customError/* InternalServerError */.Hl) || (0,_instanceof/* default */.Z)(error, customError/* ServiceUnavailableError */.TC)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(img_maintenance, {
                                "data-testid": "error-boundary-image",
                                as: "EmptyStateImageSvg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-primary",
                                color: "black",
                                onClick: function() {
                                    return router.reload();
                                },
                                children: "Perbarui Halaman"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-secondary",
                                color: "white",
                                onClick: function() {
                                    return dist_history/* backToApp */.NU(function() {
                                        return router.back();
                                    });
                                },
                                children: "Kembali"
                            })
                        ]
                    }),
                    (0,_instanceof/* default */.Z)(error, customError/* NetworkError */.F7) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(img_no_connection, {
                                "data-testid": "error-boundary-image",
                                as: "EmptyStateImageSvg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                                "data-testid": "error-boundary-action-primary",
                                color: "black",
                                onClick: function() {
                                    return router.reload();
                                },
                                children: "Perbarui Halaman"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 80079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@wartek-id/spinner/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(35884);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./node_modules/react-keyed-flatten-children/index.js
var react_keyed_flatten_children = __webpack_require__(23262);
;// CONCATENATED MODULE: ./components/Header/HeaderComposition.tsx







function HeaderLeftAction(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute left-3 leading-3 z-10",
        children: children
    });
}
function HeaderRightAction(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute right-3 leading-3 z-10",
        children: children
    });
}
function HeaderTitle(param) {
    var children = param.children;
    return children;
}
function Header(_param) {
    var _backgroundColor = _param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "default" : _backgroundColor, _hasBorder = _param.hasBorder, hasBorder = _hasBorder === void 0 ? true : _hasBorder, _hasOrnament = _param.hasOrnament, hasOrnament = _hasOrnament === void 0 ? false : _hasOrnament, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "backgroundColor",
        "hasBorder",
        "hasOrnament",
        "className",
        "children"
    ]);
    var baseClasses = "flex justify-center items-center h-14 px-3 fixed w-full max-w-xl z-10 top-0";
    var variants = {
        default: "bg-white text-black",
        primary: "bg-primary text-white",
        secondary: "bg-secondary text-white",
        transparent: "bg-transparent text-black",
        darkBlue: "bg-[#006ED3] text-white",
        milGray: "bg-gray-5 text-type-basic",
        milBlue: "bg-expressive-dark-blue text-white"
    };
    var classes = (0,clsx_m/* default */.Z)(baseClasses, variants[backgroundColor], hasBorder && "border-b border-gray-300", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: [
            react.Children.map((0,react_keyed_flatten_children/* default */.Z)(children), function(child) {
                if (typeof child === "object") {
                    if (child.type === HeaderLeftAction) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLeftAction, (0,_object_spread/* default */.Z)({}, child.props));
                    }
                    if (child.type === HeaderRightAction) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRightAction, (0,_object_spread/* default */.Z)({}, child.props));
                    }
                    if (child.type === HeaderTitle) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, (0,_object_spread/* default */.Z)({}, child.props));
                    }
                }
                return null;
            }),
            hasOrnament && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute left-0 top-0 z-0",
                        src: "/images/layout/header-ornament-left.svg",
                        width: 144,
                        height: 56,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute right-0 bottom-0 z-0",
                        src: "/images/layout/header-ornament-right-alt.svg",
                        width: 196,
                        height: 32,
                        alt: ""
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./components/Header/Header.tsx











var Header_Header = function(_param) {
    var title = _param.title, _titlePosition = _param.titlePosition, titlePosition = _titlePosition === void 0 ? "center" : _titlePosition, subtitle = _param.subtitle, backHref = _param.backHref, _hasBackButton = _param.hasBackButton, hasBackButton = _hasBackButton === void 0 ? false : _hasBackButton, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _replace = _param.replace, replace = _replace === void 0 ? true : _replace, _iconLeftSrc = _param.iconLeftSrc, iconLeftSrc = _iconLeftSrc === void 0 ? "/icon/arrow-left.svg" : _iconLeftSrc, iconRightSrc = _param.iconRightSrc, leftChild = _param.leftChild, rightChild = _param.rightChild, onLeftActionClick = _param.onLeftActionClick, _onRightActionClick = _param.onRightActionClick, onRightActionClick = _onRightActionClick === void 0 ? function() {} : _onRightActionClick, _bordered = _param.bordered, bordered = _bordered === void 0 ? true : _bordered, _hasOrnament = _param.hasOrnament, hasOrnament = _hasOrnament === void 0 ? false : _hasOrnament, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titlePosition",
        "subtitle",
        "backHref",
        "hasBackButton",
        "variant",
        "replace",
        "iconLeftSrc",
        "iconRightSrc",
        "leftChild",
        "rightChild",
        "onLeftActionClick",
        "onRightActionClick",
        "bordered",
        "hasOrnament"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hasBorder: bordered,
        hasOrnament: hasOrnament,
        backgroundColor: variant
    }, props), {
        children: [
            hasBackButton && (backHref && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLeftAction, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: backHref,
                    replace: replace,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: backHref,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: iconLeftSrc,
                            width: 24,
                            height: 24,
                            alt: "back button"
                        })
                    })
                })
            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLeftAction, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        if (typeof onLeftActionClick === "function") {
                            onLeftActionClick();
                        } else {
                            dist_history/* backToApp */.NU(router.back);
                        }
                    },
                    children: leftChild !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: leftChild
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: iconLeftSrc,
                        width: 24,
                        height: 24,
                        alt: "back button"
                    })
                })
            })),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(titlePosition === "center" && "flex flex-col items-center", titlePosition === "left" && "absolute left-[60px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-base font-semibold",
                            children: title
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-type-basic-secondary",
                            children: subtitle
                        })
                    ]
                })
            }),
            (iconRightSrc || rightChild) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRightAction, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onRightActionClick,
                    children: rightChild !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: rightChild
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: iconRightSrc,
                        width: 24,
                        height: 24,
                        alt: "share button"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var components_Header_Header = ((/* unused pure expression or super */ null && (Header_Header)));

;// CONCATENATED MODULE: ./components/Header/index.ts


// EXTERNAL MODULE: ./utils/hooks/context/useScreenSizeContext.tsx + 1 modules
var useScreenSizeContext = __webpack_require__(65260);
// EXTERNAL MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx + 1 modules
var useFeatureFlagContext = __webpack_require__(66578);
;// CONCATENATED MODULE: ./utils/hooks/useMaintenance.ts


var useMaintenancePelatihanMandiri = function() {
    var isServer = "object" === "undefined";
    var path = !isServer && ((router_default()) === null || (router_default()) === void 0 ? void 0 : (router_default()).pathname);
    var ref = (0,useFeatureFlagContext/* useFeatureFlagContext */.dG)(), getFeatureByKey = ref.getFeatureByKey, status = ref.status;
    var isLoading = status === "loading";
    var isPelatihanMandiriOnMaintenance = getFeatureByKey("enableMaintenancePelatihanMandiri") && path.includes("/pelatihan-mandiri");
    return {
        isOnMaintenance: isPelatihanMandiriOnMaintenance,
        isLoading: isLoading
    };
};

// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(54204);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/MaintenanceInfo.tsx



var MaintenanceInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full flex items-center justify-center px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://storage.googleapis.com/microlearning-public-production/web-assets/img-error-fixing.png",
                    height: 120,
                    width: 120,
                    alt: "maintenance",
                    className: "mb-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-semibold text-lg",
                    children: "Maaf, sedang ada gangguan"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm text-gray-60 mb-4",
                    children: "Tak perlu khawatir, tim kami sedang menanganinya. Mohon coba lagi nanti."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                    onClick: function() {
                        return window.location.reload();
                    },
                    className: "mt-2",
                    fullWidth: true,
                    color: "black",
                    children: "Coba lagi"
                })
            ]
        })
    });
};
/* harmony default export */ var components_MaintenanceInfo = (MaintenanceInfo);

;// CONCATENATED MODULE: ./components/Layout/Layout.tsx








var Layout = function(param) {
    var children = param.children, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? false : _hasHeader, _headerTitle = param.headerTitle, headerTitle = _headerTitle === void 0 ? "" : _headerTitle, _headerHasBackButton = param.headerHasBackButton, headerHasBackButton = _headerHasBackButton === void 0 ? false : _headerHasBackButton, className = param.className, PropHeader = param.header, _enableDesktopLayout = param.enableDesktopLayout, enableDesktopLayout = _enableDesktopLayout === void 0 ? false : _enableDesktopLayout;
    var Header = PropHeader !== null && PropHeader !== void 0 ? PropHeader : function() {
        return Header_Header({
            title: headerTitle,
            hasBackButton: headerHasBackButton
        });
    };
    var ref = (0,useScreenSizeContext/* useScreenSizeContext */.fl)(), isDesktopScreenSize = ref.isDesktop;
    var ref1 = useMaintenancePelatihanMandiri(), isOnMaintenance = ref1.isOnMaintenance, isLoading = ref1.isLoading;
    if (enableDesktopLayout && isDesktopScreenSize) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full",
            children: children
        });
    }
    var Content = function() {
        if (isLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spinner */.$, {})
            });
        }
        return isOnMaintenance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaintenanceInfo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("max-w-xl m-auto relative", hasHeader && "mt-14", className),
        style: {
            height: "calc(100vh - 3.5rem)"
        },
        children: [
            hasHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {})
        ]
    });
};
/* harmony default export */ var Layout_Layout = ((/* unused pure expression or super */ null && (Layout)));


/***/ }),

/***/ 8008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ LayoutWithHeader; }
});

// UNUSED EXPORTS: Layout

// EXTERNAL MODULE: ./components/Layout/Layout.tsx + 5 modules
var Layout = __webpack_require__(80079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./assets/icons/arrow-left.svg
var arrow_left = __webpack_require__(51667);
;// CONCATENATED MODULE: ./components/Layout/WithHeader.tsx







var LayoutWithHeader = function(_param) {
    var children = _param.children, title = _param.title, href = _param.href, onClickBack = _param.onClickBack, className = _param.className, _headerVariant = _param.headerVariant, headerVariant = _headerVariant === void 0 ? "basic" : _headerVariant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "title",
        "href",
        "onClickBack",
        "className",
        "headerVariant"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("max-w-xl m-auto relative", className),
        style: {
            minHeight: "calc(100vh - 3.5rem)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (0,clsx_m/* default */.Z)("flex justify-center items-center h-14 px-3 fixed w-full max-w-xl z-[1] top-0", {
                    "border-b border-gray-300 bg-white text-black": headerVariant === "basic"
                }, {
                    "text-white bg-login": headerVariant === "styled"
                })
            }, props), {
                children: [
                    href && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: href,
                            className: "absolute left-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                                    fill: "currentColor",
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Kembali"
                                })
                            ]
                        })
                    }),
                    onClickBack && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "absolute left-3",
                        onClick: onClickBack,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                                fill: "currentColor",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Kembali"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-base font-semibold",
                        children: title
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-14",
                children: children
            })
        ]
    });
};
/* harmony default export */ var WithHeader = ((/* unused pure expression or super */ null && (LayoutWithHeader)));

;// CONCATENATED MODULE: ./components/Layout/index.ts




/***/ }),

/***/ 13102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
/* unused harmony export api */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68430);



var _NEXT_PUBLIC_API_URL;
var baseUrl = (_NEXT_PUBLIC_API_URL = "https://api.belajar.id") !== null && _NEXT_PUBLIC_API_URL !== void 0 ? _NEXT_PUBLIC_API_URL : "https://guru.kemdikbud.go.id";
var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
var paramsSerializer = function(params) {
    return stringify(params !== null && params !== void 0 ? params : {}, {
        arrayFormat: "none"
    });
};
var api = function(opts) {
    return axios.create(_object_spread({
        baseURL: baseUrl,
        headers: headers,
        paramsSerializer: paramsSerializer
    }, opts));
};


/***/ }),

/***/ 32178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NS": function() { return /* binding */ GURU_TOKEN_GOOGLE_OAUTH_CONFIG; },
/* harmony export */   "dV": function() { return /* binding */ USER_ID_STORAGE_KEY; },
/* harmony export */   "fW": function() { return /* binding */ SATU_EVENT_CONFIG; },
/* harmony export */   "zy": function() { return /* binding */ APP_LOGIN_STORAGE_KEY; }
/* harmony export */ });
var APP_LOGIN_STORAGE_KEY = "app-login";
var USER_ID_STORAGE_KEY = "user-id";
var GURU_TOKEN_GOOGLE_OAUTH_CONFIG = {
    clientId: "1024117286948-n26r09fs1h3607ttqru7s2ue4eltkqn8.apps.googleusercontent.com",
    responseType: "id_token permission",
    cookiePolicy: "single_host_origin",
    prompt: "consent",
    scope: "email profile openid"
};
var SATU_EVENT_CONFIG = {
    enabled: "true" === "true",
    debugEnabled: "false" === "true",
    url: "https://events.belajar.id/event-tracker/api/v1/events",
    username: "guru-frontend",
    password: "06bB5hT6w7cLm#87Mj78YS9Ji",
    mengajar_username: "guru-mengajar",
    mengajar_password: "ICjN1vUTVpnSsLaplt0r"
};


/***/ }),

/***/ 90294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UNPROTECTED_ROUTES; },
/* harmony export */   "N": function() { return /* binding */ ROUTE_PATH_NAMES; }
/* harmony export */ });
var UNPROTECTED_ROUTES = [
    "/login",
    "/logout",
    "/belajar-fe/healthz", 
];
var ROUTE_PATH_NAMES = {
    home: "Beranda"
};


/***/ }),

/***/ 87209:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; },
  "LinkedErrors": function() { return LinkedErrors; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "HttpContext": function() { return HttpContext; },
  "LinkedErrors": function() { return linkederrors_LinkedErrors; },
  "TryCatch": function() { return TryCatch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(32263);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/sdkMetadata.js

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "npm";
    var metadata = options._metadata || {};
    if (!metadata.sdk) {
        metadata.sdk = {
            name: "sentry.javascript.".concat(name),
            packages: names.map(function(name) {
                return {
                    name: "".concat(source, ":@sentry/").concat(name),
                    version: version/* SDK_VERSION */.J
                };
            }),
            version: version/* SDK_VERSION */.J
        };
    }
    options._metadata = metadata;
}
 //# sourceMappingURL=sdkMetadata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(32407);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js

// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function hasTracingEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) {
        return false;
    }
    var client = (0,esm_exports/* getClient */.s3)();
    var options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}
 //# sourceMappingURL=hasTracingEnabled.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(38434);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(78774);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(37745);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(12706);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(68813);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js







var installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
            return;
        }
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map(function(k) {
        return integrationsByName[k];
    });
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) {
        integrations = (0,src_to_consumable_array/* default */.Z)(defaultIntegrations).concat((0,src_to_consumable_array/* default */.Z)(userIntegrations));
    } else if (typeof userIntegrations === "function") {
        integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
    } else {
        integrations = defaultIntegrations;
    }
    var finalIntegrations = filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    var debugIndex = findIndex(finalIntegrations, function(integration) {
        return integration.name === "Debug";
    });
    if (debugIndex !== -1) {
        var ref = (0,src_sliced_to_array/* default */.Z)(finalIntegrations.splice(debugIndex, 1), 1), debugInstance = ref[0];
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) {
            setupIntegration(client, integration, integrationIndex);
        }
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            // guard against empty provided integrations
            if (integration && integration.afterAllSetup) {
                integration.afterAllSetup(client);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("Integration skipped because it was already installed: ".concat(integration.name));
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (installedIntegrations.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce(eventProcessors/* addGlobalEventProcessor */.cc, esm_hub/* getCurrentHub */.Gd);
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") {
        integration.setup(client);
    }
    if (client.on && typeof integration.preprocessEvent === "function") {
        var callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("Integration installed: ".concat(integration.name));
}
/** Add an integration to the current hub's client. */ function addIntegration(integration) {
    var client = getClient();
    if (!client || !client.addIntegration) {
        DEBUG_BUILD && logger.warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
    for(var i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) {
            return i;
        }
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function convertIntegrationFnToClass(name, fn) {
    return Object.assign(function ConvertedIntegration() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fn.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}
 //# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js



var originalFunctionToString;
var INTEGRATION_NAME = "FunctionToString";
var SETUP_CLIENTS = new WeakMap();
var _functionToStringIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0,object/* getOriginalFunction */.HK)(this);
                    var context = SETUP_CLIENTS.has((0,esm_exports/* getClient */.s3)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ var functionToStringIntegration = defineIntegration(_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var FunctionToString = convertIntegrationFnToClass(INTEGRATION_NAME, functionToStringIntegration);
// eslint-disable-next-line deprecation/deprecation
 //# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(35408);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/, 
];
var DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/, 
];
/** Options for the InboundFilters integration */ var inboundfilters_INTEGRATION_NAME = "InboundFilters";
var _inboundFiltersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        name: inboundfilters_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(event, _hint, client) {
            var clientOptions = client.getOptions();
            var mergedOptions = _mergeOptions(options, clientOptions);
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
var inboundFiltersIntegration = defineIntegration(_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var InboundFilters = convertIntegrationFnToClass(inboundfilters_INTEGRATION_NAME, inboundFiltersIntegration);
function _mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0,src_to_consumable_array/* default */.Z)(internalOptions.allowUrls || []).concat((0,src_to_consumable_array/* default */.Z)(clientOptions.allowUrls || [])),
        denyUrls: (0,src_to_consumable_array/* default */.Z)(internalOptions.denyUrls || []).concat((0,src_to_consumable_array/* default */.Z)(clientOptions.denyUrls || [])),
        ignoreErrors: (0,src_to_consumable_array/* default */.Z)(internalOptions.ignoreErrors || []).concat((0,src_to_consumable_array/* default */.Z)(clientOptions.ignoreErrors || []), (0,src_to_consumable_array/* default */.Z)(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0,src_to_consumable_array/* default */.Z)(internalOptions.ignoreTransactions || []).concat((0,src_to_consumable_array/* default */.Z)(clientOptions.ignoreTransactions || []), (0,src_to_consumable_array/* default */.Z)(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat((0,misc/* getEventDescription */.jH)(event)));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0,misc/* getEventDescription */.jH)(event)));
        return true;
    }
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0,misc/* getEventDescription */.jH)(event)));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0,misc/* getEventDescription */.jH)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0,misc/* getEventDescription */.jH)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function(message) {
        return (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors);
    });
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) {
        return false;
    }
    var name = event.transaction;
    return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}
function _getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) {
        possibleMessages.push(event.message);
    }
    var lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) {
                possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
            }
        }
    }
    if (debug_build/* DEBUG_BUILD */.X && possibleMessages.length === 0) {
        esm_logger/* logger.error */.kg.error("Could not extract message for event ".concat((0,misc/* getEventDescription */.jH)(event)));
    }
    return possibleMessages;
}
function _isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function _getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        var frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? _getLastValidUrl(frames) : null;
    } catch (oO) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("Cannot extract url for event ".concat((0,misc/* getEventDescription */.jH)(event)));
        return null;
    }
}
 //# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(11436);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/aggregate-errors.js





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
        return;
    }
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) {
        event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
    }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) {
        return prevExceptions;
    }
    var newExceptions = (0,src_to_consumable_array/* default */.Z)(prevExceptions);
    // Recursively call this function in order to walk down a chain of errors
    if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0,src_to_consumable_array/* default */.Z)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) {
        error.errors.forEach(function(childError, i) {
            if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
                applyExceptionGroupFieldsForParentException(exception, exceptionId);
                var newException = exceptionFromErrorImplementation(parser, childError);
                var newExceptionId = newExceptions.length;
                applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
                newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                    newException
                ].concat((0,src_to_consumable_array/* default */.Z)(newExceptions)), newException, newExceptionId);
            }
        });
    }
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, exception.mechanism, exception.type === "AggregateError" && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) {
            exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
        }
        return exception;
    });
}
 //# sourceMappingURL=aggregate-errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/eventbuilder.js







/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    var frames = parseStackFrames(stackParser, error);
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    return exception;
}
function getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        var message = "'".concat(exception.name, "' captured as exception");
        if ("message" in exception && typeof exception.message === "string") {
            message += " with message '".concat(exception.message, "'");
        }
        return message;
    } else if ("message" in exception && typeof exception.message === "string") {
        return exception.message;
    } else {
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        return "Object captured as exception with keys: ".concat(extractExceptionKeysForMessage(exception));
    }
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function eventFromUnknownInput(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    var client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    var ex = exception;
    var providedMechanism = hint && hint.data && hint.data.mechanism;
    var mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    var extras;
    if (!isError(exception)) {
        if (isPlainObject(exception)) {
            var normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = _define_property({}, "__serialized__", normalizeToSize(exception, normalizeDepth));
            var message = getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    var event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) {
        event.extra = extras;
    }
    addExceptionTypeValue(event, undefined, undefined);
    addExceptionMechanism(event, mechanism);
    return _object_spread_props(_object_spread({}, event), {
        event_id: hint && hint.event_id
    });
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        var frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }, 
                ]
            };
        }
    }
    if (isParameterizedString(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
 //# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/linkederrors.js


var DEFAULT_KEY = "cause";
var DEFAULT_LIMIT = 5;
var linkederrors_INTEGRATION_NAME = "LinkedErrors";
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: linkederrors_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            applyAggregateErrorsToEvent(exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var LinkedErrors = convertIntegrationFnToClass(linkederrors_INTEGRATION_NAME, linkedErrorsIntegration);
 //# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


 /* eslint-disable deprecation/deprecation */  //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/index.js














































/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var Integrations = integrations_namespaceObject;
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(61745);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js





var helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var ignoreOnError = 0;
/**
 * @hidden
 */ function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */ function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError++;
    setTimeout(function() {
        ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function wrap(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") {
                return wrapper;
            } else {
                // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
                // that something messed with it. In that case we want to return the originally passed function.
                return fn;
            }
        }
        // We don't wanna wrap it twice
        if ((0,object/* getOriginalFunction */.HK)(fn)) {
            return fn;
        }
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0,esm_exports/* withScope */.$e)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
                        (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
                    }
                    event.extra = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0,esm_exports/* captureException */.Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn){
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);
    (0,object/* addNonEnumerableProperty */.xp)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, "name", {
                get: function get() {
                    return fn.name;
                }
            });
        }
    // eslint-disable-next-line no-empty
    } catch (_oO1) {}
    return sentryWrapped;
}
 //# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/debug-build.js
var esm_debug_build = __webpack_require__(73159);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(28848);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/_handlers.js



// We keep the handlers globally
var handlers = {};
var instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach(function(key) {
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumentFn();
        instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                esm_debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0,stacktrace/* getFunctionName */.$P)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
 //# sourceMappingURL=_handlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/globalError.js


var _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    var type = "error";
    addHandler(type, handler);
    maybeInstrument(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = worldwide/* GLOBAL_OBJ.onerror */.n2.onerror;
    worldwide/* GLOBAL_OBJ.onerror */.n2.onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        triggerHandlers("error", handlerData);
        if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
    worldwide/* GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */.n2.onerror.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalError.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js


var _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    var type = "unhandledrejection";
    addHandler(type, handler);
    maybeInstrument(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection;
    worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection = function(e) {
        var handlerData = e;
        triggerHandlers("unhandledrejection", handlerData);
        if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
    worldwide/* GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */.n2.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalUnhandledRejection.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(90241);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var debug_build_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(40465);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(58950);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from a JavaScript Error
 */ function eventbuilder_exceptionFromError(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = eventbuilder_parseStackFrames(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    if (exception.type === undefined && exception.value === "") {
        exception.value = "Unrecoverable error caught";
    }
    return exception;
}
/**
 * @hidden
 */ function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0,esm_exports/* getClient */.s3)();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }, 
            ]
        },
        extra: {
            __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
            // event.exception.values[0] has been set above
            event.exception.values[0].stacktrace = {
                frames: frames
            };
        }
    }
    return event;
}
/**
 * @hidden
 */ function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                eventbuilder_exceptionFromError(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function eventbuilder_parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return "No error message";
    }
    if (message.error && typeof message.error.message === "string") {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function eventFromException(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventbuilder_eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventbuilder_eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * @hidden
 */ function eventbuilder_eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
        var domException = exception;
        if ("stack" in exception) {
            event = eventFromError(stackParser, exception);
        } else {
            var name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0,misc/* addExceptionTypeValue */.Db)(event, message);
        }
        if ("code" in domException) {
            // eslint-disable-next-line deprecation/deprecation
            event.tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.tags), {
                "DOMException.code": "".concat(domException.code)
            });
        }
        return event;
    }
    if ((0,is/* isError */.VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(stackParser, exception);
    }
    if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0,misc/* addExceptionMechanism */.EG)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionTypeValue */.Db)(event, "".concat(exception), undefined);
    (0,misc/* addExceptionMechanism */.EG)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
        }
    }
    if ((0,is/* isParameterizedString */.Le)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0,object/* extractExceptionKeysForMessage */.zf)(exception);
    var captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0,is/* isErrorEvent */.VW)(exception)) {
        return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    }
    if ((0,is/* isEvent */.cO)(exception)) {
        var className = getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
 //# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js






/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var globalhandlers_INTEGRATION_NAME = "GlobalHandlers";
var _globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,src_object_spread/* default */.Z)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: globalhandlers_INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            Error.stackTraceLimit = 50;
        },
        setup: function setup(client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
var globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var GlobalHandlers = convertIntegrationFnToClass(globalhandlers_INTEGRATION_NAME, globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    addGlobalErrorInstrumentationHandler(function(data) {
        var ref = getOptions(), stackParser = ref.stackParser, attachStacktrace = ref.attachStacktrace;
        if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = error === undefined && (0,is/* isString */.HD)(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame(eventbuilder_eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0,esm_exports/* captureEvent */.eN)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    addGlobalUnhandledRejectionInstrumentationHandler(function(e) {
        var ref = getOptions(), stackParser = ref.stackParser, attachStacktrace = ref.attachStacktrace;
        if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
            return;
        }
        var error = _getUnhandledRejectionError(e);
        var event = (0,is/* isPrimitive */.pt)(error) ? _eventFromRejectionWithPrimitive(error) : eventbuilder_eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0,esm_exports/* captureEvent */.eN)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function _getUnhandledRejectionError(error) {
    if ((0,is/* isPrimitive */.pt)(error)) {
        return error;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) {
            return e.reason;
        } else if ("detail" in e && "reason" in e.detail) {
            return e.detail.reason;
        }
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }, 
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
    var name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }, 
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
    }
    return event;
}
function globalHandlerLog(type) {
    debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Global Handler attached: ".concat(type));
}
function getOptions() {
    var client = (0,esm_exports/* getClient */.s3)();
    var options = client && client.getOptions() || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}
 //# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js




var DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload", 
];
var trycatch_INTEGRATION_NAME = "TryCatch";
var _browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,src_object_spread/* default */.Z)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: trycatch_INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function setupOnce() {
            if (_options.setTimeout) {
                (0,object/* fill */.hl)(helpers_WINDOW, "setTimeout", _wrapTimeFunction);
            }
            if (_options.setInterval) {
                (0,object/* fill */.hl)(helpers_WINDOW, "setInterval", _wrapTimeFunction);
            }
            if (_options.requestAnimationFrame) {
                (0,object/* fill */.hl)(helpers_WINDOW, "requestAnimationFrame", _wrapRAF);
            }
            if (_options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
                (0,object/* fill */.hl)(XMLHttpRequest.prototype, "send", _wrapXHR);
            }
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(_wrapEventTarget);
            }
        }
    };
};
var browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var TryCatch = convertIntegrationFnToClass(trycatch_INTEGRATION_NAME, browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: {
                    function: (0,stacktrace/* getFunctionName */.$P)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            wrap(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0,stacktrace/* getFunctionName */.$P)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            }), 
        ]);
    };
}
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,object/* fill */.hl)(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,stacktrace/* getFunctionName */.$P)(original)
                            },
                            handled: false,
                            type: "instrument"
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObject = helpers_WINDOW;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
        return;
    }
    (0,object/* fill */.hl)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") {
                    // ESlint disable explanation:
                    //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                    //  introduce a bug here, because bind returns a new function that doesn't have our
                    //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                    //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    fn.handleEvent = wrap(fn.handleEvent, {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                                target: target
                            },
                            handled: false,
                            type: "instrument"
                        }
                    });
                }
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options, 
            ]);
        };
    });
    (0,object/* fill */.hl)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
 //# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/console.js




/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    var type = "console";
    addHandler(type, handler);
    maybeInstrument(type, instrumentConsole);
}
function instrumentConsole() {
    if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
        return;
    }
    esm_logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function(level) {
        if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
            return;
        }
        (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n2.console, level, function(originalConsoleMethod) {
            esm_logger/* originalConsoleMethods */.LD[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                triggerHandlers("console", handlerData);
                var log = esm_logger/* originalConsoleMethods */.LD[level];
                log && log.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
            };
        });
    });
}
 //# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/dom.js




var dom_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var DEBOUNCE_DURATION = 1000;
var debounceTimerID;
var lastCapturedEventType;
var lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addClickKeypressInstrumentationHandler(handler) {
    var type = "dom";
    addHandler(type, handler);
    maybeInstrument(type, instrumentDOM);
}
/** Exported for tests only. */ function instrumentDOM() {
    if (!dom_WINDOW.document) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, "dom");
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    dom_WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    dom_WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = dom_WINDOW[target] && dom_WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
            return;
        }
        (0,object/* fill */.hl)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers[type] = handlers[type] || {
                            refCount: 0
                        };
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount++;
                    } catch (e) {
                    // Accessing dom properties is always fragile.
                    // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,object/* fill */.hl)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers[type];
                        if (handlerForType) {
                            handlerForType.refCount--;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    } catch (e) {
                    // Accessing dom properties is always fragile.
                    // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== lastCapturedEventType) {
        return false;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
            return false;
        }
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") {
        return false;
    }
    if (!target || !target.tagName) {
        return true;
    }
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return false;
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) {
            return;
        }
        var target = getEventTarget(event);
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event.type, target)) {
            return;
        }
        // Mark event as "seen"
        (0,object/* addNonEnumerableProperty */.xp)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) {
            // Add UUID to event target so we can identify if
            (0,object/* addNonEnumerableProperty */.xp)(target, "_sentryId", (0,misc/* uuid4 */.DM)());
        }
        var name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = dom_WINDOW.setTimeout(function() {
            lastCapturedEventTargetId = undefined;
            lastCapturedEventType = undefined;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}
 //# sourceMappingURL=dom.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/xhr.js





var xhr_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addXhrInstrumentationHandler(handler) {
    var type = "xhr";
    addHandler(type, handler);
    maybeInstrument(type, instrumentXHR);
}
/** Exported only for tests. */ function instrumentXHR() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!xhr_WINDOW.XMLHttpRequest) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,object/* fill */.hl)(xhrproto, "open", function(originalOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            var startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            var method = (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : undefined;
            var url = parseUrl(args[1]);
            if (!method || !url) {
                return originalOpen.apply(this, args);
            }
            this[SENTRY_XHR_DATA_KEY] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) {
                this.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = _this[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) {
                    return;
                }
                if (_this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = _this.status;
                    } catch (e) {
                    /* do nothing */ }
                    var handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: _this
                    };
                    triggerHandlers("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") {
                (0,object/* fill */.hl)(this, "onreadystatechange", function(original) {
                    return function() {
                        for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                            readyStateArgs[_key] = arguments[_key];
                        }
                        onreadystatechangeHandler();
                        return original.apply(this, readyStateArgs);
                    };
                });
            } else {
                this.addEventListener("readystatechange", onreadystatechangeHandler);
            }
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0,object/* fill */.hl)(this, "setRequestHeader", function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = (0,src_sliced_to_array/* default */.Z)(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && (0,is/* isString */.HD)(header) && (0,is/* isString */.HD)(value)) {
                        xhrInfo.request_headers[header.toLowerCase()] = value;
                    }
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0,object/* fill */.hl)(xhrproto, "send", function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) {
                return originalSend.apply(this, args);
            }
            if (args[0] !== undefined) {
                sentryXhrData.body = args[0];
            }
            var handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            triggerHandlers("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function parseUrl(url) {
    if ((0,is/* isString */.HD)(url)) {
        return url;
    }
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}
 //# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/supports.js



// eslint-disable-next-line deprecation/deprecation
var supports_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function supportsFetch() {
    if (!("fetch" in supports_WINDOW)) {
        return false;
    }
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") {
        return true;
    }
    if (!supportsFetch()) {
        return false;
    }
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(supports_WINDOW.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = supports_WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement("iframe");
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        } catch (err) {
            esm_debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return "ReportingObserver" in supports_WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
 //# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/fetch.js







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler) {
    var type = "fetch";
    addHandler(type, handler);
    maybeInstrument(type, instrumentFetch);
}
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ */.n2, "fetch", function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var ref = parseFetchArgs(args), method = ref.method, url = ref.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            triggerHandlers("fetch", (0,src_object_spread/* default */.Z)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(worldwide/* GLOBAL_OBJ */.n2, args).then(function(response) {
                var finishedHandlerData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                });
                triggerHandlers("fetch", finishedHandlerData);
                return response;
            }, function(error) {
                var erroredHandlerData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                });
                triggerHandlers("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === "string") {
        return resource;
    }
    if (!resource) {
        return "";
    }
    if (hasProp(resource, "url")) {
        return resource.url;
    }
    if (resource.toString) {
        return resource.toString();
    }
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) {
        return {
            method: "GET",
            url: ""
        };
    }
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0,src_sliced_to_array/* default */.Z)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
 //# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js

// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var supportsHistory_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chromeVar = supportsHistory_WINDOW.chrome;
    var isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in supportsHistory_WINDOW && !!supportsHistory_WINDOW.history.pushState && !!supportsHistory_WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
 //# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/history.js






var history_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addHistoryInstrumentationHandler(handler) {
    var type = "history";
    addHandler(type, handler);
    maybeInstrument(type, instrumentHistory);
}
function instrumentHistory() {
    var historyReplacementFunction = function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                var handlerData = {
                    from: from,
                    to: to
                };
                triggerHandlers("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    };
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = history_WINDOW.onpopstate;
    history_WINDOW.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = history_WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        var handlerData = {
            from: from,
            to: to
        };
        triggerHandlers("history", handlerData);
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            } catch (_oO) {
            // no-empty
            }
        }
    };
    (0,object/* fill */.hl)(history_WINDOW.history, "pushState", historyReplacementFunction);
    (0,object/* fill */.hl)(history_WINDOW.history, "replaceState", historyReplacementFunction);
}
 //# sourceMappingURL=history.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var validSeverityLevels = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function severityFromString(level) {
    return severityLevelFromString(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function severityLevelFromString(level) {
    return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}
 //# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function url_parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function getNumberOfUrlSegments(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ",";
    }).length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return "".concat(protocol ? "".concat(protocol, "://") : "").concat(filteredHost).concat(path);
}
 //# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js






/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var MAX_ALLOWED_STRING_LENGTH = 1024;
var breadcrumbs_INTEGRATION_NAME = "Breadcrumbs";
var _breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,src_object_spread/* default */.Z)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: breadcrumbs_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            if (_options.console) {
                addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
            }
            if (_options.dom) {
                addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
            }
            if (_options.xhr) {
                addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
            }
            if (_options.fetch) {
                addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
            }
            if (_options.history) {
                addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
            }
            if (_options.sentry && client.on) {
                client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
            }
        }
    };
};
var breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Breadcrumbs = convertIntegrationFnToClass(breadcrumbs_INTEGRATION_NAME, breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: "sentry.".concat(event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0,misc/* getEventDescription */.jH)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var target;
        var componentName;
        var keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        var maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") {
            keyAttrs = [
                keyAttrs
            ];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            var element = _isEvent(event) ? event.target : event;
            target = (0,browser/* htmlTreeAsString */.Rt)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0,browser/* getComponentName */.iY)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) {
            return;
        }
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) {
            breadcrumb.data = {
                "ui.component_name": componentName
            };
        }
        (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: severityLevelFromString(handlerData.level),
            message: (0,string/* safeJoin */.nK)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat((0,string/* safeJoin */.nK)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) {
            return;
        }
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        // We only capture complete fetch requests
        if (!endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0,esm_exports/* addBreadcrumb */.n_)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            var response = handlerData.response;
            var data1 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0,esm_exports/* addBreadcrumb */.n_)({
                category: "fetch",
                data: data1,
                type: "http"
            }, hint1);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = url_parseUrl(helpers_WINDOW.location.href);
        var parsedFrom = from ? url_parseUrl(from) : undefined;
        var parsedTo = url_parseUrl(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}
 //# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js



var linkederrors_DEFAULT_KEY = "cause";
var linkederrors_DEFAULT_LIMIT = 5;
var integrations_linkederrors_INTEGRATION_NAME = "LinkedErrors";
var linkederrors_linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || linkederrors_DEFAULT_LIMIT;
    var key = options.key || linkederrors_DEFAULT_KEY;
    return {
        name: integrations_linkederrors_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            applyAggregateErrorsToEvent(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            eventbuilder_exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var integrations_linkederrors_linkedErrorsIntegration = defineIntegration(linkederrors_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var linkederrors_LinkedErrors = convertIntegrationFnToClass(integrations_linkederrors_INTEGRATION_NAME, integrations_linkederrors_linkedErrorsIntegration);
 //# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js




var httpcontext_INTEGRATION_NAME = "HttpContext";
var _httpContextIntegration = function() {
    return {
        name: httpcontext_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event) {
            // if none of the information we want exists, don't bother
            if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
                return;
            }
            // grab as much info as exists and add it to the event
            var url = event.request && event.request.url || helpers_WINDOW.location && helpers_WINDOW.location.href;
            var referrer = (helpers_WINDOW.document || {}).referrer;
            var userAgent = (helpers_WINDOW.navigator || {}).userAgent;
            var headers = (0,src_object_spread/* default */.Z)({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                "User-Agent": userAgent
            });
            var request = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
};
var httpContextIntegration = defineIntegration(_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var HttpContext = convertIntegrationFnToClass(httpcontext_INTEGRATION_NAME, httpContextIntegration);
 //# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js



var dedupe_INTEGRATION_NAME = "Dedupe";
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: dedupe_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) {
                return currentEvent;
            }
            // Juuust in case something goes wrong
            try {
                if (dedupe_shouldDropEvent(currentEvent, previousEvent)) {
                    debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = defineIntegration(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Dedupe = convertIntegrationFnToClass(dedupe_INTEGRATION_NAME, dedupeIntegration);
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-expect-error Object could be undefined
            return exception.values[0].stacktrace.frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}
 //# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js





 /* eslint-disable deprecation/deprecation */  //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js



























var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers_WINDOW.Sentry && helpers_WINDOW.Sentry.Integrations) {
    windowIntegrations = helpers_WINDOW.Sentry.Integrations;
}
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var INTEGRATIONS = (0,src_object_spread/* default */.Z)({}, windowIntegrations, Integrations, esm_integrations_namespaceObject);
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (debug_build/* DEBUG_BUILD */.X) {
            esm_logger/* logger.enable */.kg.enable();
        } else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            (0,esm_logger/* consoleSandbox */.Cf)(function() {
                // eslint-disable-next-line no-console
                console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
            });
        }
    }
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    setCurrentClient(client);
    initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    // eslint-disable-next-line deprecation/deprecation
    var top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function initializeClient(client) {
    if (client.init) {
        client.init();
    // TODO v8: Remove this fallback
    // eslint-disable-next-line deprecation/deprecation
    } else if (client.setupIntegrations) {
        // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
}
 //# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_super_prop_base.mjs


function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_get_prototype_of/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get.mjs


function get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    get = Reflect.get;
  } else {
    get = function get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver || target);
      }

      return desc.value;
    };
  }

  return get(target, property, receiver);
}

function _get(target, property, receiver) {
  return get(target, property, receiver);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(25171);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js



/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsn_dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : "") + "@".concat(host).concat(port ? ":".concat(port) : "", "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0,esm_logger/* consoleSandbox */.Cf)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var ref = (0,src_sliced_to_array/* default */.Z)(match.slice(1), 6), protocol = ref[0], publicKey = ref[1], tmp = ref[2], pass = tmp === void 0 ? "" : tmp, host = ref[3], tmp1 = ref[4], port = tmp1 === void 0 ? "" : tmp1, lastPath = ref[5];
    var path = "";
    var projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!esm_debug_build/* DEBUG_BUILD */.X) {
        return true;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            esm_logger/* logger.error */.kg.error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) {
        return false;
    }
    if (!projectId.match(/^\d+$/)) {
        esm_logger/* logger.error */.kg.error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!isValidProtocol(protocol)) {
        esm_logger/* logger.error */.kg.error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        esm_logger/* logger.error */.kg.error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function dsn_makeDsn(from) {
    var components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) {
        return undefined;
    }
    return components;
}
 //# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js







/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0,src_sliced_to_array/* default */.Z)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0,src_to_consumable_array/* default */.Z)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8.
 */ function encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope, textEncoder) {
    var append = function append(next) {
        if (typeof parts === "string") {
            parts = typeof next === "string" ? parts + next : [
                encodeUTF8(parts, textEncoder),
                next
            ];
        } else {
            parts.push(typeof next === "string" ? encodeUTF8(next, textEncoder) : next);
        }
    };
    var _envelope = (0,src_sliced_to_array/* default */.Z)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0,src_sliced_to_array/* default */.Z)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === "string" || (0,_instanceof/* default */.Z)(payload, Uint8Array)) {
                append(payload);
            } else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0,normalize/* normalize */.Fv)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env, textEncoder, textDecoder) {
    var readBinary = function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    };
    var readJson = function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) {
            i = buffer.length;
        }
        return JSON.parse(textDecoder.decode(readBinary(i)));
    };
    var buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment, textEncoder) {
    var buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0,object/* dropUndefinedKeys */.Jr)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer, 
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) {
        return;
    }
    var _sdk = metadataOrEvent.sdk, name = _sdk.name, version = _sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0,src_object_spread/* default */.Z)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: dsn_dsnToString(dsn)
    }, dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)((0,src_object_spread/* default */.Z)({}, dynamicSamplingContext))
    });
}
 //# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_construct.mjs
var _construct = __webpack_require__(89101);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return (0,_construct/* default */.Z)(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */ 





var SentryError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(SentryError, Error1);
    var _super = (0,_create_super/* default */.Z)(SentryError);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "warn";
        (0,_class_call_check/* default */.Z)(this, SentryError);
        var _this;
        _this = _super.call(this, message);
        _this.message = message;
        _this.name = ((0,_instanceof/* default */.Z)(this, SentryError) ? this.constructor : void 0).prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf((0,_assert_this_initialized/* default */.Z)(_this), ((0,_instanceof/* default */.Z)(this, SentryError) ? this.constructor : void 0).prototype);
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}(_wrapNativeSuper(Error));
 //# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


var SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : "";
    var port = dsn.port ? ":".concat(dsn.port) : "";
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : "", "/api/");
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return "".concat(getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    return (0,object/* urlEncode */._j)((0,src_object_spread/* default */.Z)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION
    }, sdkInfo && {
        sentry_client: "".concat(sdkInfo.name, "/").concat(sdkInfo.version)
    }));
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn) {
    var // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
    // options: ClientOptions = {} as ClientOptions,
    tunnelOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : "".concat(_getIngestEndpoint(dsn), "?").concat(_encodedAuth(dsn, sdkInfo));
}
/** Returns the url to the report dialog endpoint. */ function api_getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = makeDsn(dsnLike);
    if (!dsn) {
        return "";
    }
    var endpoint = "".concat(getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat(dsnToString(dsn));
    for(var key in dialogOptions){
        if (key === "dsn") {
            continue;
        }
        if (key === "onClose") {
            continue;
        }
        if (key === "user") {
            var user = dialogOptions.user;
            if (!user) {
                continue;
            }
            if (user.name) {
                encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            }
            if (user.email) {
                encodedOptions += "&email=".concat(encodeURIComponent(user.email));
            }
        } else {
            encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
        }
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}
 //# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,src_to_consumable_array/* default */.Z)(event.sdk.integrations || []).concat((0,src_to_consumable_array/* default */.Z)(sdkInfo.integrations || []));
    event.sdk.packages = (0,src_to_consumable_array/* default */.Z)(event.sdk.packages || []).concat((0,src_to_consumable_array/* default */.Z)(sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
    var envelopeHeaders = (0,src_object_spread/* default */.Z)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: dsn_dsnToString(dsn)
    });
    var envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
 //# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/utils.js



/**
 * Generate bucket key from metric properties.
 */ function getBucketKey(metricType, name, unit, tags) {
    var stringifiedTags = Object.entries(dropUndefinedKeys(tags)).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    });
    return "".concat(metricType).concat(name).concat(unit).concat(stringifiedTags);
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function simpleHash(s) {
    var rv = 0;
    for(var i = 0; i < s.length; i++){
        var c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function serializeMetricBuckets(metricBucketItems) {
    var out = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metricBucketItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var tagEntries = Object.entries(item.tags);
            var maybeTags = tagEntries.length > 0 ? "|#".concat(tagEntries.map(function(param) {
                var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                return "".concat(key, ":").concat(value);
            }).join(",")) : "";
            out += "".concat(item.name, "@").concat(item.unit, ":").concat(item.metric, "|").concat(item.metricType).concat(maybeTags, "|T").concat(item.timestamp, "\n");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
/** Sanitizes units */ function sanitizeUnit(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function sanitizeMetricKey(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
var tagValueReplacements = (/* unused pure expression or super */ null && ([
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ], 
]));
function getCharOrReplacement(input) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tagValueReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), search = _value[0], replacement = _value[1];
            if (input === search) {
                return replacement;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return input;
}
function sanitizeTagValue(value) {
    return _to_consumable_array(value).reduce(function(acc, char) {
        return acc + getCharOrReplacement(char);
    }, "");
}
/**
 * Sanitizes tags.
 */ function sanitizeTags(unsanitizedTags) {
    var tags = {};
    for(var key in unsanitizedTags){
        if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
            var sanitizedKey = sanitizeTagKey(key);
            tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
        }
    }
    return tags;
}
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/envelope.js


/**
 * Create envelope from a metric aggregate.
 */ function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) {
        headers.sdk = {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        };
    }
    if (!!tunnel && dsn) {
        headers.dsn = dsn_dsnToString(dsn);
    }
    var item = createMetricEnvelopeItem(metricBucketItems);
    return createEnvelope(headers, [
        item
    ]);
}
function createMetricEnvelopeItem(metricBucketItems) {
    var payload = serializeMetricBuckets(metricBucketItems);
    var metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}
 //# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(34395);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(86232);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(8405);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js


















var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var BaseClient = /*#__PURE__*/ function() {
    "use strict";
    function BaseClient(options) {
        (0,_class_call_check/* default */.Z)(this, BaseClient);
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) {
            this._dsn = dsn_makeDsn(options.dsn);
        } else {
            debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("No DSN provided, client will not send events.");
        }
        if (this._dsn) {
            var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
            this._transport = options.transport((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
    (0,_create_class/* default */.Z)(BaseClient, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                // ensure we haven't captured this very object before
                if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this.eventFromException(exception, hint).then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint, scope) {
                var _this = this;
                var eventId = hint && hint.event_id;
                var eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);
                var promisedEvent = (0,is/* isPrimitive */.pt)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
                this._process(promisedEvent.then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // ensure we haven't captured this very object before
                if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession(session) {
                if (!(typeof session.release === "string")) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Discarded session because of missing or non-string release");
                } else {
                    this.sendSession(session);
                    // After sending, we set init false to indicate it's not the first occurrence
                    (0,esm_session/* updateSession */.CT)(session, {
                        init: false
                    });
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush(timeout) {
                var transport = this._transport;
                if (transport) {
                    if (this.metricsAggregator) {
                        this.metricsAggregator.flush();
                    }
                    return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                        return transport.flush(timeout).then(function(transportFlushed) {
                            return clientFinished && transportFlushed;
                        });
                    });
                } else {
                    return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close(timeout) {
                var _this = this;
                return this.flush(timeout).then(function(result) {
                    _this.getOptions().enabled = false;
                    if (_this.metricsAggregator) {
                        _this.metricsAggregator.close();
                    }
                    return result;
                });
            }
        },
        {
            /** Get all installed event processors. */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /** @inheritDoc */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ key: "setupIntegrations",
            value: function setupIntegrations(forceInitialize) {
                if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) {
                    this._setupIntegrations();
                }
            }
        },
        {
            /** @inheritdoc */ key: "init",
            value: function init() {
                if (this._isEnabled()) {
                    this._setupIntegrations();
                }
            }
        },
        {
            /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegrationById",
            value: function getIntegrationById(integrationId) {
                return this.getIntegrationByName(integrationId);
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                try {
                    return this._integrations[integration.id] || null;
                } catch (_oO) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                // This hook takes care of only installing if not already installed
                setupIntegration(this, integration, this._integrations);
                // Here we need to check manually to make sure to not run this multiple times
                if (!isAlreadyInstalled) {
                    afterSetupIntegrations(this, [
                        integration
                    ]);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                this.emit("beforeSendEvent", event, hint);
                var env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var promise = this._sendEnvelope(env);
                if (promise) {
                    promise.then(function(sendResponse) {
                        return _this.emit("afterSendEvent", event, sendResponse);
                    }, null);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendSession",
            value: function sendSession(session) {
                var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(env);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category, eventOrCount) {
                if (this._options.sendClientReports) {
                    // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
                    // If event is passed as third argument, we assume this is a count of 1
                    var count = typeof eventOrCount === "number" ? eventOrCount : 1;
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = "".concat(reason, ":").concat(category);
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('Recording outcome: "'.concat(key, '"').concat(count > 1 ? " (".concat(count, " times)") : ""));
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureAggregateMetrics",
            value: function captureAggregateMetrics(metricBucketItems) {
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("Flushing aggregated metrics, number of metrics: ".concat(metricBucketItems.length));
                var metricsEnvelope = createMetricEnvelope(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(metricsEnvelope);
            }
        },
        {
            // Keep on() & emit() signatures in sync with types' client.ts interface
            /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ key: "on",
            value: function on(hook, callback) {
                if (!this._hooks[hook]) {
                    this._hooks[hook] = [];
                }
                // @ts-expect-error We assue the types are correct
                this._hooks[hook].push(callback);
            }
        },
        {
            /** @inheritdoc */ /** @inheritdoc */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (this._hooks[hook]) {
                    this._hooks[hook].forEach(function(callback) {
                        return callback.apply(void 0, (0,src_to_consumable_array/* default */.Z)(rest));
                    });
                }
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = setupIntegrations(this, integrations);
                afterSetupIntegrations(this, integrations);
                // TODO v8: We don't need this flag anymore
                this._integrationsInitialized = true;
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var crashed = false;
                var errored = false;
                var exceptions = event.exception && event.exception.values;
                if (exceptions) {
                    errored = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            var mechanism = ex.mechanism;
                            if (mechanism && mechanism.handled === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === "ok";
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0,esm_session/* updateSession */.CT)(session, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, crashed && {
                        status: "crashed"
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ key: "_isClientDoneProcessing",
            value: function _isClientDoneProcessing(timeout) {
                var _this = this;
                return new syncpromise/* SyncPromise */.cW(function(resolve) {
                    var ticked = 0;
                    var tick = 1;
                    var interval = setInterval(function() {
                        if (_this._numProcessing == 0) {
                            clearInterval(interval);
                            resolve(true);
                        } else {
                            ticked += tick;
                            if (timeout && ticked >= timeout) {
                                clearInterval(interval);
                                resolve(false);
                            }
                        }
                    }, tick);
                });
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                var isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0,esm_hub/* getIsolationScope */.aF)();
                var _this = this;
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && integrations.length > 0) {
                    hint.integrations = integrations;
                }
                this.emit("preprocessEvent", event, hint);
                return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope, this, isolationScope).then(function(evt) {
                    if (evt === null) {
                        return evt;
                    }
                    var propagationContext = (0,src_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope ? scope.getPropagationContext() : undefined);
                    var trace = evt.contexts && evt.contexts.trace;
                    if (!trace && propagationContext) {
                        var trace_id = propagationContext.traceId, spanId = propagationContext.spanId, parentSpanId = propagationContext.parentSpanId, dsc = propagationContext.dsc;
                        evt.contexts = (0,src_object_spread/* default */.Z)({
                            trace: {
                                trace_id: trace_id,
                                span_id: spanId,
                                parent_span_id: parentSpanId
                            }
                        }, evt.contexts);
                        var dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, _this, scope);
                        evt.sdkProcessingMetadata = (0,src_object_spread/* default */.Z)({
                            dynamicSamplingContext: dynamicSamplingContext
                        }, evt.sdkProcessingMetadata);
                    }
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(event, hint, scope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (debug_build/* DEBUG_BUILD */.X) {
                        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                        // control flow, log just the message (no stack) as a log-level log.
                        var sentryError = reason;
                        if (sentryError.logLevel === "log") {
                            esm_logger/* logger.log */.kg.log(sentryError.message);
                        } else {
                            esm_logger/* logger.warn */.kg.warn(sentryError);
                        }
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = isTransactionEvent(event);
                var isError = isErrorEvent(event);
                var eventType = event.type || "error";
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
                    this.recordDroppedEvent("sample_rate", "error", event);
                    return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), "log"));
                }
                var dataCategory = eventType === "replay_event" ? "replay" : eventType;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent("event_processor", dataCategory, event);
                        throw new SentryError("An event processor returned `null`, will not send event.", "log");
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) {
                        return prepared;
                    }
                    var result = processBeforeSend(options, prepared, hint);
                    return _validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent("before_send", dataCategory, event);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            // the transaction itself counts as one span, plus all the child spans that are added
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent("before_send", "span", spanCount);
                        }
                        throw new SentryError("".concat(beforeSendLabel, " returned `null`, will not send event."), "log");
                    }
                    var session = scope && scope.getSession();
                    if (!isTransaction && session) {
                        _this._updateSessionFromEvent(session, processedEvent);
                    }
                    if (isTransaction) {
                        var spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) {
                            _this.recordDroppedEvent("before_send", "span", droppedSpanCount);
                        }
                    }
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = "custom";
                        processedEvent.transaction_info = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if ((0,_instanceof/* default */.Z)(reason, SentryError)) {
                        throw reason;
                    }
                    _this.captureException(reason, {
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(promise) {
                var _this = this;
                this._numProcessing++;
                void promise.then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    return reason;
                });
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "_sendEnvelope",
            value: function _sendEnvelope(envelope) {
                this.emit("beforeEnvelope", envelope);
                if (this._isEnabled() && this._transport) {
                    return this._transport.send(envelope).then(null, function(reason) {
                        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("Error while sending event:", reason);
                    });
                } else {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("Transport disabled");
                }
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.keys(outcomes).map(function(key) {
                    var ref = (0,src_sliced_to_array/* default */.Z)(key.split(":"), 2), reason = ref[0], category = ref[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: outcomes[key]
                    };
                });
            }
        }
    ]);
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0,is/* isThenable */.J8)(beforeSendResult)) {
        return beforeSendResult.then(function(event) {
            if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
                throw new SentryError(invalidValueError);
            }
            return event;
        }, function(e) {
            throw new SentryError("".concat(beforeSendLabel, " rejected with ").concat(e));
        });
    } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
        throw new SentryError(invalidValueError);
    }
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction;
    if (isErrorEvent(event) && beforeSend) {
        return beforeSend(event, hint);
    }
    if (isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            var spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.sdkProcessingMetadata), {
                spanCountBeforeProcessing: spanCountBefore
            });
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function addEventProcessor(callback) {
    var client = getClient();
    if (!client || !client.addEventProcessor) {
        return;
    }
    client.addEventProcessor(callback);
}
 //# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}
 //# sourceMappingURL=env.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(25231);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js


/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
            discarded_events: discarded_events
        }, 
    ];
    return createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
 //# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */ function createUserFeedbackEnvelope(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0,src_object_spread/* default */.Z)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: dsn_dsnToString(dsn)
    });
    var item = createUserFeedbackEnvelopeItem(feedback);
    return createEnvelope(headers, [
        item
    ]);
}
function createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}
 //# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js












/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var BrowserClient = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0,_inherits/* default */.Z)(BrowserClient, BaseClient);
    var _super = (0,_create_super/* default */.Z)(BrowserClient);
    function BrowserClient(options) {
        (0,_class_call_check/* default */.Z)(this, BrowserClient);
        var _this;
        var sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
        applySdkMetadata(options, "browser", [
            "browser"
        ], sdkSource);
        _this = _super.call(this, options);
        if (options.sendClientReports && helpers_WINDOW.document) {
            helpers_WINDOW.document.addEventListener("visibilitychange", function() {
                if (helpers_WINDOW.document.visibilityState === "hidden") {
                    _this._flushOutcomes();
                }
            });
        }
        return _this;
    }
    (0,_create_class/* default */.Z)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException1(exception, hint) {
                return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage1(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info", hint = arguments.length > 2 ? arguments[2] : void 0;
                return eventbuilder_eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * Sends user feedback to Sentry.
   */ key: "captureUserFeedback",
            value: function captureUserFeedback(feedback) {
                if (!this._isEnabled()) {
                    debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("SDK not enabled, will not capture user feedback.");
                    return;
                }
                var envelope = createUserFeedbackEnvelope(feedback, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                event.platform = event.platform || "javascript";
                return _get((0,_get_prototype_of/* default */.Z)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("No outcomes to send");
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("No dsn provided, will not send outcomes");
                    return;
                }
                debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Sending outcomes:", outcomes);
                var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        }
    ]);
    return BrowserClient;
}(BaseClient);
 //# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js



// global reference to slice
var UNKNOWN_FUNCTION = "?";
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var chromeStackParserFn = function(line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var ref = (0,src_sliced_to_array/* default */.Z)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = ref[0], filename = ref[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackLineParser = [
    CHROME_PRIORITY,
    chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function(line) {
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        var ref;
        ref = (0,src_sliced_to_array/* default */.Z)(extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackLineParser = [
    GECKO_PRIORITY,
    gecko
];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function(line) {
    var parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var winjsStackLineParser = [
    WINJS_PRIORITY,
    winjs
];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function(line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackLineParser = [
    OPERA10_PRIORITY,
    opera10
];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function(line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackLineParser = [
    OPERA11_PRIORITY,
    opera11
];
var defaultStackLineParsers = [
    chromeStackLineParser,
    geckoStackLineParser,
    winjsStackLineParser
];
var defaultStackParser = stacktrace/* createStackParser.apply */.pE.apply(void 0, (0,src_to_consumable_array/* default */.Z)(defaultStackLineParsers));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename), 
    ] : [
        func,
        filename
    ];
};
 //# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer(limit) {
    var isReady = function isReady() {
        return limit === undefined || buffer.length < limit;
    };
    var remove = /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    };
    var add = /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError("Not adding Promise because buffer limit was reached."));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    };
    var drain = /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function() {
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    };
    var buffer = [];
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}
 //# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend


var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0,src_object_spread/* default */.Z)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var limit = _step.value;
                var ref = (0,src_sliced_to_array/* default */.Z)(limit.split(":", 5), 5), retryAfter = ref[0], categories = ref[1], namespaces = ref[4];
                var headerDelay = parseInt(retryAfter, 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!categories) {
                    updatedRateLimits.all = now + delay;
                } else {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = categories.split(";")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var category = _step1.value;
                            if (category === "metric_bucket") {
                                // namespaces will be present when category === 'metric_bucket'
                                if (!namespaces || namespaces.split(";").includes("custom")) {
                                    updatedRateLimits[category] = now + delay;
                                }
                            } else {
                                updatedRateLimits[category] = now + delay;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    } else if (statusCode === 429) {
        updatedRateLimits.all = now + 60 * 1000;
    }
    return updatedRateLimits;
}
 //# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js



var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE);
    var send = function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        forEachEnvelopeItem(envelope, function(item, type) {
            var dataCategory = envelopeItemTypeToDataCategory(type);
            if (isRateLimited(rateLimits, dataCategory)) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else {
                filteredEnvelopeItems.push(item);
            }
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) {
            return (0,syncpromise/* resolvedSyncPromise */.WD)();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            forEachEnvelopeItem(filteredEnvelope, function(item, type) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: serializeEnvelope(filteredEnvelope, options.textEncoder)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                }
                rateLimits = updateRateLimits(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss("network_error");
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if ((0,_instanceof/* default */.Z)(error, SentryError)) {
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0,syncpromise/* resolvedSyncPromise */.WD)();
            } else {
                throw error;
            }
        });
    };
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") {
        return undefined;
    }
    return Array.isArray(item) ? item[1] : undefined;
}
 //# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



var cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if (isNativeFetch(helpers_WINDOW.fetch)) {
        return cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW);
    }
    var document = helpers_WINDOW.document;
    var fetchImpl = helpers_WINDOW.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") {
        try {
            var sandbox = document.createElement("iframe");
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        } catch (e) {
            debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
        }
    }
    return cachedFetchImpl = fetchImpl.bind(helpers_WINDOW);
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function clearCachedFetchImplementation() {
    cachedFetchImpl = undefined;
}
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function makeFetchTransport(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getNativeFetchImplementation();
    var makeRequest = function makeRequest(request) {
        var requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        var requestOptions = (0,src_object_spread/* default */.Z)({
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        try {
            return nativeFetch(options.url, requestOptions).then(function(response) {
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            clearCachedFetchImplementation();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
        }
    };
    var pendingBodySize = 0;
    var pendingCount = 0;
    return createTransport(options, makeRequest);
}
 //# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js


/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function makeXHRTransport(options) {
    var makeRequest = function makeRequest(request) {
        return new syncpromise/* SyncPromise */.cW(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = function() {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    resolve({
                        statusCode: xhr.status,
                        headers: {
                            "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                            "retry-after": xhr.getResponseHeader("Retry-After")
                        }
                    });
                }
            };
            xhr.open("POST", options.url);
            for(var header in options.headers){
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    };
    return createTransport(options, makeRequest);
}
 //# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js

















/** @deprecated Use `getDefaultIntegrations(options)` instead. */ var defaultIntegrations = [
    inboundFiltersIntegration(),
    functionToStringIntegration(),
    browserApiErrorsIntegration(),
    breadcrumbsIntegration(),
    globalHandlersIntegration(),
    integrations_linkederrors_linkedErrorsIntegration(),
    dedupeIntegration(),
    httpContextIntegration(), 
];
/** Get the default integrations for the browser SDK. */ function getDefaultIntegrations(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return(// eslint-disable-next-line deprecation/deprecation
    (0,src_to_consumable_array/* default */.Z)(defaultIntegrations));
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function init() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = getDefaultIntegrations();
    }
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") {
            options.release = __SENTRY_RELEASE__;
        }
        // This supports the variable that sentry-webpack-plugin injects
        if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
            options.release = helpers_WINDOW.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    var clientOptions = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
        integrations: getIntegrationsToSetup(options),
        transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport)
    });
    initAndBind(BrowserClient, clientOptions);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
var showReportDialog = function() {
    var // eslint-disable-next-line deprecation/deprecation
    options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, // eslint-disable-next-line deprecation/deprecation
    hub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentHub();
    // doesn't work without a document (React Native)
    if (!WINDOW.document) {
        DEBUG_BUILD && logger.error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    var ref = hub.getStackTop(), client = ref.client, scope = ref.scope;
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        DEBUG_BUILD && logger.error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) {
        options.user = _object_spread({}, scope.getUser(), options.user);
    }
    if (!options.eventId) {
        // eslint-disable-next-line deprecation/deprecation
        options.eventId = hub.lastEventId();
    }
    var script = WINDOW.document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = getReportDialogEndpoint(dsn, options);
    if (options.onLoad) {
        script.onload = options.onLoad;
    }
    var onClose = options.onClose;
    if (onClose) {
        var reportDialogClosedMessageHandler = function(event) {
            if (event.data === "__sentry_reportdialog_closed__") {
                try {
                    onClose();
                } finally{
                    WINDOW.removeEventListener("message", reportDialogClosedMessageHandler);
                }
            }
        };
        WINDOW.addEventListener("message", reportDialogClosedMessageHandler);
    }
    var injectionPoint = WINDOW.document.head || WINDOW.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    } else {
        DEBUG_BUILD && logger.error("Not injecting report dialog. No injection point found in HTML");
    }
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function forceLoad() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function onLoad(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
    return wrap$1(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function startSessionTracking() {
    if (typeof helpers_WINDOW.document === "undefined") {
        debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0,esm_exports/* startSession */.yj)({
        ignoreDuration: true
    });
    (0,esm_exports/* captureSession */.cg)();
    // We want to create a session for every navigation as well
    addHistoryInstrumentationHandler(function(param) {
        var from = param.from, to = param.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0,esm_exports/* startSession */.yj)({
                ignoreDuration: true
            });
            (0,esm_exports/* captureSession */.cg)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function captureUserFeedback(feedback) {
    var client = getClient();
    if (client) {
        client.captureUserFeedback(feedback);
    }
}
 //# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js



/**
 * Inits the React SDK
 */ function sdk_init(options) {
    var opts = (0,src_object_spread/* default */.Z)({}, options);
    applySdkMetadata(opts, "react");
    init(opts);
}
 //# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */ function getVercelEnv(isClient) {
    var vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
    return vercelEnvVar ? "vercel-".concat(vercelEnvVar) : undefined;
}
 //# sourceMappingURL=getVercelEnv.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(5889);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/spanstatus.js
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var SpanStatus;
(function(SpanStatus) {
    /** The operation completed successfully. */ var Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ var DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ var Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ var PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ var NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ var ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ var InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ var Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ var Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ var InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ var UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ var Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ var AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ var FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ var Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ var OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ var DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return "ok";
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch(httpStatus){
            case 401:
                return "unauthenticated";
            case 403:
                return "permission_denied";
            case 404:
                return "not_found";
            case 409:
                return "already_exists";
            case 413:
                return "failed_precondition";
            case 429:
                return "resource_exhausted";
            default:
                return "invalid_argument";
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch(httpStatus){
            case 501:
                return "unimplemented";
            case 503:
                return "unavailable";
            case 504:
                return "deadline_exceeded";
            default:
                return "internal_error";
        }
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ var spanStatusfromHttpCode = (/* unused pure expression or super */ null && (getSpanStatusFromHttpCode));
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus !== "unknown_error") {
        span.setStatus(spanStatus);
    }
}
 //# sourceMappingURL=spanstatus.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js












/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function trace(context, callback) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, // eslint-disable-next-line @typescript-eslint/no-empty-function
    afterFinish = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    // eslint-disable-next-line deprecation/deprecation
    var hub = getCurrentHub();
    var scope = getCurrentScope();
    // eslint-disable-next-line deprecation/deprecation
    var parentSpan = scope.getSpan();
    var spanContext = normalizeContext(context);
    var activeSpan = createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return handleCallbackErrors(function() {
        return callback(activeSpan);
    }, function(error) {
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, function() {
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpan(context, callback) {
    var spanContext = normalizeContext(context);
    return runWithAsyncContext(function() {
        return withScope(context.scope, function(scope) {
            // eslint-disable-next-line deprecation/deprecation
            var hub = getCurrentHub();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return handleCallbackErrors(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    var status = spanToJSON(activeSpan).status;
                    if (!status || status === "ok") {
                        activeSpan.setStatus("internal_error");
                    }
                }
            }, function() {
                return activeSpan && activeSpan.end();
            });
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ var startActiveSpan = (/* unused pure expression or super */ null && (startSpan));
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpanManual(context, callback) {
    var spanContext = normalizeContext(context);
    return runWithAsyncContext(function() {
        return withScope(context.scope, function(scope) {
            var finishAndSetSpan = function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            };
            // eslint-disable-next-line deprecation/deprecation
            var hub = getCurrentHub();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return handleCallbackErrors(function() {
                return callback(activeSpan, finishAndSetSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    var status = spanToJSON(activeSpan).status;
                    if (!status || status === "ok") {
                        activeSpan.setStatus("internal_error");
                    }
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startInactiveSpan(context) {
    if (!hasTracingEnabled()) {
        return undefined;
    }
    var spanContext = normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var parentSpan = context.scope ? context.scope.getSpan() : trace_getActiveSpan();
    var shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) {
        return undefined;
    }
    var scope = context.scope || (0,esm_exports/* getCurrentScope */.nZ)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    var temporaryScope = scope.clone();
    return createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function trace_getActiveSpan() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,esm_exports/* getCurrentScope */.nZ)().getSpan();
}
var continueTrace = function(param, callback) {
    var sentryTrace = param.sentryTrace, baggage = param.baggage;
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ var currentScope = getCurrentScope();
    // eslint-disable-next-line deprecation/deprecation
    var ref = tracingContextFromHeaders(sentryTrace, baggage), traceparentData = ref.traceparentData, dynamicSamplingContext = ref.dynamicSamplingContext, propagationContext = ref.propagationContext;
    currentScope.setPropagationContext(propagationContext);
    if (DEBUG_BUILD && traceparentData) {
        logger.log("[Tracing] Continuing trace ".concat(traceparentData.traceId, "."));
    }
    var transactionContext = _object_spread_props(_object_spread({}, traceparentData), {
        metadata: dropUndefinedKeys({
            dynamicSamplingContext: dynamicSamplingContext
        })
    });
    if (!callback) {
        return transactionContext;
    }
    return runWithAsyncContext(function() {
        return callback(transactionContext);
    });
};
function createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, param) {
    var parentSpan = param.parentSpan, spanContext = param.spanContext, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!hasTracingEnabled()) {
        return undefined;
    }
    var isolationScope = (0,esm_hub/* getIsolationScope */.aF)();
    var span;
    if (parentSpan && !forceTransaction) {
        // eslint-disable-next-line deprecation/deprecation
        span = parentSpan.startChild(spanContext);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(parentSpan);
        var ref = parentSpan.spanContext(), traceId = ref.traceId, parentSpanId = ref.spanId;
        var sampled = (0,spanUtils/* spanIsSampled */.Tt)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled
        }, spanContext), {
            metadata: (0,src_object_spread/* default */.Z)({
                dynamicSamplingContext: dsc
            }, spanContext.metadata)
        }));
    } else {
        var ref1 = (0,src_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = ref1.traceId, dsc1 = ref1.dsc, parentSpanId1 = ref1.parentSpanId, sampled1 = ref1.sampled;
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            traceId: traceId1,
            parentSpanId: parentSpanId1,
            parentSampled: sampled1
        }, spanContext), {
            metadata: (0,src_object_spread/* default */.Z)({
                dynamicSamplingContext: dsc1
            }, spanContext.metadata)
        }));
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function normalizeContext(context) {
    if (context.startTime) {
        var ctx = (0,src_object_spread/* default */.Z)({}, context);
        ctx.startTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.$k)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
var SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0,object/* addNonEnumerableProperty */.xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0,object/* addNonEnumerableProperty */.xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function getCapturedScopesOnSpan(span) {
    return {
        scope: span[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}
 //# sourceMappingURL=trace.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = "profile_id";
 //# sourceMappingURL=semanticAttributes.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(87143);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(41326);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/common/fetch.js






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var spanOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "auto.http.browser";
    if (!hasTracingEnabled() || !handlerData.fetchData) {
        return undefined;
    }
    var shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    var client = (0,esm_exports/* getClient */.s3)();
    var _fetchData = handlerData.fetchData, method = _fetchData.method, url = _fetchData.url;
    var fullUrl = getFullURL(url);
    var host = fullUrl ? url_parseUrl(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? startInactiveSpan({
        name: "".concat(method, " ").concat(url),
        onlyIfParent: true,
        attributes: (0,src_define_property/* default */.Z)({
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host
        }, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, spanOrigin),
        op: "http.client"
    }) : undefined;
    if (span1) {
        handlerData.fetchData.__span = span1.spanContext().spanId;
        spans[span1.spanContext().spanId] = span1;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        var request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span1);
    }
    return span1;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function addTracingHeadersToFetchRequest(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    var span = requestSpan || scope.getSpan();
    var isolationScope = (0,esm_hub/* getIsolationScope */.aF)();
    var ref = (0,src_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = ref.traceId, spanId = ref.spanId, sampled = ref.sampled, dsc = ref.dsc;
    var sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);
    var sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dsc || (span ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)));
    var headers = options.headers || (typeof Request !== "undefined" && (0,is/* isInstanceOf */.V9)(request, Request) ? request.headers : undefined);
    if (!headers) {
        return {
            "sentry-trace": sentryTraceHeader,
            baggage: sentryBaggageHeader
        };
    } else if (typeof Headers !== "undefined" && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
        var newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            // If the same header is appended multiple times the browser will merge the values into a single request header.
            // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
            newHeaders.append(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        var newHeaders1 = (0,src_to_consumable_array/* default */.Z)(headers).concat([
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ]);
        if (sentryBaggageHeader) {
            // If there are multiple entries with the same key, the browser will merge the values into a single request header.
            // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
            newHeaders1.push([
                baggage/* BAGGAGE_HEADER_NAME */.bU,
                sentryBaggageHeader
            ]);
        }
        return newHeaders1;
    } else {
        var existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        var newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) {
            var _newBaggageHeaders;
            (_newBaggageHeaders = newBaggageHeaders).push.apply(_newBaggageHeaders, (0,src_to_consumable_array/* default */.Z)(existingBaggageHeader));
        } else if (existingBaggageHeader) {
            newBaggageHeaders.push(existingBaggageHeader);
        }
        if (sentryBaggageHeader) {
            newBaggageHeaders.push(sentryBaggageHeader);
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, headers), {
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        });
    }
}
function getFullURL(url) {
    try {
        var parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        setHttpStatus(span, handlerData.response.status);
        var contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) {
                span.setAttribute("http.response_content_length", contentLengthNum);
            }
        }
    } else if (handlerData.error) {
        span.setStatus("internal_error");
    }
    span.end();
}
 //# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/common/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var common_debug_build_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
var bindReporter = function(callback, metric, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};
 //# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js

var types_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
 //# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var generateUniqueID = function() {
    return "v3-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
 //# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js

/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getNavigationEntryFromPerformanceTiming = function() {
    // eslint-disable-next-line deprecation/deprecation
    var timing = types_WINDOW.performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    var type = types_WINDOW.performance.navigation.type;
    var navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(var key in timing){
        if (key !== "navigationStart" && key !== "toJSON") {
            // eslint-disable-next-line deprecation/deprecation
            navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
        }
    }
    return navigationEntry;
};
var getNavigationEntry = function() {
    if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
        return types_WINDOW.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || getNavigationEntryFromPerformanceTiming());
    } else {
        return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    }
};
 //# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js

/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getActivationStart = function() {
    var navEntry = getNavigationEntry();
    return navEntry && navEntry.activationStart || 0;
};
 //# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var initMetric = function(name, value) {
    var navEntry = getNavigationEntry();
    var navigationType = "navigate";
    if (navEntry) {
        if (types_WINDOW.document && types_WINDOW.document.prerendering || getActivationStart() > 0) {
            navigationType = "prerender";
        } else {
            navigationType = navEntry.type.replace(/_/g, "-");
        }
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: generateUniqueID(),
        navigationType: navigationType
    };
};
 //# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var observe = function(type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};
 //# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var onHidden = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === "pagehide" || types_WINDOW.document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if (types_WINDOW.document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};
 //# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onCLS = function(onReport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = initMetric("CLS", 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                var firstSessionEntry = sessionEntries[0];
                var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) {
                        report();
                    }
                }
            }
        });
    };
    var po = observe("layout-shift", handleEntries);
    if (po) {
        report = bindReporter(onReport, metric, options.reportAllChanges);
        var stopListening = function() {
            handleEntries(po.takeRecords());
            report(true);
        };
        onHidden(stopListening);
        return stopListening;
    }
    return;
};
 //# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var firstHiddenTime = -1;
var initHiddenTime = function() {
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if (types_WINDOW.document && types_WINDOW.document.visibilityState) {
        firstHiddenTime = types_WINDOW.document.visibilityState === "hidden" && !types_WINDOW.document.prerendering ? 0 : Infinity;
    }
};
var trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    onHidden(function(param) {
        var timeStamp = param.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function() {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime () {
            return firstHiddenTime;
        }
    };
};
 //# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ var onFID = function(onReport) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric("FID");
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntry = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var handleEntries = function(entries) {
        entries.forEach(handleEntry);
    };
    var po = observe("first-input", handleEntries);
    report = bindReporter(onReport, metric);
    if (po) {
        onHidden(function() {
            handleEntries(po.takeRecords());
            po.disconnect();
        }, true);
    }
};
 //# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/polyfills/interactionCountPolyfill.js

var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
var updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ var getInteractionCount = function() {
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ var initInteractionCountPolyfill = function() {
    if ("interactionCount" in performance || po) return;
    po = observe("event", updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};
 //# sourceMappingURL=interactionCountPolyfill.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getINP.js





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ var getInteractionCountForNavigation = function() {
    return getInteractionCount();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
var longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
var longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ var processEntry = function(entry) {
    // The least-long of the 10 longest interactions.
    var minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var existingInteraction = longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            var interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            longestInteractionMap[interaction.id] = interaction;
            longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        longestInteractionList.sort(function(a, b) {
            return b.latency - a.latency;
        });
        longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(function(i) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ var estimateP98LongestInteraction = function() {
    var candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
    return longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onINP = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    initInteractionCountPolyfill();
    var metric = initMetric("INP");
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            if (entry.interactionId) {
                processEntry(entry);
            }
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                var noMatchingEntry = !longestInteractionList.some(function(interaction) {
                    return interaction.entries.some(function(prevEntry) {
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) {
                    processEntry(entry);
                }
            }
        });
        var inp = estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    var po = observe("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = bindReporter(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        onHidden(function() {
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};
 //# sourceMappingURL=getINP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ var onLCP = function(onReport) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric("LCP");
    var report;
    var handleEntries = function(entries) {
        var lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            var value = Math.max(lastEntry.startTime - getActivationStart(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    var po = observe("largest-contentful-paint", handleEntries);
    if (po) {
        report = bindReporter(onReport, metric);
        var stopListening = function() {
            if (!reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach(function(type) {
            if (types_WINDOW.document) {
                addEventListener(type, stopListening, {
                    once: true,
                    capture: true
                });
            }
        });
        onHidden(stopListening, true);
        return stopListening;
    }
    return;
};
 //# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/onTTFB.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ var whenReady = function(callback) {
    if (!types_WINDOW.document) {
        return;
    }
    if (types_WINDOW.document.prerendering) {
        addEventListener("prerenderingchange", function() {
            return whenReady(callback);
        }, true);
    } else if (types_WINDOW.document.readyState !== "complete") {
        addEventListener("load", function() {
            return whenReady(callback);
        }, true);
    } else {
        // Queue a task so the callback runs after `loadEventEnd`.
        setTimeout(callback, 0);
    }
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ var onTTFB = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    var metric = initMetric("TTFB");
    var report = bindReporter(onReport, metric, opts.reportAllChanges);
    whenReady(function() {
        var navEntry = getNavigationEntry();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - getActivationStart(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};
 //# sourceMappingURL=onTTFB.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js








var instrument_handlers = {};
var instrument_instrumented = {};
var _previousCls;
var _previousFid;
var _previousLcp;
var _previousTtfb;
var _previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function addClsInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver("cls", callback, instrumentCls, _previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function addLcpInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver("lcp", callback, instrumentLcp, _previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function addTtfbInstrumentationHandler(callback) {
    return addMetricObserver("ttfb", callback, instrumentTtfb, _previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addFidInstrumentationHandler(callback) {
    return addMetricObserver("fid", callback, instrumentFid, _previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addInpInstrumentationHandler(callback) {
    return addMetricObserver("inp", callback, instrumentInp, _previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addPerformanceInstrumentationHandler(type, callback) {
    instrument_addHandler(type, callback);
    if (!instrument_instrumented[type]) {
        instrumentPerformanceObserver(type);
        instrument_instrumented[type] = true;
    }
    return getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function instrument_triggerHandlers(type, data) {
    var typeHandlers = instrument_handlers[type];
    if (!typeHandlers || !typeHandlers.length) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                common_debug_build_DEBUG_BUILD && esm_logger/* logger.error */.kg.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0,stacktrace/* getFunctionName */.$P)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function instrumentCls() {
    return onCLS(function(metric) {
        instrument_triggerHandlers("cls", {
            metric: metric
        });
        _previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function instrumentFid() {
    return onFID(function(metric) {
        instrument_triggerHandlers("fid", {
            metric: metric
        });
        _previousFid = metric;
    });
}
function instrumentLcp() {
    return onLCP(function(metric) {
        instrument_triggerHandlers("lcp", {
            metric: metric
        });
        _previousLcp = metric;
    });
}
function instrumentTtfb() {
    return onTTFB(function(metric) {
        instrument_triggerHandlers("ttfb", {
            metric: metric
        });
        _previousTtfb = metric;
    });
}
function instrumentInp() {
    return onINP(function(metric) {
        instrument_triggerHandlers("inp", {
            metric: metric
        });
        _previousInp = metric;
    });
}
function addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    instrument_addHandler(type, callback);
    var stopListening;
    if (!instrument_instrumented[type]) {
        stopListening = instrumentFn();
        instrument_instrumented[type] = true;
    }
    if (previousValue) {
        callback({
            metric: previousValue
        });
    }
    return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
    var options = {};
    // Special per-type options we want to use
    if (type === "event") {
        options.durationThreshold = 0;
    }
    observe(type, function(entries) {
        instrument_triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function instrument_addHandler(type, handler) {
    instrument_handlers[type] = instrument_handlers[type] || [];
    instrument_handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) {
            stopListening();
        }
        var typeHandlers = instrument_handlers[type];
        if (!typeHandlers) {
            return;
        }
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) {
            typeHandlers.splice(index, 1);
        }
    };
}
 //# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js









/* eslint-disable max-lines */ var DEFAULT_TRACE_PROPAGATION_TARGETS = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
    tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS
};
/** Registers span creators for xhr and fetch requests  */ function instrumentOutgoingRequests(_options) {
    var ref = (0,src_object_spread/* default */.Z)({
        traceFetch: defaultRequestInstrumentationOptions.traceFetch,
        traceXHR: defaultRequestInstrumentationOptions.traceXHR
    }, _options), traceFetch = ref.traceFetch, traceXHR = ref.traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets = ref.tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins = ref.tracingOrigins, shouldCreateSpanForRequest = ref.shouldCreateSpanForRequest, enableHTTPTimings = ref.enableHTTPTimings;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    var shouldAttachHeadersWithTargets = function(url) {
        return shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);
    };
    var spans = {};
    if (traceFetch) {
        addFetchInstrumentationHandler(function(handlerData) {
            var createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                var fullUrl = request_getFullURL(handlerData.fetchData.url);
                var host = fullUrl ? url_parseUrl(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) {
                addHTTPTimings(createdSpan);
            }
        });
    }
    if (traceXHR) {
        addXhrInstrumentationHandler(function(handlerData) {
            var createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (enableHTTPTimings && createdSpan) {
                addHTTPTimings(createdSpan);
            }
        });
    }
}
function isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function addHTTPTimings(span) {
    var url = ((0,spanUtils/* spanToJSON */.XU)(span).data || {}).url;
    if (!url || typeof url !== "string") {
        return;
    }
    var cleanup = addPerformanceInstrumentationHandler("resource", function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                var _span;
                var spanData = resourceTimingEntryToSpanData(entry);
                spanData.forEach(function(data) {
                    return (_span = span).setAttribute.apply(_span, (0,src_to_consumable_array/* default */.Z)(data));
                });
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function extractNetworkProtocol(nextHopProtocol) {
    var name = "unknown";
    var version = "unknown";
    var _name = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            // http/1.1 etc.
            if (char === "/") {
                var ref;
                ref = (0,src_sliced_to_array/* default */.Z)(nextHopProtocol.split("/"), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(char))) {
                name = _name === "h" ? "http" : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) {
        // webrtc, ftp, etc.
        name = _name;
    }
    return {
        name: name,
        version: version
    };
}
function getAbsoluteTime() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}
function resourceTimingEntryToSpanData(resourceTiming) {
    var ref = extractNetworkProtocol(resourceTiming.nextHopProtocol), name = ref.name, version = ref.version;
    var timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
        return timingSpanData;
    }
    return (0,src_to_consumable_array/* default */.Z)(timingSpanData).concat([
        [
            "http.request.redirect_start",
            getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            getAbsoluteTime(resourceTiming.responseEnd)
        ], 
    ]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function shouldAttachHeaders(url, tracePropagationTargets) {
    return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];
    if (!hasTracingEnabled() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
        return undefined;
    }
    var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            setHttpStatus(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    var isolationScope = (0,esm_hub/* getIsolationScope */.aF)();
    var fullUrl = request_getFullURL(sentryXhrData.url);
    var host = fullUrl ? url_parseUrl(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? startInactiveSpan({
        name: "".concat(sentryXhrData.method, " ").concat(sentryXhrData.url),
        onlyIfParent: true,
        attributes: (0,src_define_property/* default */.Z)({
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host
        }, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.http.browser"),
        op: "http.client"
    }) : undefined;
    if (span1) {
        xhr.__sentry_xhr_span_id__ = span1.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span1;
    }
    var client = (0,esm_exports/* getClient */.s3)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        var ref = (0,src_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = ref.traceId, spanId1 = ref.spanId, sampled = ref.sampled, dsc = ref.dsc;
        var sentryTraceHeader = span1 ? (0,spanUtils/* spanToTraceHeader */.Hb)(span1) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId1, sampled);
        var sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dsc || (span1 ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span1) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)));
        setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span1;
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            xhr.setRequestHeader(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
        }
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function request_getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        var parsed = new URL(url, types_WINDOW.location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
 //# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/metric-summary.js






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ var SPAN_METRIC_SUMMARY;
function getMetricStorageForSpan(span) {
    return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function getMetricSummaryJsonForSpan(span) {
    var storage = getMetricStorageForSpan(span);
    if (!storage) {
        return undefined;
    }
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = storage[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), ref = (0,src_sliced_to_array/* default */.Z)(_value[1], 2), exportKey = ref[0], summary = ref[1];
            if (!output[exportKey]) {
                output[exportKey] = [];
            }
            output[exportKey].push((0,object/* dropUndefinedKeys */.Jr)(summary));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
    var span = getActiveSpan();
    if (span) {
        var storage = getMetricStorageForSpan(span) || new Map();
        var exportKey = "".concat(metricType, ":").concat(sanitizedName, "@").concat(unit);
        var bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            var _bucketItem = _sliced_to_array(bucketItem, 2), summary = _bucketItem[1];
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }, 
            ]);
        } else {
            storage.set(bucketKey, [
                exportKey,
                {
                    min: value,
                    max: value,
                    count: 1,
                    sum: value,
                    tags: tags
                }, 
            ]);
        }
        if (!SPAN_METRIC_SUMMARY) {
            SPAN_METRIC_SUMMARY = new WeakMap();
        }
        SPAN_METRIC_SUMMARY.set(span, storage);
    }
}
 //# sourceMappingURL=metric-summary.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(99586);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/span.js












/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var SpanRecorder = /*#__PURE__*/ function() {
    "use strict";
    function SpanRecorder() {
        var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0,_class_call_check/* default */.Z)(this, SpanRecorder);
        this._maxlen = maxlen;
        this.spans = [];
    }
    (0,_create_class/* default */.Z)(SpanRecorder, [
        {
            /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ key: "add",
            value: function add(span) {
                if (this.spans.length > this._maxlen) {
                    // eslint-disable-next-line deprecation/deprecation
                    span.spanRecorder = undefined;
                } else {
                    this.spans.push(span);
                }
            }
        }
    ]);
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var Span = /*#__PURE__*/ function() {
    "use strict";
    function Span() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_class_call_check/* default */.Z)(this, Span);
        this._traceId = spanContext.traceId || (0,misc/* uuid4 */.DM)();
        this._spanId = spanContext.spanId || (0,misc/* uuid4 */.DM)().substring(16);
        this._startTime = spanContext.startTimestamp || (0,esm_time/* timestampInSeconds */.ph)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? (0,src_object_spread/* default */.Z)({}, spanContext.tags) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? (0,src_object_spread/* default */.Z)({}, spanContext.data) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        var _obj;
        this.setAttributes((0,src_object_spread/* default */.Z)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, spanContext.origin || "manual"), (0,src_define_property/* default */.Z)(_obj, SEMANTIC_ATTRIBUTE_SENTRY_OP, spanContext.op), _obj), spanContext.attributes));
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) {
            this._parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ("sampled" in spanContext) {
            this._sampled = spanContext.sampled;
        }
        if (spanContext.status) {
            this._status = spanContext.status;
        }
        if (spanContext.endTimestamp) {
            this._endTime = spanContext.endTimestamp;
        }
        if (spanContext.exclusiveTime !== undefined) {
            this._exclusiveTime = spanContext.exclusiveTime;
        }
        this._measurements = spanContext.measurements ? (0,src_object_spread/* default */.Z)({}, spanContext.measurements) : {};
    }
    (0,_create_class/* default */.Z)(Span, [
        {
            key: "name",
            get: // This rule conflicts with another eslint rule :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name || "";
            },
            set: /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(name) {
                this.updateName(name);
            }
        },
        {
            key: "description",
            get: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(description) {
                this._name = description;
            }
        },
        {
            key: "traceId",
            get: /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ function get() {
                return this._traceId;
            },
            set: /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ function set(traceId) {
                this._traceId = traceId;
            }
        },
        {
            key: "spanId",
            get: /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ function get() {
                return this._spanId;
            },
            set: /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ function set(spanId) {
                this._spanId = spanId;
            }
        },
        {
            key: "parentSpanId",
            get: /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ function get() {
                return this._parentSpanId;
            },
            set: /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ function set(string) {
                this._parentSpanId = string;
            }
        },
        {
            key: "sampled",
            get: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ function get() {
                return this._sampled;
            },
            set: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ function set(sampled) {
                this._sampled = sampled;
            }
        },
        {
            key: "attributes",
            get: /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ function get() {
                return this._attributes;
            },
            set: /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ function set(attributes) {
                this._attributes = attributes;
            }
        },
        {
            key: "startTimestamp",
            get: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._startTime;
            },
            set: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ function set(startTime) {
                this._startTime = startTime;
            }
        },
        {
            key: "endTimestamp",
            get: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._endTime;
            },
            set: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ function set(endTime) {
                this._endTime = endTime;
            }
        },
        {
            key: "status",
            get: /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ function get() {
                return this._status;
            },
            set: /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ function set(status) {
                this._status = status;
            }
        },
        {
            key: "op",
            get: /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ function get() {
                return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP];
            },
            set: /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ function set(op) {
                this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, op);
            }
        },
        {
            key: "origin",
            get: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ function get() {
                return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
            },
            set: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ function set(origin) {
                this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, origin);
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var ref = this, spanId = ref._spanId, traceId = ref._traceId, sampled = ref._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? spanUtils/* TRACE_FLAG_SAMPLED */.i0 : spanUtils/* TRACE_FLAG_NONE */.ve
                };
            }
        },
        {
            /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startChild",
            value: function startChild(spanContext) {
                var childSpan = new Span((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, spanContext), {
                    parentSpanId: this._spanId,
                    sampled: this._sampled,
                    traceId: this._traceId
                }));
                // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder = this.spanRecorder;
                // eslint-disable-next-line deprecation/deprecation
                if (childSpan.spanRecorder) {
                    // eslint-disable-next-line deprecation/deprecation
                    childSpan.spanRecorder.add(childSpan);
                }
                var rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
                // TODO: still set span.transaction here until we have a more permanent solution
                // Probably similarly to the weakmap we hold in node-experimental
                // eslint-disable-next-line deprecation/deprecation
                childSpan.transaction = rootSpan;
                if (debug_build/* DEBUG_BUILD */.X && rootSpan) {
                    var opStr = spanContext && spanContext.op || "< unknown op >";
                    var nameStr = (0,spanUtils/* spanToJSON */.XU)(childSpan).description || "< unknown name >";
                    var idStr = rootSpan.spanContext().spanId;
                    var logMessage = "[Tracing] Starting '".concat(opStr, "' span on transaction '").concat(nameStr, "' (").concat(idStr, ").");
                    esm_logger/* logger.log */.kg.log(logMessage);
                    this._logMessage = logMessage;
                }
                return childSpan;
            }
        },
        {
            /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.tags), (0,src_define_property/* default */.Z)({}, key, value));
                return this;
            }
        },
        {
            /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setData",
            value: function setData(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.data), (0,src_define_property/* default */.Z)({}, key, value));
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._attributes[key];
                } else {
                    this._attributes[key] = value;
                }
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ key: "setHttpStatus",
            value: function setHttpStatus1(httpStatus) {
                setHttpStatus(this, httpStatus);
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ key: "setName",
            value: function setName(name) {
                this.updateName(name);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ key: "isSuccess",
            value: function isSuccess() {
                return this._status === "ok";
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ key: "finish",
            value: function finish(endTimestamp) {
                return this.end(endTimestamp);
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) {
                    return;
                }
                var rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
                if (debug_build/* DEBUG_BUILD */.X && // Don't call this for transactions
                rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
                    var logMessage = this._logMessage;
                    if (logMessage) {
                        esm_logger/* logger.log */.kg.log(logMessage.replace("Starting", "Finishing"));
                    }
                }
                this._endTime = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "toTraceparent",
            value: function toTraceparent() {
                return (0,spanUtils/* spanToTraceHeader */.Hb)(this);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ key: "toContext",
            value: function toContext() {
                return (0,object/* dropUndefinedKeys */.Jr)({
                    data: this._getData(),
                    description: this._name,
                    endTimestamp: this._endTime,
                    // eslint-disable-next-line deprecation/deprecation
                    op: this.op,
                    parentSpanId: this._parentSpanId,
                    sampled: this._sampled,
                    spanId: this._spanId,
                    startTimestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    traceId: this._traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ key: "updateWithContext",
            value: function updateWithContext(spanContext) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = spanContext.data || {};
                // eslint-disable-next-line deprecation/deprecation
                this._name = spanContext.name || spanContext.description;
                this._endTime = spanContext.endTimestamp;
                // eslint-disable-next-line deprecation/deprecation
                this.op = spanContext.op;
                this._parentSpanId = spanContext.parentSpanId;
                this._sampled = spanContext.sampled;
                this._spanId = spanContext.spanId || this._spanId;
                this._startTime = spanContext.startTimestamp || this._startTime;
                this._status = spanContext.status;
                // eslint-disable-next-line deprecation/deprecation
                this.tags = spanContext.tags || {};
                this._traceId = spanContext.traceId || this._traceId;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ key: "getTraceContext",
            value: function getTraceContext() {
                return (0,spanUtils/* spanToTraceContext */.wy)(this);
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return (0,object/* dropUndefinedKeys */.Jr)({
                    data: this._getData(),
                    description: this._name,
                    op: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                    _metrics_summary: getMetricSummaryJsonForSpan(this),
                    profile_id: this._attributes[SEMANTIC_ATTRIBUTE_PROFILE_ID],
                    exclusive_time: this._exclusiveTime,
                    measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
                });
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ key: "toJSON",
            value: function toJSON() {
                return this.getSpanJSON();
            }
        },
        {
            /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ key: "_getData",
            value: function _getData() {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this, data = ref.data, attributes = ref._attributes;
                var hasData = Object.keys(data).length > 0;
                var hasAttributes = Object.keys(attributes).length > 0;
                if (!hasData && !hasAttributes) {
                    return undefined;
                }
                if (hasData && hasAttributes) {
                    return (0,src_object_spread/* default */.Z)({}, data, attributes);
                }
                return hasData ? data : attributes;
            }
        }
    ]);
    return Span;
}();
 //# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js


















/** JSDoc */ var Transaction = /*#__PURE__*/ function(Span) {
    "use strict";
    (0,_inherits/* default */.Z)(Transaction, Span);
    var _super = (0,_create_super/* default */.Z)(Transaction);
    function Transaction(transactionContext, hub) {
        (0,_class_call_check/* default */.Z)(this, Transaction);
        var _this;
        _this = _super.call(this, transactionContext);
        _this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        _this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();
        _this._name = transactionContext.name || "";
        _this._metadata = (0,src_object_spread/* default */.Z)({}, transactionContext.metadata);
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        _this.transaction = (0,_assert_this_initialized/* default */.Z)(_this);
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        var incomingDynamicSamplingContext = _this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) {
            // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
            _this._frozenDynamicSamplingContext = (0,src_object_spread/* default */.Z)({}, incomingDynamicSamplingContext);
        }
        return _this;
    }
    (0,_create_class/* default */.Z)(Transaction, [
        {
            key: "name",
            get: // This sadly conflicts with the getter/setter ordering :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ function set(newName) {
                // eslint-disable-next-line deprecation/deprecation
                this.setName(newName);
            }
        },
        {
            key: "metadata",
            get: /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function get() {
                // We merge attributes in for backwards compatibility
                return (0,src_object_spread/* default */.Z)({
                    // Defaults
                    // eslint-disable-next-line deprecation/deprecation
                    source: "custom",
                    spanMetadata: {}
                }, this._metadata, this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                    source: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
                }, this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                    sampleRate: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
                });
            },
            set: /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function set(metadata) {
                this._metadata = metadata;
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ key: "setName",
            value: function setName(name) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "custom";
                this._name = name;
                this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source);
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ key: "initSpanRecorder",
            value: function initSpanRecorder() {
                var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new SpanRecorder(maxlen);
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ key: "setMeasurement",
            value: function setMeasurement(name, value) {
                var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                this._measurements[name] = {
                    value: value,
                    unit: unit
                };
            }
        },
        {
            /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ key: "setMetadata",
            value: function setMetadata(newMetadata) {
                this._metadata = (0,src_object_spread/* default */.Z)({}, this._metadata, newMetadata);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "end",
            value: function end(endTimestamp) {
                var timestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
                var transaction = this._finishTransaction(timestampInS);
                if (!transaction) {
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                return this._hub.captureEvent(transaction);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                // eslint-disable-next-line deprecation/deprecation
                var spanContext = _get((0,_get_prototype_of/* default */.Z)(Transaction.prototype), "toContext", this).call(this);
                return (0,object/* dropUndefinedKeys */.Jr)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, spanContext), {
                    name: this._name,
                    trimEnd: this._trimEnd
                }));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(transactionContext) {
                // eslint-disable-next-line deprecation/deprecation
                _get((0,_get_prototype_of/* default */.Z)(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
                this._name = transactionContext.name || "";
                this._trimEnd = transactionContext.trimEnd;
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ key: "getDynamicSamplingContext",
            value: function getDynamicSamplingContext() {
                return (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this);
            }
        },
        {
            /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setHub",
            value: function setHub(hub) {
                this._hub = hub;
            }
        },
        {
            /**
   * Get the profile id of the transaction.
   */ key: "getProfileId",
            value: function getProfileId() {
                if (this._contexts !== undefined && this._contexts["profile"] !== undefined) {
                    return this._contexts["profile"].profile_id;
                }
                return undefined;
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_finishTransaction",
            value: function _finishTransaction(endTimestamp) {
                var _this = this;
                // This transaction is already finished, so we should not flush it again.
                if (this._endTime !== undefined) {
                    return undefined;
                }
                if (!this._name) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
                    this._name = "<unlabeled transaction>";
                }
                // just sets the end timestamp
                _get((0,_get_prototype_of/* default */.Z)(Transaction.prototype), "end", this).call(this, endTimestamp);
                // eslint-disable-next-line deprecation/deprecation
                var client = this._hub.getClient();
                if (client && client.emit) {
                    client.emit("finishTransaction", this);
                }
                if (this._sampled !== true) {
                    // At this point if `sampled !== true` we want to discard the transaction.
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
                    if (client) {
                        client.recordDroppedEvent("sample_rate", "transaction");
                    }
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(span) {
                    return span !== _this && (0,spanUtils/* spanToJSON */.XU)(span).timestamp;
                }) : [];
                if (this._trimEnd && finishedSpans.length > 0) {
                    var endTimes = finishedSpans.map(function(span) {
                        return (0,spanUtils/* spanToJSON */.XU)(span).timestamp;
                    }).filter(Boolean);
                    this._endTime = endTimes.reduce(function(prev, current) {
                        return prev > current ? prev : current;
                    });
                }
                var ref = getCapturedScopesOnSpan(this), capturedSpanScope = ref.scope, capturedSpanIsolationScope = ref.isolationScope;
                // eslint-disable-next-line deprecation/deprecation
                var metadata = this.metadata;
                // eslint-disable-next-line deprecation/deprecation
                var source = metadata.source;
                var transaction = (0,src_object_spread/* default */.Z)({
                    contexts: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this._contexts), {
                        // We don't want to override trace context
                        trace: (0,spanUtils/* spanToTraceContext */.wy)(this)
                    }),
                    // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
                    spans: finishedSpans,
                    start_timestamp: this._startTime,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: "transaction",
                    sdkProcessingMetadata: (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, metadata), {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope
                    }), (0,object/* dropUndefinedKeys */.Jr)({
                        dynamicSamplingContext: (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this)
                    })),
                    _metrics_summary: getMetricSummaryJsonForSpan(this)
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var hasMeasurements = Object.keys(this._measurements).length > 0;
                if (hasMeasurements) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
                    transaction.measurements = this._measurements;
                }
                // eslint-disable-next-line deprecation/deprecation
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this._name, "."));
                return transaction;
            }
        }
    ]);
    return Transaction;
}(Span);
 //# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js












var TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
var FINISH_REASON_TAG = "finishReason";
var IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled", 
];
/**
 * @inheritDoc
 */ var IdleTransactionSpanRecorder = /*#__PURE__*/ function(SpanRecorder) {
    "use strict";
    (0,_inherits/* default */.Z)(IdleTransactionSpanRecorder, SpanRecorder);
    var _super = (0,_create_super/* default */.Z)(IdleTransactionSpanRecorder);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        (0,_class_call_check/* default */.Z)(this, IdleTransactionSpanRecorder);
        var _this;
        _this = _super.call(this, maxlen);
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    (0,_create_class/* default */.Z)(IdleTransactionSpanRecorder, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(span) {
                var _this = this;
                // We should make sure we do not push and pop activities for
                // the transaction that this span recorder belongs to.
                if (span.spanContext().spanId !== this.transactionSpanId) {
                    // We patch span.end() to pop an activity after setting an endTimestamp.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    var originalEnd = span.end;
                    span.end = function() {
                        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
                            rest[_key] = arguments[_key];
                        }
                        _this._popActivity(span.spanContext().spanId);
                        return originalEnd.apply(span, rest);
                    };
                    // We should only push new activities if the span does not have an end timestamp.
                    if ((0,spanUtils/* spanToJSON */.XU)(span).timestamp === undefined) {
                        this._pushActivity(span.spanContext().spanId);
                    }
                }
                _get((0,_get_prototype_of/* default */.Z)(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
            }
        }
    ]);
    return IdleTransactionSpanRecorder;
}(SpanRecorder);
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var IdleTransaction = /*#__PURE__*/ function(Transaction) {
    "use strict";
    (0,_inherits/* default */.Z)(IdleTransaction, Transaction);
    var _super = (0,_create_super/* default */.Z)(IdleTransaction);
    function IdleTransaction(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub) {
        var /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : TRACING_DEFAULTS.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : TRACING_DEFAULTS.finalTimeout, _heartbeatInterval = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : TRACING_DEFAULTS.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
        _onScope = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
        (0,_class_call_check/* default */.Z)(this, IdleTransaction);
        var _this;
        _this = _super.call(this, transactionContext, _idleHub);
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._finalTimeout = _finalTimeout;
        _this._heartbeatInterval = _heartbeatInterval;
        _this._onScope = _onScope;
        _this.activities = {};
        _this._heartbeatCounter = 0;
        _this._finished = false;
        _this._idleTimeoutCanceledPermanently = false;
        _this._beforeFinishCallbacks = [];
        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
        _this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("Setting idle transaction on scope. Span ID: ".concat(_this.spanContext().spanId));
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan((0,_assert_this_initialized/* default */.Z)(_this));
        }
        if (!delayAutoFinishUntilSignal) {
            _this._restartIdleTimeout();
        }
        setTimeout(function() {
            if (!_this._finished) {
                _this.setStatus("deadline_exceeded");
                _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
                _this.end();
            }
        }, _this._finalTimeout);
        return _this;
    }
    (0,_create_class/* default */.Z)(IdleTransaction, [
        {
            /** {@inheritDoc} */ key: "end",
            value: function end(endTimestamp) {
                var _this = this;
                var endTimestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
                this._finished = true;
                this.activities = {};
                // eslint-disable-next-line deprecation/deprecation
                if (this.op === "ui.action.click") {
                    this.setAttribute(FINISH_REASON_TAG, this._finishReason);
                }
                // eslint-disable-next-line deprecation/deprecation
                if (this.spanRecorder) {
                    debug_build/* DEBUG_BUILD */.X && // eslint-disable-next-line deprecation/deprecation
                    esm_logger/* logger.log */.kg.log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._beforeFinishCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            callback(this, endTimestampInS);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                        // If we are dealing with the transaction itself, we just return it
                        if (span.spanContext().spanId === _this.spanContext().spanId) {
                            return true;
                        }
                        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                        if (!(0,spanUtils/* spanToJSON */.XU)(span).timestamp) {
                            span.setStatus("cancelled");
                            span.end(endTimestampInS);
                            debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                        }
                        var ref = (0,spanUtils/* spanToJSON */.XU)(span), startTime = ref.start_timestamp, endTime = ref.timestamp;
                        var spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                        // Add a delta with idle timeout so that we prevent false positives
                        var timeoutWithMarginOfError = (_this._finalTimeout + _this._idleTimeout) / 1000;
                        var spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                        if (debug_build/* DEBUG_BUILD */.X) {
                            var stringifiedSpan = JSON.stringify(span, undefined, 2);
                            if (!spanStartedBeforeTransactionFinish) {
                                esm_logger/* logger.log */.kg.log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                            } else if (!spanEndedBeforeFinalTimeout) {
                                esm_logger/* logger.log */.kg.log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                            }
                        }
                        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
                    });
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] flushing IdleTransaction");
                } else {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] No active IdleTransaction");
                }
                // if `this._onScope` is `true`, the transaction put itself on the scope when it started
                if (this._onScope) {
                    // eslint-disable-next-line deprecation/deprecation
                    var scope = this._idleHub.getScope();
                    // eslint-disable-next-line deprecation/deprecation
                    if (scope.getTransaction() === this) {
                        // eslint-disable-next-line deprecation/deprecation
                        scope.setSpan(undefined);
                    }
                }
                return _get((0,_get_prototype_of/* default */.Z)(IdleTransaction.prototype), "end", this).call(this, endTimestamp);
            }
        },
        {
            /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ key: "registerBeforeFinishCallback",
            value: function registerBeforeFinishCallback(callback) {
                this._beforeFinishCallbacks.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "initSpanRecorder",
            value: function initSpanRecorder(maxlen) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    var pushActivity = function(id) {
                        if (_this._finished) {
                            return;
                        }
                        _this._pushActivity(id);
                    };
                    var popActivity = function(id) {
                        if (_this._finished) {
                            return;
                        }
                        _this._popActivity(id);
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);
                    // Start heartbeat so that transactions do not run forever.
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("Starting heartbeat");
                    this._pingHeartbeat();
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ key: "cancelIdleTimeout",
            value: function cancelIdleTimeout(endTimestamp) {
                var restartOnChildSpanChange = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    restartOnChildSpanChange: true
                }).restartOnChildSpanChange;
                this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
                if (this._idleTimeoutID) {
                    clearTimeout(this._idleTimeoutID);
                    this._idleTimeoutID = undefined;
                    if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.end(endTimestamp);
                    }
                }
            }
        },
        {
            /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ key: "setFinishReason",
            value: function setFinishReason(reason) {
                this._finishReason = reason;
            }
        },
        {
            /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ key: "sendAutoFinishSignal",
            value: function sendAutoFinishSignal() {
                if (!this._autoFinishAllowed) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Received finish signal for idle transaction.");
                    this._restartIdleTimeout();
                    this._autoFinishAllowed = true;
                }
            }
        },
        {
            /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ key: "_restartIdleTimeout",
            value: function _restartIdleTimeout(endTimestamp) {
                var _this = this;
                this.cancelIdleTimeout();
                this._idleTimeoutID = setTimeout(function() {
                    if (!_this._finished && Object.keys(_this.activities).length === 0) {
                        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
                        _this.end(endTimestamp);
                    }
                }, this._idleTimeout);
            }
        },
        {
            /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ key: "_pushActivity",
            value: function _pushActivity(spanId) {
                this.cancelIdleTimeout(undefined, {
                    restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
                });
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] pushActivity: ".concat(spanId));
                this.activities[spanId] = true;
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] new activities count", Object.keys(this.activities).length);
            }
        },
        {
            /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ key: "_popActivity",
            value: function _popActivity(spanId) {
                if (this.activities[spanId]) {
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] popActivity ".concat(spanId));
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.activities[spanId];
                    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] new activities count", Object.keys(this.activities).length);
                }
                if (Object.keys(this.activities).length === 0) {
                    var endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
                    if (this._idleTimeoutCanceledPermanently) {
                        if (this._autoFinishAllowed) {
                            this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                            this.end(endTimestamp);
                        }
                    } else {
                        // We need to add the timeout here to have the real endtimestamp of the transaction
                        // Remember timestampInSeconds is in seconds, timeout is in ms
                        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
                    }
                }
            }
        },
        {
            /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ key: "_beat",
            value: function _beat() {
                // We should not be running heartbeat if the idle transaction is finished.
                if (this._finished) {
                    return;
                }
                var heartbeatString = Object.keys(this.activities).join("");
                if (heartbeatString === this._prevHeartbeatString) {
                    this._heartbeatCounter++;
                } else {
                    this._heartbeatCounter = 1;
                }
                this._prevHeartbeatString = heartbeatString;
                if (this._heartbeatCounter >= 3) {
                    if (this._autoFinishAllowed) {
                        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Transaction finished because of no change for 3 heart beats");
                        this.setStatus("deadline_exceeded");
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
                        this.end();
                    }
                } else {
                    this._pingHeartbeat();
                }
            }
        },
        {
            /**
   * Pings the heartbeat
   */ key: "_pingHeartbeat",
            value: function _pingHeartbeat() {
                var _this = this;
                debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
                setTimeout(function() {
                    _this._beat();
                }, this._heartbeatInterval);
            }
        }
    ]);
    return IdleTransaction;
}(Transaction);
 //# sourceMappingURL=idletransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js



/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
    // eslint-disable-next-line deprecation/deprecation
    var scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ var extractTraceparentData = tracing/* extractTraceparentData */.qG;
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



var errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function registerErrorInstrumentation() {
    if (errorsInstrumented) {
        return;
    }
    errorsInstrumented = true;
    addGlobalErrorInstrumentationHandler(errorCallback);
    addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var status = "internal_error";
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Transaction: ".concat(status, " -> Global error occured"));
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = "sentry_tracingErrorCallback";
 //# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/sampling.js






/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function sampleTransaction(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!hasTracingEnabled(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
    } else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"));
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
        return transaction;
    }
    debug_build/* DEBUG_BUILD */.X && // eslint-disable-next-line deprecation/deprecation
    esm_logger/* logger.log */.kg.log("[Tracing] starting ".concat(transaction.op, " transaction - ").concat((0,spanUtils/* spanToJSON */.XU)(transaction).description));
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(rate)), "."));
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}
 //# sourceMappingURL=sampling.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js









/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    var scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    var span = scope.getSpan();
    return span ? {
        "sentry-trace": (0,spanUtils/* spanToTraceHeader */.Hb)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var configInstrumenter = options.instrumenter || "sentry";
    var transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error("A transaction was started with instrumenter=`".concat(transactionInstrumenter, "`, but the SDK is configured with the `").concat(configInstrumenter, "` instrumenter.\nThe transaction will not be sampled. Please use the ").concat(configInstrumenter, " instrumentation to start transactions."));
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new Transaction(transactionContext, this);
    transaction = sampleTransaction(transaction, options, (0,src_object_spread/* default */.Z)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0,src_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    if (client && client.emit) {
        client.emit("startTransaction", transaction);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    var delayAutoFinishUntilSignal = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    // eslint-disable-next-line deprecation/deprecation
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new IdleTransaction(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = sampleTransaction(transaction, options, (0,src_object_spread/* default */.Z)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0,src_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    if (client && client.emit) {
        client.emit("startTransaction", transaction);
    }
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function addTracingExtensions() {
    var carrier = (0,esm_hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
    registerErrorInstrumentation();
}
 //# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function registerBackgroundTabDetection() {
    if (types_WINDOW.document) {
        types_WINDOW.document.addEventListener("visibilitychange", function() {
            // eslint-disable-next-line deprecation/deprecation
            var activeTransaction = getActiveTransaction();
            if (types_WINDOW.document.hidden && activeTransaction) {
                var statusType = "cancelled";
                var ref = (0,spanUtils/* spanToJSON */.XU)(activeTransaction), op = ref.op, status = ref.status;
                common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Transaction: ".concat(statusType, " -> since tab moved to the background, op: ").concat(op));
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!status) {
                    activeTransaction.setStatus(statusType);
                }
                // TODO: Can we rewrite this to an attribute?
                // eslint-disable-next-line deprecation/deprecation
                activeTransaction.setTag("visibilitychange", "document.hidden");
                activeTransaction.end();
            }
        });
    } else {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Could not set up background tab detection due to lack of global document");
    }
}
 //# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/span.js

/**
 * Create envelope from Span item.
 */ function createSpanEnvelope(spans, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) {
        headers.dsn = dsn_dsnToString(dsn);
    }
    var items = spans.map(createSpanItem);
    return createEnvelope(headers, items);
}
function createSpanItem(span) {
    var spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}
 //# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/measurement.js

/**
 * Adds a measurement to the current active transaction.
 */ function setMeasurement(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    var transaction = getActiveTransaction();
    if (transaction) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMeasurement(name, value, unit);
    }
}
 //# sourceMappingURL=measurement.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */ 

function isMeasurementValue(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function _startChild(transaction, _param) {
    var startTimestamp = _param.startTimestamp, ctx = (0,_object_without_properties/* default */.Z)(_param, [
        "startTimestamp"
    ]);
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.startTimestamp = startTimestamp;
    }
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild((0,src_object_spread/* default */.Z)({
        startTimestamp: startTimestamp
    }, ctx));
}
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js









var MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function msToSec(time) {
    return time / 1000;
}
function getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}
var _performanceCursor = 0;
var _measurements = {};
var _lcpEntry;
var _clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function startTrackingWebVitals() {
    var performance = getBrowserPerformanceAPI();
    if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) {
            types_WINDOW.performance.mark("sentry-tracing-init");
        }
        var fidCallback = _trackFID();
        var clsCallback = _trackCLS();
        var lcpCallback = _trackLCP();
        var ttfbCallback = _trackTtfb();
        return function() {
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function startTrackingLongTasks() {
    addPerformanceInstrumentationHandler("longtask", function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = getActiveTransaction();
                if (!transaction) {
                    return;
                }
                var startTime = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
                var duration = msToSec(entry.duration);
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild({
                    description: "Main UI thread blocked",
                    op: "ui.long-task",
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking interaction events.
 */ function startTrackingInteractions() {
    addPerformanceInstrumentationHandler("event", function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = getActiveTransaction();
                if (!transaction) {
                    return;
                }
                if (entry.name === "click") {
                    var startTime = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
                    var duration = msToSec(entry.duration);
                    var span = {
                        description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        origin: "auto.ui.browser.metrics",
                        startTimestamp: startTime,
                        endTimestamp: startTime + duration
                    };
                    var componentName = (0,browser/* getComponentName */.iY)(entry.target);
                    if (componentName) {
                        span.attributes = {
                            "ui.component_name": componentName
                        };
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    transaction.startChild(span);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function startTrackingINP(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    var performance = getBrowserPerformanceAPI();
    if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
        var inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return function() {
            inpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function _trackCLS() {
    return addClsInstrumentationHandler(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding CLS");
        _measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        _clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function _trackLCP() {
    return addLcpInstrumentationHandler(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding LCP");
        _measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function _trackFID() {
    return addFidInstrumentationHandler(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        var timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);
        var startTime = msToSec(entry.startTime);
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding FID");
        _measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function _trackTtfb() {
    return addTtfbInstrumentationHandler(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
var INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function _trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return addInpInstrumentationHandler(function(param) {
        var metric = param.metric;
        if (metric.value === undefined) {
            return;
        }
        var entry = metric.entries.find(function(entry) {
            return entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined;
        });
        var client = (0,esm_exports/* getClient */.s3)();
        if (!entry || !client) {
            return;
        }
        var interactionType = INP_ENTRY_MAP[entry.name];
        var options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ var startTime = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
        var duration = msToSec(metric.value);
        var interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) {
            return;
        }
        var routeName = interaction.routeName, parentContext = interaction.parentContext, activeTransaction = interaction.activeTransaction, user = interaction.user, replayId = interaction.replayId;
        var userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        var span = new Span({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.".concat(interactionType),
            name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
            attributes: (0,src_object_spread/* default */.Z)({
                release: options.release,
                environment: options.environment,
                transaction: routeName
            }, userDisplay !== undefined && userDisplay !== "" ? {
                user: userDisplay
            } : {}, profileId !== undefined ? {
                profile_id: profileId
            } : {}, replayId !== undefined ? {
                replay_id: replayId
            } : {}),
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ var sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) {
            return;
        }
        if (Math.random() < sampleRate) {
            var envelope = span ? createSpanEnvelope([
                span
            ], client.getDsn()) : undefined;
            var transport = client && client.getTransport();
            if (transport && envelope) {
                transport.send(envelope).then(null, function(reason) {
                    common_debug_build_DEBUG_BUILD && esm_logger/* logger.error */.kg.error("Error while sending interaction:", reason);
                });
            }
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function addPerformanceEntries(transaction) {
    var performance = getBrowserPerformanceAPI();
    if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
        // Gatekeeper if performance API not available
        return;
    }
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Adding & adjusting spans using Performance API");
    var timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);
    var performanceEntries = performance.getEntries();
    var ref = (0,spanUtils/* spanToJSON */.XU)(transaction), op = ref.op, transactionStartTime = ref.start_timestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice(_performanceCursor).forEach(function(entry) {
        var startTime = msToSec(entry.startTime);
        var duration = msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
            return;
        }
        switch(entry.entryType){
            case "navigation":
                {
                    _addNavigationSpans(transaction, entry, timeOrigin);
                    break;
                }
            case "mark":
            case "paint":
            case "measure":
                {
                    _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding FP");
                        _measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding FCP");
                        _measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    _addResourceSpans(transaction, entry, entry.name, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    _performanceCursor = Math.max(performanceEntries.length - 1, 0);
    _trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        _addTtfbRequestTimeToMeasurements(_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach(function(name) {
            if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) {
                return;
            }
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = _measurements[name].value;
            var measurementTimestamp = timeOrigin + msToSec(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            var delta = normalizedValue - oldValue;
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Normalized ".concat(name, " from ").concat(oldValue, " to ").concat(normalizedValue, " (").concat(delta, ")"));
            _measurements[name].value = normalizedValue;
        });
        var fidMark = _measurements["mark.fid"];
        if (fidMark && _measurements["fid"]) {
            // create span for FID
            _startChild(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + msToSec(_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete _measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in _measurements)) {
            delete _measurements.cls;
        }
        Object.keys(_measurements).forEach(function(measurementName) {
            setMeasurement(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
        });
        _tagMetricInfo(transaction);
    }
    _lcpEntry = undefined;
    _clsEntry = undefined;
    _measurements = {};
}
/** Create measure related spans */ function _addMeasureSpans(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach(function(event) {
        _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    _addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    _addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    _addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    _addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function _addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry["".concat(event, "End")];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        _startChild(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + msToSec(entry.requestStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
        _startChild(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + msToSec(entry.responseStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function _addResourceSpans(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") {
        return;
    }
    var parsedUrl = url_parseUrl(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = {};
    setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) {
        data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    }
    if (parsedUrl.protocol) {
        data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    }
    if (parsedUrl.host) {
        data["server.address"] = parsedUrl.host;
    }
    data["url.same_origin"] = resourceUrl.includes(types_WINDOW.location.origin);
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceUrl.replace(types_WINDOW.location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource.".concat(entry.initiatorType) : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function _trackNavigator(transaction) {
    var navigator = types_WINDOW.navigator;
    if (!navigator) {
        return;
    }
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("effectiveConnectionType", connection.effectiveType);
        }
        if (connection.type) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("connectionType", connection.type);
        }
        if (isMeasurementValue(connection.rtt)) {
            _measurements["connection.rtt"] = {
                value: connection.rtt,
                unit: "millisecond"
            };
        }
    }
    if (isMeasurementValue(navigator.deviceMemory)) {
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("deviceMemory", "".concat(navigator.deviceMemory, " GB"));
    }
    if (isMeasurementValue(navigator.hardwareConcurrency)) {
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
/** Add LCP / CLS data to transaction to allow debugging */ function _tagMetricInfo(transaction) {
    if (_lcpEntry) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if (_lcpEntry.element) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.element", (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
        }
        if (_lcpEntry.id) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.id", _lcpEntry.id);
        }
        if (_lcpEntry.url) {
            // Trim URL to the first 200 characters.
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.url", _lcpEntry.url.trim().slice(0, 200));
        }
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", _lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (_clsEntry && _clsEntry.sources) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding CLS Data");
        _clsEntry.sources.forEach(function(source, index) {
            return(// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("cls.source.".concat(index + 1), (0,browser/* htmlTreeAsString */.Rt)(source.node)));
        });
    }
}
function setResourceEntrySizeData(data, entry, key, dataKey) {
    var entryVal = entry[key];
    if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
        data[dataKey] = entryVal;
    }
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function _addTtfbRequestTimeToMeasurements(_measurements) {
    var navEntry = getNavigationEntry();
    if (!navEntry) {
        return;
    }
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!hasTracingEnabled(options)) {
        return false;
    }
    var sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            transactionContext: transactionContext,
            name: transactionContext.name,
            parentSampled: transactionContext.parentSampled,
            attributes: (0,src_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes),
            location: types_WINDOW.location
        });
    } else if (transactionContext !== undefined && transactionContext.sampled !== undefined) {
        sampleRate = transactionContext.sampled;
    } else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
    } else {
        sampleRate = 1;
    }
    if (!isValidSampleRate(sampleRate)) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) {
        return interactionsSampleRate;
    } else if (sampleRate === false) {
        return 0;
    }
    return sampleRate * interactionsSampleRate;
}
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */ function instrumentRoutingWithDefaults(customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!types_WINDOW || !types_WINDOW.location) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    var startingUrl = types_WINDOW.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({
            name: types_WINDOW.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
            op: "pageload",
            origin: "auto.pageload.browser",
            metadata: {
                source: "url"
            }
        });
    }
    if (startTransactionOnLocationChange) {
        addHistoryInstrumentationHandler(function(param) {
            var to = param.to, from = param.from;
            /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op));
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.end();
                }
                activeTransaction = customStartTransaction({
                    name: types_WINDOW.location.pathname,
                    op: "navigation",
                    origin: "auto.navigation.browser",
                    metadata: {
                        source: "url"
                    }
                });
            }
        });
    }
}
 //# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js














var BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ var DEFAULT_BROWSER_TRACING_OPTIONS = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, TRACING_DEFAULTS), {
    markBackgroundTransactions: true,
    routingInstrumentation: instrumentRoutingWithDefaults,
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), defaultRequestInstrumentationOptions);
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ var BrowserTracing = /*#__PURE__*/ function() {
    "use strict";
    function BrowserTracing(_options) {
        (0,_class_call_check/* default */.Z)(this, BrowserTracing);
        this.name = BROWSER_TRACING_INTEGRATION_ID;
        this._hasSetTracePropagationTargets = false;
        addTracingExtensions();
        if (common_debug_build_DEBUG_BUILD) {
            this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
            (_options.tracePropagationTargets || _options.tracingOrigins));
        }
        this.options = (0,src_object_spread/* default */.Z)({}, DEFAULT_BROWSER_TRACING_OPTIONS, _options);
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) {
            this.options.enableLongTask = this.options._experiments.enableLongTask;
        }
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
            // eslint-disable-next-line deprecation/deprecation
            this.options.tracePropagationTargets = _options.tracingOrigins;
        }
        this._collectWebVitals = startTrackingWebVitals();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) {
            startTrackingINP(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        }
        if (this.options.enableLongTask) {
            startTrackingLongTasks();
        }
        if (this.options._experiments.enableInteractions) {
            startTrackingInteractions();
        }
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    (0,_create_class/* default */.Z)(BrowserTracing, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                var _this = this;
                this._getCurrentHub = getCurrentHub;
                var hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                var client = hub.getClient();
                var clientOptions = client && client.getOptions();
                var _options = this.options, instrumentRouting = _options.routingInstrumentation, startTransactionOnLocationChange = _options.startTransactionOnLocationChange, startTransactionOnPageLoad = _options.startTransactionOnPageLoad, markBackgroundTransactions = _options.markBackgroundTransactions, traceFetch = _options.traceFetch, traceXHR = _options.traceXHR, shouldCreateSpanForRequest = _options.shouldCreateSpanForRequest, enableHTTPTimings = _options.enableHTTPTimings, _experiments = _options._experiments;
                var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
                // There are three ways to configure tracePropagationTargets:
                // 1. via top level client option `tracePropagationTargets`
                // 2. via BrowserTracing option `tracePropagationTargets`
                // 3. via BrowserTracing option `tracingOrigins` (deprecated)
                //
                // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
                // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
                // This is done as it minimizes bundle size (we don't have to have undefined checks).
                //
                // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
                // eslint-disable-next-line deprecation/deprecation
                var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
                if (common_debug_build_DEBUG_BUILD && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
                    esm_logger/* logger.warn */.kg.warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
                }
                instrumentRouting(function(context) {
                    var transaction = _this._createRouteTransaction(context);
                    _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
                    return transaction;
                }, startTransactionOnPageLoad, startTransactionOnLocationChange);
                if (markBackgroundTransactions) {
                    registerBackgroundTabDetection();
                }
                if (_experiments.enableInteractions) {
                    this._registerInteractionListener();
                }
                if (this.options.enableInp) {
                    this._registerInpInteractionListener();
                }
                instrumentOutgoingRequests({
                    traceFetch: traceFetch,
                    traceXHR: traceXHR,
                    tracePropagationTargets: tracePropagationTargets,
                    shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                    enableHTTPTimings: enableHTTPTimings
                });
            }
        },
        {
            /** Create routing idle transaction. */ key: "_createRouteTransaction",
            value: function _createRouteTransaction(context) {
                var _this = this;
                if (!this._getCurrentHub) {
                    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(context.op, " transaction because _getCurrentHub is invalid."));
                    return undefined;
                }
                var hub = this._getCurrentHub();
                var _options = this.options, beforeNavigate = _options.beforeNavigate, idleTimeout = _options.idleTimeout, finalTimeout = _options.finalTimeout, heartbeatInterval = _options.heartbeatInterval;
                var isPageloadTransaction = context.op === "pageload";
                var expandedContext;
                if (isPageloadTransaction) {
                    var sentryTrace = isPageloadTransaction ? getMetaContent("sentry-trace") : "";
                    var baggage = isPageloadTransaction ? getMetaContent("baggage") : undefined;
                    var ref = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage), traceId = ref.traceId, dsc = ref.dsc, parentSpanId = ref.parentSpanId, sampled = ref.sampled;
                    expandedContext = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        traceId: traceId,
                        parentSpanId: parentSpanId,
                        parentSampled: sampled
                    }, context), {
                        metadata: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, context.metadata), {
                            dynamicSamplingContext: dsc
                        }),
                        trimEnd: true
                    });
                } else {
                    expandedContext = (0,src_object_spread/* default */.Z)({
                        trimEnd: true
                    }, context);
                }
                var modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
                // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
                // from being sent to Sentry).
                var finalContext = modifiedContext === undefined ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, expandedContext), {
                    sampled: false
                }) : modifiedContext;
                // If `beforeNavigate` set a custom name, record that fact
                // eslint-disable-next-line deprecation/deprecation
                finalContext.metadata = finalContext.name !== expandedContext.name ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, finalContext.metadata), {
                    source: "custom"
                }) : finalContext.metadata;
                this._latestRoute.name = finalContext.name;
                this._latestRoute.context = finalContext;
                // eslint-disable-next-line deprecation/deprecation
                if (finalContext.sampled === false) {
                    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
                }
                common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
                var location = types_WINDOW.location;
                var idleTransaction = startIdleTransaction(hub, finalContext, idleTimeout, finalTimeout, true, {
                    location: location
                }, heartbeatInterval, isPageloadTransaction);
                if (isPageloadTransaction) {
                    if (types_WINDOW.document) {
                        types_WINDOW.document.addEventListener("readystatechange", function() {
                            if ([
                                "interactive",
                                "complete"
                            ].includes(types_WINDOW.document.readyState)) {
                                idleTransaction.sendAutoFinishSignal();
                            }
                        });
                        if ([
                            "interactive",
                            "complete"
                        ].includes(types_WINDOW.document.readyState)) {
                            idleTransaction.sendAutoFinishSignal();
                        }
                    }
                }
                idleTransaction.registerBeforeFinishCallback(function(transaction) {
                    _this._collectWebVitals();
                    addPerformanceEntries(transaction);
                });
                return idleTransaction;
            }
        },
        {
            /** Start listener for interaction transactions */ key: "_registerInteractionListener",
            value: function _registerInteractionListener() {
                var _this = this;
                var inflightInteractionTransaction;
                var registerInteractionTransaction = function() {
                    var _options = _this.options, idleTimeout = _options.idleTimeout, finalTimeout = _options.finalTimeout, heartbeatInterval = _options.heartbeatInterval;
                    var op = "ui.action.click";
                    // eslint-disable-next-line deprecation/deprecation
                    var currentTransaction = getActiveTransaction();
                    if (currentTransaction && currentTransaction.op && [
                        "navigation",
                        "pageload"
                    ].includes(currentTransaction.op)) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
                        return undefined;
                    }
                    if (inflightInteractionTransaction) {
                        inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                        inflightInteractionTransaction.end();
                        inflightInteractionTransaction = undefined;
                    }
                    if (!_this._getCurrentHub) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because _getCurrentHub is invalid."));
                        return undefined;
                    }
                    if (!_this._latestRoute.name) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
                        return undefined;
                    }
                    var hub = _this._getCurrentHub();
                    var location = types_WINDOW.location;
                    var context = {
                        name: _this._latestRoute.name,
                        op: op,
                        trimEnd: true,
                        data: (0,src_define_property/* default */.Z)({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, _this._latestRoute.context ? getSource(_this._latestRoute.context) : "url")
                    };
                    inflightInteractionTransaction = startIdleTransaction(hub, context, idleTimeout, finalTimeout, true, {
                        location: location
                    }, heartbeatInterval);
                };
                [
                    "click"
                ].forEach(function(type) {
                    if (types_WINDOW.document) {
                        addEventListener(type, registerInteractionTransaction, {
                            once: false,
                            capture: true
                        });
                    }
                });
            }
        },
        {
            /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ key: "_registerInpInteractionListener",
            value: function _registerInpInteractionListener() {
                var _this = this;
                var handleEntries = function(param) {
                    var entries = param.entries;
                    var client = (0,esm_exports/* getClient */.s3)();
                    // We need to get the replay, user, and activeTransaction from the current scope
                    // so that we can associate replay id, profile id, and a user display to the span
                    var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
                    var replayId = replay !== undefined ? replay.getReplayId() : undefined;
                    // eslint-disable-next-line deprecation/deprecation
                    var activeTransaction = getActiveTransaction();
                    var currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
                    var user = currentScope !== undefined ? currentScope.getUser() : undefined;
                    entries.forEach(function(entry) {
                        if (isPerformanceEventTiming(entry)) {
                            var interactionId = entry.interactionId;
                            if (interactionId === undefined) {
                                return;
                            }
                            var existingInteraction = _this._interactionIdToRouteNameMapping[interactionId];
                            var duration = entry.duration;
                            var startTime = entry.startTime;
                            var keys = Object.keys(_this._interactionIdToRouteNameMapping);
                            var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                                return _this._interactionIdToRouteNameMapping[a].duration < _this._interactionIdToRouteNameMapping[b].duration ? a : b;
                            }) : undefined;
                            // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                            // This is also checked in the web-vitals library.
                            if (entry.entryType === "first-input") {
                                var matchingEntry = keys.map(function(key) {
                                    return _this._interactionIdToRouteNameMapping[key];
                                }).some(function(interaction) {
                                    return interaction.duration === duration && interaction.startTime === startTime;
                                });
                                if (matchingEntry) {
                                    return;
                                }
                            }
                            // Interactions with an id of 0 and are not first-input are not valid.
                            if (!interactionId) {
                                return;
                            }
                            // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                            if (existingInteraction) {
                                existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                            } else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > _this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                                // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                                var routeName = _this._latestRoute.name;
                                var parentContext = _this._latestRoute.context;
                                if (routeName && parentContext) {
                                    if (minInteractionId && Object.keys(_this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                                        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                        delete _this._interactionIdToRouteNameMapping[minInteractionId];
                                    }
                                    _this._interactionIdToRouteNameMapping[interactionId] = {
                                        routeName: routeName,
                                        duration: duration,
                                        parentContext: parentContext,
                                        user: user,
                                        activeTransaction: activeTransaction,
                                        replayId: replayId,
                                        startTime: startTime
                                    };
                                }
                            }
                        }
                    });
                };
                addPerformanceInstrumentationHandler("event", handleEntries);
                addPerformanceInstrumentationHandler("first-input", handleEntries);
            }
        }
    ]);
    return BrowserTracing;
}();
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0,browser/* getDomElement */.qT)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
 //# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js











var browserTracingIntegration_BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ var browserTracingIntegration_DEFAULT_BROWSER_TRACING_OPTIONS = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, TRACING_DEFAULTS), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ var browserTracingIntegration = function() {
    var _options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createRouteTransaction = /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        var hub = (0,esm_hub/* getCurrentHub */.Gd)();
        var beforeStartSpan = options.beforeStartSpan, idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var isPageloadTransaction = context.op === "pageload";
        var expandedContext;
        if (isPageloadTransaction) {
            var sentryTrace = isPageloadTransaction ? browserTracingIntegration_getMetaContent("sentry-trace") : "";
            var baggage = isPageloadTransaction ? browserTracingIntegration_getMetaContent("baggage") : undefined;
            var ref = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage), traceId = ref.traceId, dsc = ref.dsc, parentSpanId = ref.parentSpanId, sampled = ref.sampled;
            expandedContext = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled
            }, context), {
                metadata: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, context.metadata), {
                    dynamicSamplingContext: dsc
                }),
                trimEnd: true
            });
        } else {
            expandedContext = (0,src_object_spread/* default */.Z)({
                trimEnd: true
            }, context);
        }
        var finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, finalContext.metadata), {
            source: "custom"
        }) : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) {
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
        }
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
        var location = types_WINDOW.location;
        var idleTransaction = startIdleTransaction(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && types_WINDOW.document) {
            types_WINDOW.document.addEventListener("readystatechange", function() {
                if ([
                    "interactive",
                    "complete"
                ].includes(types_WINDOW.document.readyState)) {
                    idleTransaction.sendAutoFinishSignal();
                }
            });
            if ([
                "interactive",
                "complete"
            ].includes(types_WINDOW.document.readyState)) {
                idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback(function(transaction) {
            _collectWebVitals();
            addPerformanceEntries(transaction);
        });
        return idleTransaction;
    };
    var _hasSetTracePropagationTargets = common_debug_build_DEBUG_BUILD ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    addTracingExtensions();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) {
        // eslint-disable-next-line deprecation/deprecation
        _options.tracePropagationTargets = _options.tracingOrigins;
    }
    var options = (0,src_object_spread/* default */.Z)({}, browserTracingIntegration_DEFAULT_BROWSER_TRACING_OPTIONS, _options);
    var _collectWebVitals = startTrackingWebVitals();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ var interactionIdToRouteNameMapping = {};
    if (options.enableInp) {
        startTrackingINP(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    }
    if (options.enableLongTask) {
        startTrackingLongTasks();
    }
    if (options._experiments.enableInteractions) {
        startTrackingInteractions();
    }
    var latestRoute = {
        name: undefined,
        context: undefined
    };
    return {
        name: browserTracingIntegration_BROWSER_TRACING_INTEGRATION_ID,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: function() {},
        afterAllSetup: function afterAllSetup(client) {
            var clientOptions = client.getOptions();
            var markBackgroundSpan = options.markBackgroundSpan, traceFetch = options.traceFetch, traceXHR = options.traceXHR, shouldCreateSpanForRequest = options.shouldCreateSpanForRequest, enableHTTPTimings = options.enableHTTPTimings, _experiments = options._experiments;
            var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            var tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if (common_debug_build_DEBUG_BUILD && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
                esm_logger/* logger.warn */.kg.warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            }
            var activeSpan;
            var startingUrl = types_WINDOW.location && types_WINDOW.location.href;
            if (client.on) {
                client.on("startNavigationSpan", function(context) {
                    if (activeSpan) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: ".concat((0,spanUtils/* spanToJSON */.XU)(activeSpan).op));
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0,src_object_spread/* default */.Z)({
                        op: "navigation"
                    }, context));
                });
                client.on("startPageLoadSpan", function(context) {
                    if (activeSpan) {
                        common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: ".concat((0,spanUtils/* spanToJSON */.XU)(activeSpan).op));
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0,src_object_spread/* default */.Z)({
                        op: "pageload"
                    }, context));
                });
            }
            if (options.instrumentPageLoad && client.emit && types_WINDOW.location) {
                var context = {
                    name: types_WINDOW.location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: (0,src_define_property/* default */.Z)({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "url")
                };
                startBrowserTracingPageLoadSpan(client, context);
            }
            if (options.instrumentNavigation && client.emit && types_WINDOW.location) {
                addHistoryInstrumentationHandler(function(param) {
                    var to = param.to, from = param.from;
                    /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        var context = {
                            name: types_WINDOW.location.pathname,
                            origin: "auto.navigation.browser",
                            attributes: (0,src_define_property/* default */.Z)({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "url")
                        };
                        startBrowserTracingNavigationSpan(client, context);
                    }
                });
            }
            if (markBackgroundSpan) {
                registerBackgroundTabDetection();
            }
            if (_experiments.enableInteractions) {
                registerInteractionListener(options, latestRoute);
            }
            if (options.enableInp) {
                registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            }
            instrumentOutgoingRequests({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options: options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingPageLoadSpan(client, spanOptions) {
    if (!client.emit) {
        return;
    }
    client.emit("startPageLoadSpan", spanOptions);
    var span = trace_getActiveSpan();
    var op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingNavigationSpan(client, spanOptions) {
    if (!client.emit) {
        return;
    }
    client.emit("startNavigationSpan", spanOptions);
    var span = trace_getActiveSpan();
    var op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function browserTracingIntegration_getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0,browser/* getDomElement */.qT)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function registerInteractionListener(options, latestRoute) {
    var inflightInteractionTransaction;
    var registerInteractionTransaction = function() {
        var idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        var currentTransaction = getActiveTransaction();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
            return undefined;
        }
        var location = types_WINDOW.location;
        var context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: (0,src_define_property/* default */.Z)({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, latestRoute.context ? browserTracingIntegration_getSource(latestRoute.context) : "url")
        };
        inflightInteractionTransaction = startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
        (0,esm_hub/* getCurrentHub */.Gd)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach(function(type) {
        if (types_WINDOW.document) {
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        }
    });
}
function browserTracingIntegration_isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var browserTracingIntegration_MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    var handleEntries = function(param) {
        var entries = param.entries;
        var client = (0,esm_exports/* getClient */.s3)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        var replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var activeTransaction = getActiveTransaction();
        var currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
        var user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach(function(entry) {
            if (browserTracingIntegration_isPerformanceEventTiming(entry)) {
                var interactionId = entry.interactionId;
                if (interactionId === undefined) {
                    return;
                }
                var existingInteraction = interactionIdToRouteNameMapping[interactionId];
                var duration = entry.duration;
                var startTime = entry.startTime;
                var keys = Object.keys(interactionIdToRouteNameMapping);
                var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    var matchingEntry = keys.map(function(key) {
                        return interactionIdToRouteNameMapping[key];
                    }).some(function(interaction) {
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) {
                        return;
                    }
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) {
                    return;
                }
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) {
                    existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                } else if (keys.length < browserTracingIntegration_MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    var routeName = latestRoute.name;
                    var parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= browserTracingIntegration_MAX_INTERACTIONS) {
                            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete interactionIdToRouteNameMapping[minInteractionId];
                        }
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    addPerformanceInstrumentationHandler("event", handleEntries);
    addPerformanceInstrumentationHandler("first-input", handleEntries);
}
function browserTracingIntegration_getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
 //# sourceMappingURL=browserTracingIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/appRouterRoutingInstrumentation.js




var DEFAULT_TAGS = {
    "routing.instrumentation": "next-app-router"
};
/**
 * Instruments the Next.js Client App Router.
 */ // TODO(v8): Clean this function up by splitting into pageload and navigation instrumentation respectively. Also remove startTransactionCb in the process.
function appRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    // We keep track of the active transaction so we can finish it when we start a navigation transaction.
    var activeTransaction = undefined;
    // We keep track of the previous location name so we can set the `from` field on navigation transactions.
    // This is either a route or a pathname.
    var prevLocationName = helpers_WINDOW.location.pathname;
    if (startTransactionOnPageLoad) {
        var transactionContext = {
            name: prevLocationName,
            op: "pageload",
            origin: "auto.pageload.nextjs.app_router_instrumentation",
            tags: DEFAULT_TAGS,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
            metadata: {
                source: "url"
            }
        };
        activeTransaction = startTransactionCb(transactionContext);
        startPageloadSpanCallback(transactionContext);
    }
    if (startTransactionOnLocationChange) {
        addFetchInstrumentationHandler(function(handlerData) {
            // The instrumentation handler is invoked twice - once for starting a request and once when the req finishes
            // We can use the existence of the end-timestamp to filter out "finishing"-events.
            if (handlerData.endTimestamp !== undefined) {
                return;
            }
            // Only GET requests can be navigating RSC requests
            if (handlerData.fetchData.method !== "GET") {
                return;
            }
            var parsedNavigatingRscFetchArgs = parseNavigatingRscFetchArgs(handlerData.args);
            if (parsedNavigatingRscFetchArgs === null) {
                return;
            }
            var transactionName = parsedNavigatingRscFetchArgs.targetPathname;
            var tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_TAGS), {
                from: prevLocationName
            });
            prevLocationName = transactionName;
            if (activeTransaction) {
                activeTransaction.end();
            }
            var transactionContext = {
                name: transactionName,
                op: "navigation",
                origin: "auto.navigation.nextjs.app_router_instrumentation",
                tags: tags,
                metadata: {
                    source: "url"
                }
            };
            startTransactionCb(transactionContext);
            startNavigationSpanCallback(transactionContext);
        });
    }
}
function parseNavigatingRscFetchArgs(fetchArgs) {
    // Make sure the first arg is a URL object
    if (!fetchArgs[0] || typeof fetchArgs[0] !== "object" || fetchArgs[0].searchParams === undefined) {
        return null;
    }
    // Make sure the second argument is some kind of fetch config obj that contains headers
    if (!fetchArgs[1] || typeof fetchArgs[1] !== "object" || !("headers" in fetchArgs[1])) {
        return null;
    }
    try {
        var url = fetchArgs[0];
        var headers = fetchArgs[1].headers;
        // Not an RSC request
        if (headers["RSC"] !== "1") {
            return null;
        }
        // Prefetch requests are not navigating RSC requests
        if (headers["Next-Router-Prefetch"] === "1") {
            return null;
        }
        return {
            targetPathname: url.pathname
        };
    } catch (e) {
        return null;
    }
}
 //# sourceMappingURL=appRouterRoutingInstrumentation.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var esm_common_debug_build_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/pagesRouterRoutingInstrumentation.js







var globalObject = helpers_WINDOW;
/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */ function extractNextDataTagInformation() {
    var nextData;
    // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
    // Theoretically this should always be the case though.
    var nextDataTag = globalObject.document.getElementById("__NEXT_DATA__");
    if (nextDataTag && nextDataTag.innerHTML) {
        try {
            nextData = JSON.parse(nextDataTag.innerHTML);
        } catch (e) {
            esm_common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Could not extract __NEXT_DATA__");
        }
    }
    if (!nextData) {
        return {};
    }
    var nextDataTagInfo = {};
    var page = nextData.page, query = nextData.query, props = nextData.props;
    // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
    // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
    // parent transaction
    // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
    // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
    nextDataTagInfo.route = page;
    nextDataTagInfo.params = query;
    if (props && props.pageProps) {
        nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
        nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }
    return nextDataTagInfo;
}
var pagesRouterRoutingInstrumentation_DEFAULT_TAGS = {
    "routing.instrumentation": "next-pages-router"
};
// We keep track of the active transaction so we can finish it when we start a navigation transaction.
var activeTransaction = undefined;
// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
var prevLocationName = undefined;
var client = (0,esm_exports/* getClient */.s3)();
/**
 * Instruments the Next.js pages router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */ function pagesRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    var ref = extractNextDataTagInformation(), route = ref.route, params = ref.params, sentryTrace = ref.sentryTrace, baggage = ref.baggage;
    // eslint-disable-next-line deprecation/deprecation
    var ref1 = (0,tracing/* tracingContextFromHeaders */.KA)(sentryTrace, baggage), traceparentData = ref1.traceparentData, dynamicSamplingContext = ref1.dynamicSamplingContext, propagationContext = ref1.propagationContext;
    (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
    prevLocationName = route || globalObject.location.pathname;
    if (startTransactionOnPageLoad) {
        var source = route ? "route" : "url";
        var transactionContext = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: prevLocationName,
            op: "pageload",
            origin: "auto.pageload.nextjs.pages_router_instrumentation",
            tags: pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined
        }, params && client && client.getOptions().sendDefaultPii && {
            data: params
        }, traceparentData), {
            metadata: {
                source: source,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            }
        });
        activeTransaction = startTransactionCb(transactionContext);
        startPageloadSpanCallback(transactionContext);
    }
    if (startTransactionOnLocationChange) {
        router_default().events.on("routeChangeStart", function(navigationTarget) {
            var strippedNavigationTarget = stripUrlQueryAndFragment(navigationTarget);
            var matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);
            var transactionName;
            var transactionSource;
            if (matchedRoute) {
                transactionName = matchedRoute;
                transactionSource = "route";
            } else {
                transactionName = strippedNavigationTarget;
                transactionSource = "url";
            }
            var tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pagesRouterRoutingInstrumentation_DEFAULT_TAGS), {
                from: prevLocationName
            });
            prevLocationName = transactionName;
            if (activeTransaction) {
                activeTransaction.end();
            }
            var transactionContext = {
                name: transactionName,
                op: "navigation",
                origin: "auto.navigation.nextjs.pages_router_instrumentation",
                tags: tags,
                metadata: {
                    source: transactionSource
                }
            };
            var navigationTransaction = startTransactionCb(transactionContext);
            startNavigationSpanCallback(transactionContext);
            if (navigationTransaction) {
                // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
                // and `routeChangeComplete` events.
                // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
                // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
                // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
                // eslint-disable-next-line deprecation/deprecation
                var nextRouteChangeSpan = navigationTransaction.startChild({
                    op: "ui.nextjs.route-change",
                    origin: "auto.ui.nextjs.pages_router_instrumentation",
                    description: "Next.js Route Change"
                });
                var finishRouteChangeSpan = function() {
                    nextRouteChangeSpan.end();
                    router_default().events.off("routeChangeComplete", finishRouteChangeSpan);
                };
                router_default().events.on("routeChangeComplete", finishRouteChangeSpan);
            }
        });
    }
}
function getNextRouteFromPathname(pathname) {
    var pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;
    // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
    if (!pageRoutes) {
        return;
    }
    return pageRoutes.find(function(route) {
        var routeRegExp = convertNextRouteToRegExp(route);
        return pathname.match(routeRegExp);
    });
}
/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */ function convertNextRouteToRegExp(route) {
    // We can assume a route is at least "/".
    var routeParts = route.split("/");
    var optionalCatchallWildcardRegex = "";
    if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
        // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
        // slash that would come before it if we didn't pop it.
        routeParts.pop();
        optionalCatchallWildcardRegex = "(?:/(.+?))?";
    }
    var rejoinedRouteParts = routeParts.map(function(routePart) {
        return routePart.replace(/^\[\.\.\..+\]$/, "(.+?)") // Replace catch all wildcard with regex wildcard
        .replace(/^\[.*\]$/, "([^/]+?)");
    }).join("/");
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- routeParts are from the build manifest, so no raw user input
    return new RegExp("^".concat(rejoinedRouteParts).concat(optionalCatchallWildcardRegex, "(?:/)?$"));
}
 //# sourceMappingURL=pagesRouterRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/nextRoutingInstrumentation.js



/**
 * Instruments the Next.js Client Router.
 *
 * @deprecated Use `browserTracingIntegration()` as exported from `@sentry/nextjs` instead.
 */ function nextRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    var isAppRouter = !helpers_WINDOW.document.getElementById("__NEXT_DATA__");
    if (isAppRouter) {
        appRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange, startPageloadSpanCallback || function() {
            return undefined;
        }, startNavigationSpanCallback || function() {
            return undefined;
        });
    } else {
        pagesRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange, startPageloadSpanCallback || function() {
            return undefined;
        }, startNavigationSpanCallback || function() {
            return undefined;
        });
    }
}
 //# sourceMappingURL=nextRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/browserTracingIntegration.js








/**
 * A custom BrowserTracing integration for Next.js.
 *
 * @deprecated Use `browserTracingIntegration` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var browserTracingIntegration_BrowserTracing = /*#__PURE__*/ function(BrowserTracing$1) {
    "use strict";
    (0,_inherits/* default */.Z)(BrowserTracing, BrowserTracing$1);
    var _super = (0,_create_super/* default */.Z)(BrowserTracing);
    function BrowserTracing(options) {
        (0,_class_call_check/* default */.Z)(this, BrowserTracing);
        return _super.call(this, (0,src_object_spread/* default */.Z)({
            // eslint-disable-next-line deprecation/deprecation
            tracingOrigins:  false ? 0 : (0,src_to_consumable_array/* default */.Z)(defaultRequestInstrumentationOptions.tracingOrigins).concat([
                /^(api\/)/
            ]),
            // eslint-disable-next-line deprecation/deprecation
            routingInstrumentation: nextRouterInstrumentation
        }, options));
    }
    return BrowserTracing;
}(BrowserTracing);
/**
 * A custom BrowserTracing integration for Next.js.
 */ function browserTracingIntegration_browserTracingIntegration(options) {
    var browserTracingIntegrationInstance = browserTracingIntegration((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins:  false ? 0 : (0,src_to_consumable_array/* default */.Z)(defaultRequestInstrumentationOptions.tracingOrigins).concat([
            /^(api\/)/
        ])
    }, options), {
        instrumentNavigation: false,
        instrumentPageLoad: false
    }));
    var fullOptions = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, browserTracingIntegrationInstance.options), {
        instrumentPageLoad: true,
        instrumentNavigation: true
    }), options);
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, browserTracingIntegrationInstance), {
        options: fullOptions,
        afterAllSetup: function afterAllSetup(client) {
            var startPageloadCallback = function(startSpanOptions) {
                startBrowserTracingPageLoadSpan(client, startSpanOptions);
            };
            var startNavigationCallback = function(startSpanOptions) {
                startBrowserTracingNavigationSpan(client, startSpanOptions);
            };
            // We need to run the navigation span instrumentation before the `afterAllSetup` hook on the normal browser
            // tracing integration because we need to ensure the order of execution is as follows:
            // Instrumentation to start span on RSC fetch request runs -> Instrumentation to put tracing headers from active span on fetch runs
            // If it were the other way around, the RSC fetch request would not receive the tracing headers from the navigation transaction.
            // eslint-disable-next-line deprecation/deprecation
            nextRouterInstrumentation(function() {
                return undefined;
            }, false, fullOptions.instrumentNavigation, startPageloadCallback, startNavigationCallback);
            browserTracingIntegrationInstance.afterAllSetup(client);
            // eslint-disable-next-line deprecation/deprecation
            nextRouterInstrumentation(function() {
                return undefined;
            }, fullOptions.instrumentPageLoad, false, startPageloadCallback, startNavigationCallback);
        }
    });
}
 //# sourceMappingURL=browserTracingIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ 
function _optionalChain(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) {
            // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
            return;
        }
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0,src_to_consumable_array/* default */.Z)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
 //# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === ".") {
            parts.splice(i, 1);
        } else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for(; up--; up){
            parts.unshift("..");
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    var truncated = filename.length > 1024 ? "<truncated>".concat(filename.slice(-1024)) : filename;
    var parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var resolvedPath = "";
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = "".concat(path, "/").concat(resolvedPath);
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split("/").filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") {
            break;
        }
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ var fromParts = trim(from.split("/"));
    var toParts = trim(to.split("/"));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++){
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for(var i1 = samePartsLength; i1 < fromParts.length; i1++){
        outputParts.push("..");
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    var normalizedPath = normalizeArray(path.split("/").filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = ".";
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += "/";
    }
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function join() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return normalizePath(args.join("/"));
}
/** JSDoc */ function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return ".";
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.slice(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) {
        f = f.slice(0, f.length - ext.length);
    }
    return f;
}
 //# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js




var rewriteframes_INTEGRATION_NAME = "RewriteFrames";
var _rewriteFramesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _processExceptionsEvent = /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event), {
                exception: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0,src_object_spread/* default */.Z)({}, value, value.stacktrace && {
                            stacktrace: _processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    var _processStacktrace = /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return iteratee(f);
            })
        });
    };
    var root = options.root;
    var prefix = options.prefix || "app:///";
    var iteratee = options.iteratee || function(frame) {
        if (!frame.filename) {
            return frame;
        }
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        var startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            var base = root ? relative(root, filename) : basename(filename);
            frame.filename = "".concat(prefix).concat(base);
        }
        return frame;
    };
    return {
        name: rewriteframes_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(originalEvent) {
            var processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
                processedEvent = _processExceptionsEvent(processedEvent);
            }
            return processedEvent;
        }
    };
};
var rewriteFramesIntegration = defineIntegration(_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var RewriteFrames = convertIntegrationFnToClass(rewriteframes_INTEGRATION_NAME, rewriteFramesIntegration);
 //# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/rewriteFramesIntegration.js





var globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2;
var customRewriteFramesIntegration = function(options) {
    // This value is injected at build time, based on the output directory specified in the build config. Though a default
    // is set there, we set it here as well, just in case something has gone wrong with the injection.
    var assetPrefixPath = globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || "";
    return rewriteFramesIntegration((0,src_object_spread/* default */.Z)({
        // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
        iteratee: function(frame) {
            try {
                var origin = new URL(frame.filename).origin;
                frame.filename = _optionalChain([
                    frame,
                    "access",
                    function(_) {
                        return _.filename;
                    },
                    "optionalAccess",
                    function(_2) {
                        return _2.replace;
                    },
                    "call",
                    function(_3) {
                        return _3(origin, "app://");
                    },
                    "access",
                    function(_4) {
                        return _4.replace;
                    },
                    "call",
                    function(_5) {
                        return _5(assetPrefixPath, "");
                    }
                ]);
            } catch (err) {
            // Filename wasn't a properly formed URL, so there's nothing we can do
            }
            // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
            // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
            if (frame.filename && frame.filename.startsWith("app:///_next")) {
                frame.filename = decodeURI(frame.filename);
            }
            if (frame.filename && frame.filename.match(/^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/)) {
                // We don't care about these frames. It's Next.js internal code.
                frame.in_app = false;
            }
            return frame;
        }
    }, options));
};
var rewriteFramesIntegration_rewriteFramesIntegration = defineIntegration(customRewriteFramesIntegration);
 //# sourceMappingURL=rewriteFramesIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


var tunnelRoute_globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2;
/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */ function applyTunnelRouteOption(options) {
    var tunnelRouteOption = tunnelRoute_globalWithInjectedValues.__sentryRewritesTunnelPath__;
    if (tunnelRouteOption && options.dsn) {
        var dsnComponents = dsnFromString(options.dsn);
        if (!dsnComponents) {
            return;
        }
        var sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
        if (sentrySaasDsnMatch) {
            var orgId = sentrySaasDsnMatch[1];
            var regionCode = sentrySaasDsnMatch[2];
            var tunnelPath = "".concat(tunnelRouteOption, "?o=").concat(orgId, "&p=").concat(dsnComponents.projectId);
            if (regionCode) {
                tunnelPath += "&r=".concat(regionCode);
            }
            options.tunnel = tunnelPath;
            esm_common_debug_build_DEBUG_BUILD && esm_logger/* logger.info */.kg.info('Tunneling events to "'.concat(tunnelPath, '"'));
        } else {
            esm_common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.");
        }
    }
}
 //# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js





























/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var client_Integrations = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, INTEGRATIONS), {
    BrowserTracing: browserTracingIntegration_BrowserTracing
});
// Treeshakable guard to remove all code related to tracing
/** Inits the Sentry NextJS SDK on the browser with the React SDK. */ function client_init(options) {
    var opts = (0,src_object_spread/* default */.Z)({
        environment: getVercelEnv(true) || "production",
        defaultIntegrations: client_getDefaultIntegrations(options)
    }, options);
    fixBrowserTracingIntegration(opts);
    applyTunnelRouteOption(opts);
    applySdkMetadata(opts, "nextjs", [
        "nextjs",
        "react"
    ]);
    sdk_init(opts);
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    scope.setTag("runtime", "browser");
    var filterTransactions = function(event) {
        return event.type === "transaction" && event.transaction === "/404" ? null : event;
    };
    filterTransactions.id = "NextClient404Filter";
    scope.addEventProcessor(filterTransactions);
    if (false) {}
}
// TODO v8: Remove this again
// We need to handle BrowserTracing passed to `integrations` that comes from `@sentry/tracing`, not `@sentry/nextjs` :(
function fixBrowserTracingIntegration(options) {
    var integrations = options.integrations;
    if (!integrations) {
        return;
    }
    if (Array.isArray(integrations)) {
        options.integrations = maybeUpdateBrowserTracingIntegration(integrations);
    } else {
        options.integrations = function(defaultIntegrations) {
            var userFinalIntegrations = integrations(defaultIntegrations);
            return maybeUpdateBrowserTracingIntegration(userFinalIntegrations);
        };
    }
}
function isNewBrowserTracingIntegration(integration) {
    // eslint-disable-next-line deprecation/deprecation
    return !!integration.afterAllSetup && !!integration.options;
}
function maybeUpdateBrowserTracingIntegration(integrations) {
    var browserTracing = integrations.find(function(integration) {
        return integration.name === "BrowserTracing";
    });
    if (!browserTracing) {
        return integrations;
    }
    // If `browserTracingIntegration()` was added, we need to force-convert it to our custom one
    if (isNewBrowserTracingIntegration(browserTracing)) {
        var options = browserTracing.options;
        // eslint-disable-next-line deprecation/deprecation
        integrations[integrations.indexOf(browserTracing)] = browserTracingIntegration_browserTracingIntegration(options);
    }
    // If BrowserTracing was added, but it is not our forked version,
    // replace it with our forked version with the same options
    // eslint-disable-next-line deprecation/deprecation
    if (!(0,_instanceof/* default */.Z)(browserTracing, browserTracingIntegration_BrowserTracing)) {
        // eslint-disable-next-line deprecation/deprecation
        var options1 = browserTracing.options;
        // This option is overwritten by the custom integration
        delete options1.routingInstrumentation;
        // eslint-disable-next-line deprecation/deprecation
        delete options1.tracingOrigins;
        // eslint-disable-next-line deprecation/deprecation
        integrations[integrations.indexOf(browserTracing)] = new browserTracingIntegration_BrowserTracing(options1);
    }
    return integrations;
}
function client_getDefaultIntegrations(options) {
    var customDefaultIntegrations = (0,src_to_consumable_array/* default */.Z)(getDefaultIntegrations(options)).concat([
        rewriteFramesIntegration_rewriteFramesIntegration()
    ]);
    // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
    // will get treeshaken away
    if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) {
        if (hasTracingEnabled(options)) {
            customDefaultIntegrations.push(browserTracingIntegration_browserTracingIntegration());
        }
    }
    return customDefaultIntegrations;
}
/**
 * Just a passthrough in case this is imported from the client.
 */ function withSentryConfig(exportedUserNextConfig) {
    return exportedUserNextConfig;
}
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var sentry_client_config_process = __webpack_require__(83454);
var _sentryCollisionFreeGlobalObject =  true ? window : 0;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "t_PgJRKbEShpxA8PIkBsb"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/


var SENTRY_DSN = sentry_client_config_process.env.SENTRY_DSN || "https://5588cbf1b0ef4f9489671a6ed0788898@o1279780.ingest.sentry.io/6741289";
var SAMPLE_RATE = 0.05;
client_init({
    enabled: false,
    environment: "production",
    release: "".concat("production", "@").concat("368da37a11d6da03acc7c082f853701b742834ef" || 0),
    beforeSend: function beforeSend(event, hint) {
        var originalException = hint.originalException;
        if (typeof originalException === "string" && originalException.indexOf("this error can be safely ignored") >= 0) {
            return null;
        }
        return event;
    },
    dsn: SENTRY_DSN || "https://a5467526c0e04a9e9ceefd6f9775fd33@o1279780.ingest.sentry.io/6511491",
    // Adjust this value in production, or use tracesSampler for greater control
    sampleRate: SAMPLE_RATE,
    tracesSampler: function(samplingContext) {
        if (false) {} else {
            if (false) {}
            if (!samplingContext.location.href.includes("https://guru.kemdikbud.go.id")) {
                return false;
            }
            return 0.0002;
        }
    }
});


/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/pelatihan-mandiri/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 76907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(55086);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx + 1 modules
var useFeatureFlagContext = __webpack_require__(66578);
// EXTERNAL MODULE: ./utils/hooks/context/useScreenSizeContext.tsx + 1 modules
var useScreenSizeContext = __webpack_require__(65260);
// EXTERNAL MODULE: ./utils/auth/index.tsx + 4 modules
var auth = __webpack_require__(23475);
// EXTERNAL MODULE: ./utils/androidHandler.ts
var utils_androidHandler = __webpack_require__(84494);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx + 5 modules
var Layout_Layout = __webpack_require__(80079);
// EXTERNAL MODULE: ./components/ErrorBoundary/index.tsx + 2 modules
var ErrorBoundary = __webpack_require__(71130);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./utils/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(212);
// EXTERNAL MODULE: ./configs/auth.ts
var configs_auth = __webpack_require__(32178);
;// CONCATENATED MODULE: ./utils/hooks/useTechDebtStoreUserId.ts
// Why?:
//   This hooks is only used in pages/_app.tsx, and the purpose is
//   to store user id from both legacy apps and newer apps.
//   The stored user id is being used all over assessment's related features
//   for event tracking.
// When to remove?:
//   Legacy app version that still uses access token has been deprecated.





function useTechDebtStoreUserId() {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(configs_auth/* USER_ID_STORAGE_KEY */.dV, null), 2), userId = ref[0], setUserId = ref[1];
    var androidUserId = (androidHandler === null || androidHandler === void 0 ? void 0 : androidHandler.enabled) ? androidHandler === null || androidHandler === void 0 ? void 0 : androidHandler.getUserId() : null;
    (0,react.useEffect)(function() {
        setUserId(androidUserId);
    }, [
        androidUserId,
        userId,
        setUserId
    ]);
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/MetaTags/MetaTags.tsx


var MetaTags = function(param) {
    var metaTags = param.metaTags, pageTitle = param.pageTitle, pageDescription = param.pageDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            !!pageTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            !!pageDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: pageDescription
            }),
            !!metaTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    Object.entries(metaTags).map(function(entry) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: entry[0],
                            name: entry[0].replace(/(.*)-/, ""),
                            content: entry[1].toString()
                        }, entry[0]);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MetaTags_MetaTags = ((/* unused pure expression or super */ null && (MetaTags)));

;// CONCATENATED MODULE: ./components/MetaTags/index.ts


// EXTERNAL MODULE: ./node_modules/@wartek-id/design-tokens/build/guru-mobile/css/color.css
var color = __webpack_require__(89833);
// EXTERNAL MODULE: ./node_modules/@wartek-id/design-tokens/build/guru-mobile/css/font.css
var font = __webpack_require__(42338);
// EXTERNAL MODULE: ./node_modules/@wartek-id/design-tokens/build/guru-mobile/css/size.css
var size = __webpack_require__(52765);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(16703);
// EXTERNAL MODULE: ./styles/global.css
var global = __webpack_require__(67284);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
;// CONCATENATED MODULE: ./pages/_app.tsx






















var STATIC_PAGES = [
    "/"
];
(0,utils_androidHandler/* createAndroidAuthDataCallback */.p_)();
var queryClient = new es.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});
if (false) { var mockServer; }
var App = function(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    var _Layout;
    var Layout = (_Layout = Component.Layout) !== null && _Layout !== void 0 ? _Layout : Layout_Layout/* Layout */.A;
    var ref = (0,useScreenSizeContext/* useScreenSizeContext */.fl)(), isDesktopScreenSize = ref.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Component.layoutOpts), {
        children: /*#__PURE__*/ (0,react.createElement)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
            isDesktopScreenSize: isDesktopScreenSize,
            key: router.route
        }))
    }));
};
var AppProvider = function(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    useTechDebtStoreUserId();
    react.useEffect(function() {
        dist_history/* storeAppInitialPath */.sF();
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
    }, []);
    if (STATIC_PAGES.includes(router.pathname)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ToastProvider */.VW, {
            autoDismiss: true,
            placement: "top-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
                client: queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {
                    Component: Component,
                    pageProps: pageProps,
                    router: router
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ToastProvider */.VW, {
        autoDismiss: true,
        placement: "top-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es.QueryClientProvider, {
            client: queryClient,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags, {
                    metaTags: pageProps.metaTags,
                    pageTitle: pageProps.pageTitle,
                    pageDescription: pageProps.pageDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* AuthProvider */.Ho, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                        resetKeys: [
                            router.asPath
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* ProtectedRoutes */.Z4, {
                            router: router,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useFeatureFlagContext/* WithFeatureFlagContext */.B_, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useScreenSizeContext/* WithScreenSizeContext */.wz, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {
                                        Component: Component,
                                        pageProps: pageProps,
                                        router: router
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var _app = (AppProvider);


/***/ }),

/***/ 84494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ androidHandler; },
/* harmony export */   "p_": function() { return /* binding */ createAndroidAuthDataCallback; }
/* harmony export */ });
/* unused harmony export getVersion */
function createAndroidAuthDataCallback() {
    if ( true && window.AndroidHandler) {
        window.resolveGetAuthData = null;
        window.rejectGetAuthData = null;
        window.getAuthDataSuccess = function(response) {
            var data = JSON.parse(response).data;
            if (window.resolveGetAuthData) {
                window.resolveGetAuthData(data);
                window.resolveGetAuthData = null;
            }
            // eslint-disable-next-line
            console.log("auth-data", JSON.stringify(data));
        };
        window.getAuthDataError = function(error) {
            if (window.rejectGetAuthData) {
                window.rejectGetAuthData(error);
                window.rejectGetAuthData = null;
            }
            // eslint-disable-next-line
            console.log("auth-data-error", error);
        };
    }
}
function getVersion() {
    var originalUserAgent = window.navigator.userAgent;
    var prefix = "androidmobile PMM/";
    var version = 0;
    if (originalUserAgent.includes(prefix)) {
        version = Number(originalUserAgent.split(prefix).join("").split(" ")[0]);
    }
    return version;
}
function androidHandler() {
    if ( true && window.AndroidHandler) {
        var ref;
        return {
            enabled: true,
            guruTokenEnabled: !!window.AndroidHandler.getAuthData,
            getVersion: getVersion,
            getAuthToken: function() {
                return window.AndroidHandler.getAuthToken();
            },
            getServerAuthCode: function() {
                return window.AndroidHandler.getServerAuthCode();
            },
            requestAccessToken: function() {
                return window.AndroidHandler.requestAccessToken();
            },
            getEmail: function() {
                return window.AndroidHandler.getEmail();
            },
            getUser: function() {
                return window.AndroidHandler.getUser();
            },
            getUserId: function() {
                var ref1, ref2;
                return (ref = (ref1 = window.AndroidHandler) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getUserId) === null || ref2 === void 0 ? void 0 : ref2.call(ref1)) !== null && ref !== void 0 ? ref : null;
            },
            refreshToken: function() {
                return window.AndroidHandler.refreshToken();
            },
            backToApp: function() {
                return window.AndroidHandler.backToApp();
            },
            shareToolkitUrl: function(textToCopy) {
                return window.AndroidHandler.shareToolkitUrl(textToCopy);
            },
            getAuthData: function() {
                var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                window.AndroidHandler.getAuthData(refresh);
                return new Promise(function(resolve, reject) {
                    window.resolveGetAuthData = resolve;
                    window.rejectGetAuthData = reject;
                });
            },
            requestLogin: function() {
                return window.AndroidHandler.requestLogin();
            }
        };
    }
    return {
        enabled: false,
        guruTokenEnabled: false,
        getVersion: getVersion,
        getAuthToken: null,
        getServerAuthCode: null,
        requestAccessToken: null,
        getEmail: null,
        getUser: null,
        getUserId: null,
        refreshToken: null,
        backToApp: null,
        shareToolkitUrl: null,
        getAuthData: null,
        requestLogin: null
    };
}


/***/ }),

/***/ 23475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* binding */ auth_AuthProvider; },
  "Z4": function() { return /* binding */ ProtectedRoutes; },
  "Gg": function() { return /* binding */ auth_getSession; },
  "Y9": function() { return /* binding */ setAuthToAPI; },
  "aC": function() { return /* binding */ useAuth; },
  "pL": function() { return /* binding */ auth_useAuthProvider; }
});

// UNUSED EXPORTS: login, useTriggerOrLogin

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/androidHandler.ts
var utils_androidHandler = __webpack_require__(84494);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(32407);
// EXTERNAL MODULE: ./components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(8008);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./utils/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(212);
// EXTERNAL MODULE: ./utils/process.ts
var process = __webpack_require__(88265);
// EXTERNAL MODULE: ./configs/auth.ts
var auth = __webpack_require__(32178);
;// CONCATENATED MODULE: ./utils/auth/useAppAuth.tsx













var AuthContextDefaultValue = {
    session: null,
    login: function() {},
    loginScriptIsLoaded: true,
    logout: function() {},
    validateTokenError: null,
    lastUsedEmailDomain: null,
    error: null
};
var AuthContext = /*#__PURE__*/ react.createContext(AuthContextDefaultValue);
AuthContext.displayName = "AuthContext";
function useAuthProvider() {
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref = useValidateToken(), run = ref.run, session = ref.session, status = ref.status, error = ref.error, resetSession = ref.resetSession;
    react.useEffect(function() {
        resetSession();
        if (immediate) {
            run();
        }
    // eslint-disable-next-line
    }, []);
    return {
        session: session,
        login: run,
        loginScriptIsLoaded: true,
        logout: resetSession,
        status: status,
        error: null,
        validateTokenError: error,
        resetSession: resetSession,
        lastUsedEmailDomain: null
    };
}
function AuthProvider(props) {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var ref = useAuthProvider(), session = ref.session, login = ref.login, loginScriptIsLoaded = ref.loginScriptIsLoaded, logout = ref.logout, status = ref.status, error = ref.error, validateTokenError = ref.validateTokenError, lastUsedEmailDomain = ref.lastUsedEmailDomain;
    var value = react.useMemo(function() {
        return {
            session: session,
            login: login,
            loginScriptIsLoaded: loginScriptIsLoaded,
            logout: logout,
            validateTokenError: validateTokenError,
            lastUsedEmailDomain: lastUsedEmailDomain
        };
    }, [
        session,
        login,
        loginScriptIsLoaded,
        logout,
        validateTokenError,
        lastUsedEmailDomain, 
    ]);
    if ([
        "idle",
        "loading"
    ].includes(status)) {
        return null;
    }
    if (status === "success") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, (0,_object_spread/* default */.Z)({
            value: value
        }, props));
    }
    if (error || status === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* LayoutWithHeader */.d, {
            title: "",
            onClickBack: function() {
                return androidHandler.backToApp();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                title: "Gagal Login",
                description: "Ada kesalahan pada sistem.\n".concat(error || validateTokenError),
                className: "h-screen",
                withHeader: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                    onClick: login,
                    children: "Coba Lagi"
                })
            })
        });
    }
    throw new Error("Unhandled states of AuthProvider component");
}
function useValidateToken() {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var ref = (0,src_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(auth/* APP_LOGIN_STORAGE_KEY */.zy, null), 3), storedSession = ref[0], setSession = ref[1], removeSession = ref[2];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState("idle"), 2), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), error = ref2[0], setError = ref2[1];
    var run = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var validateToken, ref, ref1, session, ref2, ref3, userId, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStatus("loading");
                        validateToken = androidHandler.guruTokenEnabled ? validateGuruToken : validateAccessToken;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            validateToken()
                        ];
                    case 2:
                        session = _state.sent();
                        if (!!session) {
                            setSession(session);
                        }
                        userId = (ref3 = (ref2 = storedSession === null || storedSession === void 0 ? void 0 : (ref = storedSession.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : null;
                        if (userId) {
                            (0,esm_exports/* setUser */.av)({
                                id: userId
                            });
                        }
                        setStatus("success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        setStatus("error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function run() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetSession = function() {
        (0,esm_exports/* setUser */.av)(null);
        removeSession();
        setStatus("idle");
    };
    return {
        run: run,
        session: storedSession,
        status: status,
        error: error,
        resetSession: resetSession
    };
}
function validateGuruToken() {
    return _validateGuruToken.apply(this, arguments);
}
function _validateGuruToken() {
    _validateGuruToken = (0,_async_to_generator/* default */.Z)(function() {
        var ref, androidHandler, authData, isLogin, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    androidHandler = (0,utils_androidHandler/* default */.ZP)();
                    return [
                        4,
                        androidHandler.getAuthData()
                    ];
                case 1:
                    authData = _state.sent();
                    isLogin = !!(authData === null || authData === void 0 ? void 0 : (ref = authData.user) === null || ref === void 0 ? void 0 : ref.id);
                    if (!isLogin) return [
                        3,
                        4
                    ];
                    if (!(androidHandler.getVersion() < 10800)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        androidHandler.getAuthData(true)
                    ];
                case 2:
                    authData = _state.sent();
                    _state.label = 3;
                case 3:
                    if (!authData) {
                        ;
                        androidHandler === null || androidHandler === void 0 ? void 0 : (ref1 = androidHandler.backToApp) === null || ref1 === void 0 ? void 0 : ref1.call(androidHandler);
                    }
                    return [
                        2,
                        {
                            accessToken: "",
                            tokenType: "Bearer",
                            expiryToken: authData.expiredAt,
                            refreshToken: "dummy-refresh-token",
                            email: authData.user.email,
                            guruToken: authData.guruToken,
                            expiredAt: authData.expiredAt,
                            user: authData.user
                        }
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _validateGuruToken.apply(this, arguments);
}
function validateAccessToken() {
    return _validateAccessToken.apply(this, arguments);
}
function _validateAccessToken() {
    _validateAccessToken = (0,_async_to_generator/* default */.Z)(function() {
        var androidHandler, isLogin, accessToken, expiry, user, _groups;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    androidHandler = (0,utils_androidHandler/* default */.ZP)();
                    isLogin = !!androidHandler.getUserId();
                    if (!isLogin) return [
                        3,
                        2
                    ];
                    androidHandler.refreshToken();
                    return [
                        4,
                        (0,process/* timeout */.V)(1000)
                    ];
                case 1:
                    _state.sent();
                    accessToken = androidHandler.requestAccessToken();
                    expiry = new Date(new Date().getTime() + 3600 * 1000).toISOString();
                    user = JSON.parse(androidHandler.getUser());
                    return [
                        2,
                        {
                            accessToken: accessToken,
                            tokenType: "Bearer",
                            expiryToken: expiry,
                            refreshToken: "dummy-refresh-token",
                            email: androidHandler.getEmail(),
                            guruToken: "",
                            expiredAt: expiry,
                            user: {
                                id: user.id,
                                name: user.name,
                                email: user.email,
                                picture: user.photoUrl,
                                groups: (_groups = user.groups) !== null && _groups !== void 0 ? _groups : []
                            }
                        }
                    ];
                case 2:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _validateAccessToken.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./utils/hooks/useGoogleAuthorize.ts





function useGoogleAuthorize(param) {
    var _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function() {} : _onSuccess, _onFailure = param.onFailure, onFailure = _onFailure === void 0 ? function() {} : _onFailure, onScriptLoadFailure = param.onScriptLoadFailure, clientId = param.clientId, cookiePolicy = param.cookiePolicy, loginHint = param.loginHint, hostedDomain = param.hostedDomain, scope = param.scope, responseType = param.responseType, _jsSrc = param.jsSrc, jsSrc = _jsSrc === void 0 ? "https://apis.google.com/js/api.js" : _jsSrc, includeGrantedScopes = param.includeGrantedScopes, prompt = param.prompt;
    var scriptId = "google-authorize";
    var ref = _sliced_to_array(React.useState(false), 2), loaded = ref[0], setLoaded = ref[1];
    React.useEffect(function() {
        var onLoadFailure = onScriptLoadFailure || onFailure;
        loadScript(scriptId, jsSrc, function() {
            setLoaded(true);
        }, function(err) {
            return onLoadFailure(err);
        });
        return function() {
            removeScript(scriptId);
        };
    // eslint-disable-next-line
    }, []);
    var authorize = function() {
        if (loaded) {
            var params = {
                client_id: clientId,
                cookie_policy: cookiePolicy,
                login_hint: loginHint,
                hosted_domain: hostedDomain,
                include_granted_scopes: includeGrantedScopes,
                response_type: responseType,
                prompt: prompt,
                scope: scope
            };
            // @ts-expect-error
            window.gapi.load("auth2", function() {
                // @ts-expect-error
                window.gapi.auth2.authorize(params, function(response) {
                    if (response.error) {
                        onFailure(response.error);
                    } else {
                        var authResponse = params.response_type === "code" ? {
                            code: response.code,
                            emailDomain: response.hd
                        } : {
                            accessToken: response.access_token,
                            idToken: response.id_token,
                            scope: response.scope,
                            expiresIn: response.expires_in,
                            firstIssuedAt: response.first_issued_at,
                            expiresAt: response.expires_at,
                            emailDomain: response.hd
                        };
                        onSuccess(authResponse);
                    }
                });
            });
        }
    };
    return {
        loaded: loaded,
        authorize: authorize
    };
}
function useGoogleIdentityServicesAuthorize(param) {
    var _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function() {} : _onSuccess, _onFailure = param.onFailure, onFailure = _onFailure === void 0 ? function() {} : _onFailure, onScriptLoadFailure = param.onScriptLoadFailure, clientId = param.clientId, scope = param.scope, _jsSrc = param.jsSrc, jsSrc = _jsSrc === void 0 ? "https://accounts.google.com/gsi/client" : _jsSrc;
    var scriptId = "gsi-client";
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loaded = ref[0], setLoaded = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(undefined), 2), client = ref1[0], setClient = ref1[1];
    var initClient = function() {
        var ref;
        // @ts-expect-error
        if (!((ref = window.google) === null || ref === void 0 ? void 0 : ref.accounts)) {
            onFailure("load_script_failed");
            return;
        }
        // @ts-expect-error
        var newClient = window.google.accounts.oauth2.initCodeClient({
            client_id: clientId,
            scope: scope,
            ux_mode: "popup",
            callback: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                    var code, ref, _data, tokens, tokenInfo, authResponse, param, _$response, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!response.error) return [
                                    3,
                                    1
                                ];
                                onFailure(response.error);
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                code = response.code;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    axios_default().post("/api/auth/google/exchange-token", {
                                        code: code
                                    })
                                ];
                            case 3:
                                ref = _state.sent(), _data = ref.data, tokens = _data.tokens, tokenInfo = _data.tokenInfo;
                                authResponse = {
                                    code: code,
                                    accessToken: tokens.access_token,
                                    idToken: tokens.id_token,
                                    scope: tokens.scope,
                                    expiresIn: tokenInfo.exp,
                                    firstIssuedAt: tokenInfo.iat,
                                    expiresAt: tokens.expiry_date,
                                    emailDomain: tokenInfo.hd
                                };
                                // @ts-expect-error
                                onSuccess(authResponse);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                param = _state.sent();
                                _$response = param.response;
                                if (_$response === null || _$response === void 0 ? void 0 : (ref1 = _$response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.error) {
                                    onFailure(_$response.data.data.error);
                                } else {
                                    onFailure("login_failed");
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(response) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
        setClient(newClient);
    };
    var initScript = function() {
        var onLoadFailure = onScriptLoadFailure || onFailure;
        loadScript(scriptId, jsSrc, function() {
            initClient();
            setLoaded(true);
        }, function(err) {
            return onLoadFailure(err);
        });
    };
    var authorize = function() {
        if (loaded) {
            client.requestCode();
        } else {
            initScript();
        }
    };
    react.useEffect(function() {
        initScript();
        return function() {
            removeScript(scriptId);
        };
    // eslint-disable-next-line
    }, []);
    return {
        loaded: loaded,
        authorize: authorize
    };
}
function loadScript(id, jsSrc, onLoad, onError) {
    var ref;
    var isLoaded =  true ? !!(window === null || window === void 0 ? void 0 : (ref = window.google) === null || ref === void 0 ? void 0 : ref.accounts) : 0;
    if (isLoaded) {
        onLoad();
    } else {
        var element = document.getElementsByTagName("script")[0];
        var fjs = element;
        var js = element;
        js = document.createElement("script");
        js.id = id;
        js.src = jsSrc;
        if (fjs && fjs.parentNode) {
            fjs.parentNode.insertBefore(js, fjs);
        } else {
            document.head.appendChild(js);
        }
        js.onerror = onError;
        js.onload = onLoad;
    }
}
function removeScript(id) {
    var element = document.getElementById(id);
    if (element) {
        element.parentNode.removeChild(element);
    }
}

// EXTERNAL MODULE: ./configs/api.ts
var api = __webpack_require__(13102);
;// CONCATENATED MODULE: ./utils/auth/useWebAuth.tsx













var useWebAuth_AuthContextDefaultValue = {
    session: null,
    login: function() {},
    loginScriptIsLoaded: false,
    logout: function() {},
    validateTokenError: null,
    lastUsedEmailDomain: null,
    error: null
};
var useWebAuth_AuthContext = /*#__PURE__*/ react.createContext(useWebAuth_AuthContextDefaultValue);
useWebAuth_AuthContext.displayName = "AuthContext";
function useWebAuth_useAuthProvider() {
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref = useWebAuth_useValidateToken(), run = ref.run, session = ref.session, status = ref.status, validateTokenError = ref.error, resetSession = ref.resetSession;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), error = ref1[0], setError = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), lastUsedEmailDomain = ref2[0], setLastUsedEmailDomain = ref2[1];
    react.useEffect(function() {
        if (immediate) {
            run(null);
        }
    // eslint-disable-next-line
    }, []);
    var ref3 = (useGoogleIdentityServicesAuthorize)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, auth/* GURU_TOKEN_GOOGLE_OAUTH_CONFIG */.NS), {
        onSuccess: function onSuccess(param) {
            var idToken = param.idToken, emailDomain = param.emailDomain;
            run(idToken);
            setLastUsedEmailDomain(emailDomain);
        },
        onFailure: function onFailure(loginError) {
            if (loginError !== "popup_closed_by_user") {
                new Error(// Part of this string is used for new relic alert.
                // Double check with new relic policy dashboard if you want to modify
                "".concat(loginError, " (Login failed due to cannot get idToken from Google)"));
            }
            setError(loginError);
        }
    })), login = ref3.authorize, loginScriptIsLoaded = ref3.loaded;
    var logout = function() {
        resetSession();
    };
    return {
        session: session,
        login: login,
        loginScriptIsLoaded: loginScriptIsLoaded,
        logout: logout,
        status: status,
        error: error,
        validateTokenError: validateTokenError,
        resetSession: resetSession,
        lastUsedEmailDomain: lastUsedEmailDomain
    };
}
function useWebAuth_AuthProvider(props) {
    var ref = useWebAuth_useAuthProvider(), session = ref.session, login = ref.login, loginScriptIsLoaded = ref.loginScriptIsLoaded, logout = ref.logout, status = ref.status, error = ref.error, validateTokenError = ref.validateTokenError, lastUsedEmailDomain = ref.lastUsedEmailDomain;
    var value = react.useMemo(function() {
        return {
            session: session,
            login: login,
            loginScriptIsLoaded: loginScriptIsLoaded,
            logout: logout,
            error: error,
            validateTokenError: validateTokenError,
            lastUsedEmailDomain: lastUsedEmailDomain
        };
    }, [
        session,
        login,
        loginScriptIsLoaded,
        logout,
        error,
        validateTokenError,
        lastUsedEmailDomain, 
    ]);
    if ([
        "idle",
        "loading"
    ].includes(status)) {
        return null;
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(useWebAuth_AuthContext.Provider, (0,_object_spread/* default */.Z)({
            value: value
        }, props));
    }
}
function useWebAuth_useValidateToken() {
    var ref = (0,src_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(auth/* APP_LOGIN_STORAGE_KEY */.zy, null), 3), storedSession = ref[0], setSession = ref[1], removeSession = ref[2];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState("idle"), 2), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), error = ref2[0], setError = ref2[1];
    var run = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(idToken) {
            var ref, ref1, session, ref2, ref3, userId, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStatus("loading");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            validateToken(idToken)
                        ];
                    case 2:
                        session = _state.sent();
                        if (!!session) {
                            setSession(session);
                        }
                        userId = (ref3 = (ref2 = storedSession === null || storedSession === void 0 ? void 0 : (ref = storedSession.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : null;
                        if (userId) {
                            (0,esm_exports/* setUser */.av)({
                                id: userId
                            });
                        }
                        setStatus("success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        setStatus("error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function run(idToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetSession = function() {
        (0,esm_exports/* setUser */.av)(null);
        removeSession();
        setStatus("idle");
    };
    return {
        run: run,
        session: storedSession,
        status: status,
        error: error,
        resetSession: resetSession
    };
}
function validateToken(idToken) {
    return _validateToken.apply(this, arguments);
}
function _validateToken() {
    _validateToken = (0,_async_to_generator/* default */.Z)(function(idToken) {
        var axiosConfig, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!idToken) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    axiosConfig = {
                        url: "".concat(api/* baseUrl */.F, "/teachers/v1alpha2/login"),
                        method: "POST",
                        data: {
                            grantType: "GOOGLE",
                            token: idToken
                        }
                    };
                    return [
                        4,
                        axios_default()(axiosConfig)
                    ];
                case 2:
                    data = _state.sent().data;
                    return [
                        2,
                        data.data
                    ];
                case 3:
                    error = _state.sent();
                    new Error(// Part of this string is used for new relic alert.
                    // Double check with new relic policy dashboard if you want to modify
                    "".concat(error, " (Login failed due to cannot exchange idToken to guruToken)"));
                    throw error;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        null
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _validateToken.apply(this, arguments);
}

// EXTERNAL MODULE: ./configs/routes.ts
var routes = __webpack_require__(90294);
;// CONCATENATED MODULE: ./utils/auth/utils.ts


var isBrowser = function() {
    return "object" !== "undefined";
};
var isPathProtected = function(router) {
    var url = new URL(window.location.href);
    return !routes/* UNPROTECTED_ROUTES.some */.F.some(function(route) {
        if (typeof route === "string") return router.pathname === route;
        var isPathMatched = router.pathname === route.pathname;
        if (isPathMatched && !!route.query) {
            // Next router object can return empty query in initial time
            // even though the url should have query,
            // thus we need to get it from window.location.href.
            return !!url.searchParams.get(route.query);
        }
        return isPathMatched;
    });
};
function getSession() {
    var storageKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : APP_LOGIN_STORAGE_KEY;
    try {
        return JSON.parse(window.localStorage.getItem(storageKey));
    } catch (e) {
        return null;
    }
}

;// CONCATENATED MODULE: ./utils/auth/index.tsx









function useAuth() {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    var Context = androidHandler.enabled ? AuthContext : useWebAuth_AuthContext;
    var context = react.useContext(Context);
    if (context === undefined) {
        throw new Error("useAuth must be used within a AuthProvider");
    }
    return context;
}
function auth_useAuthProvider(immediate) {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    /* eslint-disable react-hooks/rules-of-hooks */ // Android handler is not reactive, therefore it should be safe here
    // and instead we get a beautiful polymorphism!
    return androidHandler.enabled ? useAuthProvider(immediate) : useWebAuth_useAuthProvider(immediate);
/* eslint-enable react-hooks/rules-of-hooks */ }
function auth_AuthProvider(props) {
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    return androidHandler.enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthProvider, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(useWebAuth_AuthProvider, (0,_object_spread/* default */.Z)({}, props));
}
var login = function() {
    var callbackUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/pelatihan-mandiri";
    var parsedCallbackUrl = encodeURI(callbackUrl || "/pelatihan-mandiri");
    window.location.replace("".concat("https://guru.kemdikbud.go.id", "/login?from=").concat(parsedCallbackUrl));
};
function ProtectedRoutes(param) {
    var router = param.router, children = param.children;
    var session = useAuth().session;
    var androidHandler = (0,utils_androidHandler/* default */.ZP)();
    if (isBrowser() && session === null && isPathProtected(router)) {
        if (androidHandler.enabled) {
            androidHandler.requestLogin();
        } else {
            login(window.location.pathname + window.location.search);
        }
        return null;
    }
    return children;
}
function setAuthToAPI(url, param) {
    var accessToken = param.accessToken, tokenType = param.tokenType, refreshToken = param.refreshToken, expiryToken = param.expiryToken;
    var urlObj = new URL(url);
    urlObj.searchParams.set("accessToken", accessToken);
    urlObj.searchParams.set("tokenType", tokenType);
    urlObj.searchParams.set("refreshToken", refreshToken);
    urlObj.searchParams.set("expiryToken", expiryToken);
    return urlObj.toString();
}
function auth_getSession() {
    var storageKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : auth/* APP_LOGIN_STORAGE_KEY */.zy;
    try {
        return JSON.parse(window.localStorage.getItem(storageKey));
    } catch (e) {
        return null;
    }
}
function useTriggerOrLogin() {
    var session = useAuth().session;
    var androidHandler = AndroidHandler();
    var router = useRouter();
    var run = React.useCallback(function(callback) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            params[_key - 1] = arguments[_key];
        }
        if (session) {
            callback.apply(null, params);
        } else {
            if (androidHandler.enabled) {
                androidHandler.requestLogin();
            } else {
                router.push({
                    pathname: "/login",
                    query: {
                        from: router.asPath
                    }
                });
            }
        }
    }, [
        session,
        router,
        androidHandler
    ]);
    return {
        run: run
    };
}


/***/ }),

/***/ 97512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F7": function() { return /* binding */ NetworkError; },
/* harmony export */   "Hl": function() { return /* binding */ InternalServerError; },
/* harmony export */   "TC": function() { return /* binding */ ServiceUnavailableError; },
/* harmony export */   "dR": function() { return /* binding */ NotFoundError; },
/* harmony export */   "lY": function() { return /* binding */ ForbiddenError; },
/* harmony export */   "sH": function() { return /* binding */ CustomError; },
/* harmony export */   "zM": function() { return /* binding */ SessionError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25171);
// for some reason, using error for throwing error will always
// result in uncaught error, thus we don't extend Error class here



var CustomError = function CustomError(param) {
    "use strict";
    var title = param.title, description = param.description, apiPath = param.apiPath, originalError = param.originalError;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, CustomError);
    this.title = title;
    this.description = description;
    this.apiPath = apiPath;
    this.originalError = originalError;
};
var SessionError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SessionError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SessionError);
    function SessionError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SessionError);
        var title = "Sesi Anda berakhir";
        var description = "Login untuk melanjutkan dengan ketuk tombol di bawah ini.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return SessionError;
}(CustomError);
var InternalServerError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(InternalServerError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InternalServerError);
    function InternalServerError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, InternalServerError);
        var title = "Sedang terjadi kendala";
        var description = "Jangan khawatir, hal ini bersifat sementara. Silakan perbarui halaman ini beberapa saat lagi.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return InternalServerError;
}(CustomError);
var ForbiddenError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ForbiddenError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ForbiddenError);
    function ForbiddenError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ForbiddenError);
        var title = "Anda tidak memiliki akses untuk halaman ini";
        var description = "Gunakan akun lain (belajar.id / madrasah.kemenag.go.id) untuk dapat mengakses halaman ini. Jika masih mengalami kesulitan, silakan hubungi bantuan.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return ForbiddenError;
}(CustomError);
var NotFoundError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(NotFoundError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NotFoundError);
    function NotFoundError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, NotFoundError);
        var title = "Tidak menemukan yang Anda cari";
        var description = "Halaman mungkin dihapus atau terdapat kesalahan pada tautan. Ketuk tombol di bawah untuk lihat konten lainnya.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return NotFoundError;
}(CustomError);
var ServiceUnavailableError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ServiceUnavailableError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ServiceUnavailableError);
    function ServiceUnavailableError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ServiceUnavailableError);
        var title = "Sedang terjadi kendala";
        var description = "Jangan khawatir, hal ini bersifat sementara. Silakan perbarui halaman ini beberapa saat lagi.";
        if (apiPath.includes("/teachers-career/v1alpha1")) {
            title = "Tidak dapat diakses";
            description = "Karena adanya pemeliharaan sistem, Bukti Karya baru dapat diakses lagi pada 12 Mei 2022 pukul 10.00 WIB.";
        }
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return ServiceUnavailableError;
}(CustomError);
var NetworkError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(NetworkError, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NetworkError);
    function NetworkError(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, NetworkError);
        var title = "Tidak Ada Koneksi Internet";
        var description = "Pastikan koneksi internet Anda aktif untuk memuat halaman ini.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return NetworkError;
}(CustomError);


/***/ }),

/***/ 66578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B_": function() { return /* binding */ WithFeatureFlagContext; },
  "dG": function() { return /* binding */ useFeatureFlagContext; }
});

// UNUSED EXPORTS: FeatureFlagContext, FeatureFlagContextDefaultValue

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/microlearning/useAPIKeyValue.ts
var useAPIKeyValue = __webpack_require__(42979);
;// CONCATENATED MODULE: ./utils/hooks/context/useFeatureFlagHook.ts


var useFeatureFlagHook = function() {
    var ref = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.FeatureFlag */.QK.FeatureFlag), status = ref.status, data = ref.data;
    var getFeatureByKey = react.useCallback(function(key) {
        if (status === "loading") return false;
        var featureList = (data === null || data === void 0 ? void 0 : data.data) || {};
        return featureList && featureList[key] || false;
    }, [
        data === null || data === void 0 ? void 0 : data.data,
        status
    ]);
    return {
        status: status,
        features: data === null || data === void 0 ? void 0 : data.data,
        getFeatureByKey: getFeatureByKey
    };
};

;// CONCATENATED MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx




var FeatureFlagContextDefaultValue = {
    status: "loading",
    features: {},
    getFeatureByKey: function() {
        return false;
    }
};
var FeatureFlagContext = /*#__PURE__*/ react.createContext(FeatureFlagContextDefaultValue);
FeatureFlagContext.displayName = "FeatureFlagContext";
function useFeatureFlagContext() {
    var context = react.useContext(FeatureFlagContext);
    if (context === undefined) {
        throw new Error("FeatureFlagContext must be used within a FeatureContextProvider");
    }
    return context;
}
function WithFeatureFlagContext(props) {
    var featureFlag = useFeatureFlagHook();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagContext.Provider, (0,_object_spread/* default */.Z)({
        value: featureFlag
    }, props));
}


/***/ }),

/***/ 65260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wz": function() { return /* binding */ WithScreenSizeContext; },
  "fl": function() { return /* binding */ useScreenSizeContext; }
});

// UNUSED EXPORTS: ScreenSizeContext, ScreenSizeContextDefaultValue

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx + 1 modules
var useFeatureFlagContext = __webpack_require__(66578);
// EXTERNAL MODULE: ./utils/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(212);
;// CONCATENATED MODULE: ./utils/hooks/context/useScreenSizeHook.ts





var useScreenSizeHook = function() {
    var ref = (0,useFeatureFlagContext/* useFeatureFlagContext */.dG)(), getFeatureByKey = ref.getFeatureByKey, status = ref.status;
    var isEnableDesktopLayout = getFeatureByKey("enableBelajarDesktopLayout");
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isDesktop = ref1[0], setIsDesktop = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)("isDesktopScreenSize", false), 4), setDesktopScreenSizeFlag = ref2[1], getScreenSizeFlagFromLocalStorage = ref2[3];
    var handleWindowSizeChange = debounce_default()(function() {
        var isWindowDesktopWidth = (window === null || window === void 0 ? void 0 : window.innerWidth) >= 1024 && isEnableDesktopLayout;
        setDesktopScreenSizeFlag(isWindowDesktopWidth);
        setIsDesktop(isWindowDesktopWidth);
    }, 500);
    react.useEffect(function() {
        if (status === "success" && isEnableDesktopLayout !== isDesktop) {
            handleWindowSizeChange();
        }
        if (isEnableDesktopLayout) {
            window.addEventListener("resize", handleWindowSizeChange);
            return function() {
                window.removeEventListener("resize", handleWindowSizeChange);
            };
        } else {
            setDesktopScreenSizeFlag(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        status
    ]);
    return {
        isDesktop: getScreenSizeFlagFromLocalStorage() || isDesktop,
        status: status,
        toggleDesktop: isEnableDesktopLayout
    };
};

;// CONCATENATED MODULE: ./utils/hooks/context/useScreenSizeContext.tsx




var ScreenSizeContextDefaultValue = {
    status: "loading",
    isDesktop: false,
    toggleDesktop: false
};
var ScreenSizeContext = /*#__PURE__*/ react.createContext(ScreenSizeContextDefaultValue);
ScreenSizeContext.displayName = "ScreenSizeContext";
function useScreenSizeContext() {
    var context = react.useContext(ScreenSizeContext);
    if (context === undefined) {
        throw new Error("ScreenSizeContext must be used within a ScreenSizeContext.Provider");
    }
    return context;
}
function WithScreenSizeContext(props) {
    var screenSize = useScreenSizeHook();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenSizeContext.Provider, (0,_object_spread/* default */.Z)({
        value: screenSize
    }, props));
}


/***/ }),

/***/ 212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useLocalStorage(key, initialValue, parseFn, stringifyFn) {
    var parse = parseFn || JSON.parse;
    var stringify = stringifyFn || JSON.stringify;
    var getValue = function() {
        try {
            if (true) {
                var item = window.localStorage.getItem(key);
                return item ? parse(item) : initialValue;
            }
            return initialValue;
        } catch (error) {
            // eslint-disable-next-line
            console.log("error in local storage key:", key);
            // eslint-disable-next-line
            console.error(error);
            return initialValue;
        }
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(getValue()), 2), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(value) {
        try {
            setStoredValue(value);
            if (true) {
                window.localStorage.setItem(key, stringify(value));
            }
        } catch (error) {
            // eslint-disable-next-line
            console.log("error in local storage key:", key);
            // eslint-disable-next-line
            console.error(error);
        }
    };
    var removeValue = function() {
        try {
            setStoredValue(null);
            if (true) {
                window.localStorage.removeItem(key);
            }
        } catch (error) {
            // eslint-disable-next-line
            console.log("error in local storage key:", key);
            // eslint-disable-next-line
            console.error(error);
        }
    };
    return [
        storedValue,
        setValue,
        removeValue,
        getValue
    ];
}


/***/ }),

/***/ 88265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ timeout; }
/* harmony export */ });
function timeout(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}


/***/ }),

/***/ 81670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getRouterBasePath; },
/* harmony export */   "m": function() { return /* binding */ parseQuery; }
/* harmony export */ });
var parseQuery = function(query) {
    var into = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "string";
    if (!query) return null;
    if (into === "string") return Array.isArray(query) ? query === null || query === void 0 ? void 0 : query[0] : query;
    return Array.isArray(query) ? query : [
        query
    ];
};
var getRouterBasePath = function(path) {
    if (!path) return null;
    if (typeof path !== "string") return path;
    return path.replace(/^\/([^?\/]*).*$/, "$1");
};


/***/ }),

/***/ 52362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
var DEFAULT_ENVIRONMENT = "production";
 //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 12706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 34855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; },
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61745);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58950);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37745);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11436);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12706);



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function getGlobalEventProcessors() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)("globalEventProcessors", function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function addGlobalEventProcessor(callback) {
    // eslint-disable-next-line deprecation/deprecation
    getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== "function") {
            resolve(event);
        } else {
            var result = processor((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, event), hint);
            _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && processor.id && result === null && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Event processor "'.concat(processor.id, '" dropped event'));
            if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isThenable */ .J8)(result)) {
                void result.then(function(final) {
                    return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
            } else {
                void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        }
    });
}
 //# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 32407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "s3": function() { return /* binding */ getClient; },
/* harmony export */   "yj": function() { return /* binding */ startSession; },
/* harmony export */   "yl": function() { return /* binding */ flush; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, captureMessage, close, configureScope, endSession, isInitialized, lastEventId, setContext, setExtra, setExtras, setTag, setTags, startTransaction, withActiveSpan, withIsolationScope, withMonitor */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37745);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61745);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52362);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12706);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68813);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34395);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8405);










/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    getCurrentHub().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function setUser(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) {
            // eslint-disable-next-line deprecation/deprecation
            return hub.withScope(callback);
        }
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(function() {
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function withIsolationScope(callback) {
    return runWithAsyncContext(function() {
        return callback(getIsolationScope());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    return withScope(function(scope) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function startTransaction(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().startTransaction(_object_spread({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var scope = getCurrentScope();
    var client = getClient();
    if (!client) {
        DEBUG_BUILD && logger.warn("Cannot capture check-in. No client defined.");
    } else if (!client.captureCheckIn) {
        DEBUG_BUILD && logger.warn("Cannot capture check-in. Client does not support sending check-ins.");
    } else {
        return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    }
    return uuid4();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    var finishCheckIn = function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: timestampInSeconds() - now
        });
    };
    var checkInId = captureCheckIn({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    var now = timestampInSeconds();
    var maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if (isThenable(maybePromiseResult)) {
        Promise.resolve(maybePromiseResult).then(function() {
            finishCheckIn("ok");
        }, function() {
            finishCheckIn("error");
        });
    } else {
        finishCheckIn("ok");
    }
    return maybePromiseResult;
}
function flush(timeout) {
    return _flush.apply(this, arguments);
}
function _flush() {
    _flush = /**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(timeout) {
        var client;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            client = getClient();
            if (client) {
                return [
                    2,
                    client.flush(timeout)
                ];
            }
            _debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn("Cannot flush events. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _flush.apply(this, arguments);
}
function close(timeout) {
    return _close.apply(this, arguments);
}
function _close() {
    _close = /**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ _async_to_generator(function(timeout) {
        var client;
        return _ts_generator(this, function(_state) {
            client = getClient();
            if (client) {
                return [
                    2,
                    client.close(timeout)
                ];
            }
            DEBUG_BUILD && logger.warn("Cannot flush events and disable SDK. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _close.apply(this, arguments);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function lastEventId() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().lastEventId();
}
/**
 * Get the currently active client.
 */ function getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!getClient();
}
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    var client = getClient();
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var ref = client && client.getOptions() || {}, release = ref.release, _environment = ref.environment, environment = _environment === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_ENVIRONMENT */ .J : _environment;
    // Will fetch userAgent if called from browser sdk
    var userAgent = (_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {}).userAgent;
    var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_9__/* .makeSession */ .Hv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_9__/* .updateSession */ .CT)(currentSession, {
            status: "exited"
        });
    }
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_9__/* .closeSession */ .RJ)(session);
    }
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var client = getClient();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) {
        client.captureSession(session);
    }
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}
 //# sourceMappingURL=exports.js.map


/***/ }),

/***/ 68813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11436);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78774);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25231);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37745);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61745);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52362);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12706);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30359);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34395);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32263);










/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var API_VERSION = parseFloat(_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J);
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client, scope, isolationScope) {
        var _version = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : API_VERSION;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Hub);
        this._version = _version;
        var assignedScope;
        if (!scope) {
            assignedScope = new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
            assignedScope.setClient(client);
        } else {
            assignedScope = scope;
        }
        var assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
            assignedIsolationScope.setClient(client);
        } else {
            assignedIsolationScope = isolationScope;
        }
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) {
            // eslint-disable-next-line deprecation/deprecation
            this.bindClient(client);
        }
        this._isolationScope = assignedIsolationScope;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Hub, [
        {
            /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ key: "bindClient",
            value: function bindClient(client) {
                // eslint-disable-next-line deprecation/deprecation
                var top = this.getStackTop();
                top.client = client;
                top.scope.setClient(client);
                // eslint-disable-next-line deprecation/deprecation
                if (client && client.setupIntegrations) {
                    // eslint-disable-next-line deprecation/deprecation
                    client.setupIntegrations();
                }
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.getScope().clone();
                // eslint-disable-next-line deprecation/deprecation
                this.getStack().push({
                    // eslint-disable-next-line deprecation/deprecation
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "popScope",
            value: function popScope() {
                // eslint-disable-next-line deprecation/deprecation
                if (this.getStack().length <= 1) return false;
                // eslint-disable-next-line deprecation/deprecation
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.popScope();
                    throw e;
                }
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isThenable */ .J8)(maybePromiseResult)) {
                    // @ts-expect-error - isThenable returns the wrong type
                    return maybePromiseResult.then(function(res) {
                        // eslint-disable-next-line deprecation/deprecation
                        _this.popScope();
                        return res;
                    }, function(e) {
                        // eslint-disable-next-line deprecation/deprecation
                        _this.popScope();
                        throw e;
                    });
                }
                // eslint-disable-next-line deprecation/deprecation
                this.popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ key: "getClient",
            value: function getClient() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ key: "getScope",
            value: function getScope() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                var syntheticException = new Error("Sentry syntheticException");
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureException(exception, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                var syntheticException = new Error(message);
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureMessage(message, level, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                if (!event.type) {
                    this._lastEventId = eventId;
                }
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureEvent(event, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (!client) return;
                var ref1 = client.getOptions && client.getOptions() || {}, _beforeBreadcrumb = ref1.beforeBreadcrumb, beforeBreadcrumb = _beforeBreadcrumb === void 0 ? null : _beforeBreadcrumb, _maxBreadcrumbs = ref1.maxBreadcrumbs, maxBreadcrumbs = _maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .dateTimestampInSeconds */ .yW)();
                var mergedBreadcrumb = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .consoleSandbox */ .Cf)(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) {
                    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
                }
                // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
                // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
                // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
                // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
                // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
                // the event processing pipeline.
                // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ key: "setUser",
            value: function setUser(user) {
                // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setUser(user);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ key: "setTags",
            value: function setTags(tags) {
                // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTags(tags);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ key: "setExtras",
            value: function setExtras(extras) {
                // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtras(extras);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTag(key, value);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtra(key, extra);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setContext(name, context);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ key: "configureScope",
            value: function configureScope(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (client) {
                    callback(scope);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "run",
            value: function run(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    // eslint-disable-next-line deprecation/deprecation
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                if (!client) return null;
                try {
                    // eslint-disable-next-line deprecation/deprecation
                    return client.getIntegration(integration);
                } catch (_oO) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Cannot retrieve integration ".concat(integration.id, " from the current Hub"));
                    return null;
                }
            }
        },
        {
            /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
                if (_debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && !result) {
                    // eslint-disable-next-line deprecation/deprecation
                    var client = this.getClient();
                    if (!client) {
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    } else {
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");
                    }
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod("traceHeaders");
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) {
                    // eslint-disable-next-line deprecation/deprecation
                    return this.endSession();
                }
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ key: "endSession",
            value: function endSession() {
                // eslint-disable-next-line deprecation/deprecation
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .closeSession */ .RJ)(session);
                }
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ key: "startSession",
            value: function startSession(context) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var ref1 = client && client.getOptions() || {}, release = ref1.release, _environment = ref1.environment, environment = _environment === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_12__/* .DEFAULT_ENVIRONMENT */ .J : _environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = (_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {}).userAgent;
                var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .makeSession */ .Hv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === "ok") {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .updateSession */ .CT)(currentSession, {
                        status: "exited"
                    });
                }
                // eslint-disable-next-line deprecation/deprecation
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) {
                    client.captureSession(session);
                }
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
                    return sentry.extensions[method].apply(this, args);
                }
                _debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Extension method ".concat(method, " couldn't be found, doing nothing."));
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ */ .n2;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) {
            return hub;
        }
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function getIsolationScope() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(registry, new Hub());
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        var client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        var scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        var isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    }
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .getGlobalSingleton */ .YO)("hub", function() {
        return new Hub();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
 //# sourceMappingURL=hub.js.map


/***/ }),

/***/ 30359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; },
/* harmony export */   "sX": function() { return /* binding */ Scope; }
/* harmony export */ });
/* unused harmony export setGlobalScope */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11436);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25231);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78774);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37745);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34855);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34395);
/* harmony import */ var _utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30399);











/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ var globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Scope, [
        {
            /**
   * Clone this scope instance.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._breadcrumbs);
                newScope._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags);
                newScope._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra);
                newScope._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts);
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._span = this._span;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._eventProcessors);
                newScope._requestSession = this._requestSession;
                newScope._attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._attachments);
                newScope._sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._propagationContext);
                newScope._client = this._client;
                return newScope;
            }
        },
        {
            /** Update the client on the scope. */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    segment: undefined,
                    username: undefined
                };
                if (this._session) {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(this._session, {
                        user: user
                    });
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope for future events.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this._span;
                // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
                // Also, this method will be removed anyway.
                // eslint-disable-next-line deprecation/deprecation
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) {
                    delete this._session;
                } else {
                    this._session = session;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) {
                    return this;
                }
                var scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(scopeToMerge, Scope)) {
                    var scopeData = scopeToMerge.getScopeData();
                    this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, scopeData.tags);
                    this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, scopeData.extra);
                    this._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts, scopeData.contexts);
                    if (scopeData.user && Object.keys(scopeData.user).length) {
                        this._user = scopeData.user;
                    }
                    if (scopeData.level) {
                        this._level = scopeData.level;
                    }
                    if (scopeData.fingerprint.length) {
                        this._fingerprint = scopeData.fingerprint;
                    }
                    if (scopeToMerge.getRequestSession()) {
                        this._requestSession = scopeToMerge.getRequestSession();
                    }
                    if (scopeData.propagationContext) {
                        this._propagationContext = scopeData.propagationContext;
                    }
                } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .isPlainObject */ .PO)(scopeToMerge)) {
                    var scopeContext = captureContext;
                    this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, scopeContext.tags);
                    this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, scopeContext.extra);
                    this._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts, scopeContext.contexts);
                    if (scopeContext.user) {
                        this._user = scopeContext.user;
                    }
                    if (scopeContext.level) {
                        this._level = scopeContext.level;
                    }
                    if (scopeContext.fingerprint) {
                        this._fingerprint = scopeContext.fingerprint;
                    }
                    if (scopeContext.requestSession) {
                        this._requestSession = scopeContext.requestSession;
                    }
                    if (scopeContext.propagationContext) {
                        this._propagationContext = scopeContext.propagationContext;
                    }
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) {
                    return this;
                }
                var mergedBreadcrumb = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .dateTimestampInSeconds */ .yW)()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ key: "getAttachments",
            value: function getAttachments() {
                var data = this.getScopeData();
                return data.attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "getScopeData",
            value: function getScopeData() {
                var ref = this, _breadcrumbs = ref._breadcrumbs, _attachments = ref._attachments, _contexts = ref._contexts, _tags = ref._tags, _extra = ref._extra, _user = ref._user, _level = ref._level, _fingerprint = ref._fingerprint, _eventProcessors = ref._eventProcessors, _propagationContext = ref._propagationContext, _sdkProcessingMetadata = ref._sdkProcessingMetadata, _transactionName = ref._transactionName, _span = ref._span;
                return {
                    breadcrumbs: _breadcrumbs,
                    attachments: _attachments,
                    contexts: _contexts,
                    tags: _tags,
                    extra: _extra,
                    user: _user,
                    level: _level,
                    fingerprint: _fingerprint || [],
                    eventProcessors: _eventProcessors,
                    propagationContext: _propagationContext,
                    sdkProcessingMetadata: _sdkProcessingMetadata,
                    transactionName: _transactionName,
                    span: _span
                };
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                (0,_utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_10__/* .applyScopeDataToEvent */ .gi)(event, this.getScopeData());
                // TODO (v8): Update this order to be: Global > Client > Scope
                var eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(additionalEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
                (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__/* .getGlobalEventProcessors */ .fH)()), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._eventProcessors));
                return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__/* .notifyEventProcessors */ .RP)(eventProcessors, event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture exception!");
                    return eventId;
                }
                var syntheticException = new Error("Sentry syntheticException");
                this._client.captureException(exception, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture message!");
                    return eventId;
                }
                var syntheticException = new Error(message);
                this._client.captureMessage(message, level, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture event!");
                    return eventId;
                }
                this._client.captureEvent(event, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ function clone(scope) {
                return scope ? scope.clone() : new Scope();
            }
        }
    ]);
    return Scope;
}();
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    if (!globalScope) {
        globalScope = new Scope();
    }
    return globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function setGlobalScope(scope) {
    globalScope = scope;
}
function generatePropagationContext() {
    return {
        traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)(),
        spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)().substring(16)
    };
}
 //# sourceMappingURL=scope.js.map


/***/ }),

/***/ 34395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25231);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78774);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38434);

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
    var session = {
        sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) {
        updateSession(session, context);
    }
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) {
            session.ipAddress = context.user.ip_address;
        }
        if (!session.did && !context.did) {
            session.did = context.user.id || context.user.email || context.user.username;
        }
    }
    session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
    if (context.abnormal_mechanism) {
        session.abnormal_mechanism = context.abnormal_mechanism;
    }
    if (context.ignoreDuration) {
        session.ignoreDuration = context.ignoreDuration;
    }
    if (context.sid) {
        // Good enough uuid validation. — Kamil
        session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    }
    if (context.init !== undefined) {
        session.init = context.init;
    }
    if (!session.did && context.did) {
        session.did = "".concat(context.did);
    }
    if (typeof context.started === "number") {
        session.started = context.started;
    }
    if (session.ignoreDuration) {
        session.duration = undefined;
    } else if (typeof context.duration === "number") {
        session.duration = context.duration;
    } else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) {
        session.release = context.release;
    }
    if (context.environment) {
        session.environment = context.environment;
    }
    if (!session.ipAddress && context.ipAddress) {
        session.ipAddress = context.ipAddress;
    }
    if (!session.userAgent && context.userAgent) {
        session.userAgent = context.userAgent;
    }
    if (typeof context.errors === "number") {
        session.errors = context.errors;
    }
    if (context.status) {
        session.status = context.status;
    }
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) {
        context = {
            status: status
        };
    } else if (session.status === "ok") {
        context = {
            status: "exited"
        };
    }
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
 //# sourceMappingURL=session.js.map


/***/ }),

/***/ 86232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; },
/* harmony export */   "j": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38434);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52362);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32407);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99586);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5889);





/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client, scope) {
    var options = client.getOptions();
    var ref = client.getDsn() || {}, public_key = ref.publicKey;
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    var ref1 = scope && scope.getUser() || {}, user_segment = ref1.segment;
    var dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
        environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
    if (!client) {
        return {};
    }
    // passing emit=false here to only emit later once the DSC is actually populated
    var dsc = getDynamicSamplingContextFromClient((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).trace_id || "", client, (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    var txn = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span);
    if (!txn) {
        return dsc;
    }
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    var v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) {
        return v7FrozenDsc;
    }
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    var _metadata = txn.metadata, maybeSampleRate = _metadata.sampleRate, source = _metadata.source;
    if (maybeSampleRate != null) {
        dsc.sample_rate = "".concat(maybeSampleRate);
    }
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") {
        dsc.transaction = jsonSpan.description;
    }
    dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
 //# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 30399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gi": function() { return /* binding */ applyScopeDataToEvent; },
/* harmony export */   "yo": function() { return /* binding */ mergeScopeData; }
/* harmony export */ });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38434);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78774);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86232);
/* harmony import */ var _getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99586);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5889);






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) {
        applySpanToEvent(event, span);
    }
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, // eslint-disable-next-line deprecation/deprecation
    transactionName = mergeData.transactionName, span = mergeData.span;
    mergeAndOverwriteScopeData(data, "extra", extra);
    mergeAndOverwriteScopeData(data, "tags", tags);
    mergeAndOverwriteScopeData(data, "user", user);
    mergeAndOverwriteScopeData(data, "contexts", contexts);
    mergeAndOverwriteScopeData(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) {
        data.level = level;
    }
    if (transactionName) {
        // eslint-disable-next-line deprecation/deprecation
        data.transactionName = transactionName;
    }
    if (span) {
        data.span = span;
    }
    if (breadcrumbs.length) {
        data.breadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.breadcrumbs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breadcrumbs));
    }
    if (fingerprint.length) {
        data.fingerprint = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.fingerprint).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fingerprint));
    }
    if (eventProcessors.length) {
        data.eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.eventProcessors).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(eventProcessors));
    }
    if (attachments.length) {
        data.attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.attachments).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(attachments));
    }
    data.propagationContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data[prop]);
        for(var key in mergeVal){
            if (Object.prototype.hasOwnProperty.call(mergeVal, key)) {
                data[prop][key] = mergeVal[key];
            }
        }
    }
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, // eslint-disable-next-line deprecation/deprecation
    transactionName = data.transactionName;
    var cleanedExtra = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) {
        event.extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedExtra, event.extra);
    }
    var cleanedTags = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) {
        event.tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedTags, event.tags);
    }
    var cleanedUser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) {
        event.user = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedUser, event.user);
    }
    var cleanedContexts = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) {
        event.contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedContexts, event.contexts);
    }
    if (level) {
        event.level = level;
    }
    if (transactionName) {
        event.transaction = transactionName;
    }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(event.breadcrumbs || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceContext */ .wy)(span)
    }, event.contexts);
    var rootSpan = (0,_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__/* .getDynamicSamplingContextFromSpan */ .j)(span)
        }, event.sdkProcessingMetadata);
        var transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(rootSpan).description;
        if (transactionName) {
            event.tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                transaction: transactionName
            }, event.tags);
        }
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .arrayify */ .lE)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) {
        event.fingerprint = event.fingerprint.concat(fingerprint);
    }
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
        delete event.fingerprint;
    }
}
 //# sourceMappingURL=applyScopeDataToEvent.js.map


/***/ }),

/***/ 99586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getRootSpan; }
/* harmony export */ });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function getRootSpan(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}
 //# sourceMappingURL=getRootSpan.js.map


/***/ }),

/***/ 8405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; },
/* harmony export */   "U0": function() { return /* binding */ parseEventHintOrCaptureContext; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78774);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25231);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35408);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61745);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40465);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52362);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34855);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30359);
/* harmony import */ var _applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30399);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5889);










/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    var _normalizeDepth = options.normalizeDepth, normalizeDepth = _normalizeDepth === void 0 ? 3 : _normalizeDepth, _normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _normalizeMaxBreadth === void 0 ? 1000 : _normalizeMaxBreadth;
    var prepared = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event), {
        event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .uuid4 */ .DM)(),
        timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dateTimestampInSeconds */ .yW)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) {
        applyDebugIds(prepared, options.stackParser);
    }
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addExceptionMechanism */ .EG)(prepared, hint.mechanism);
    }
    var clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0,_scope_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalScope */ .lW)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeScopeData */ .yo)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeScopeData */ .yo)(data, finalScopeData);
    }
    var attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(hint.attachments || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data.attachments));
    if (attachments.length) {
        hint.attachments = attachments;
    }
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .applyScopeDataToEvent */ .gi)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    var eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(clientEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__/* .getGlobalEventProcessors */ .fH)()), // Run scope event processors _after_ all other processors
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data.eventProcessors));
    var result = (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__/* .notifyEventProcessors */ .RP)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) {
            // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
            // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
            // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
            // any new data
            applyDebugMeta(evt);
        }
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
            return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        }
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    var environment = options.environment, release = options.release, dist = options.dist, _maxValueLength = options.maxValueLength, maxValueLength = _maxValueLength === void 0 ? 250 : _maxValueLength;
    if (!("environment" in event)) {
        event.environment = "environment" in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_ENVIRONMENT */ .J;
    }
    if (event.release === undefined && release !== undefined) {
        event.release = release;
    }
    if (event.dist === undefined && dist !== undefined) {
        event.dist = dist;
    }
    if (event.message) {
        event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(event.message, maxValueLength);
    }
    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
        exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(exception.value, maxValueLength);
    }
    var request = event.request;
    if (request && request.url) {
        request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(request.url, maxValueLength);
    }
}
var debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    var debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;
    if (!debugIdMap) {
        return;
    }
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) {
        debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    } else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) {
            parsedStack = cachedParsedStack;
        } else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.filename) {
                    frame.debug_id = filenameDebugIdMap[frame.filename];
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.debug_id) {
                    if (frame.abs_path) {
                        filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    } else if (frame.filename) {
                        filenameDebugIdMap[frame.filename] = frame.debug_id;
                    }
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) {
        return;
    }
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach(function(filename) {
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(event.sdk.integrations || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
        return null;
    }
    var normalized = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, b, b.data && {
                data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) {
            normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
        }
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
        normalized.spans = event.spans.map(function(span) {
            var data = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_12__/* .spanToJSON */ .XU)(span).data;
            if (data) {
                // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
                // eslint-disable-next-line deprecation/deprecation
                span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(data, depth, maxBreadth);
            }
            return span;
        });
    }
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) {
        return scope;
    }
    var finalScope = scope ? scope.clone() : new _scope_js__WEBPACK_IMPORTED_MODULE_4__/* .Scope */ .sX();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) {
        return undefined;
    }
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) {
        return {
            captureContext: hint
        };
    }
    if (hintIsScopeContext(hint)) {
        return {
            captureContext: hint
        };
    }
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(hint, _scope_js__WEBPACK_IMPORTED_MODULE_4__/* .Scope */ .sX) || typeof hint === "function";
}
var captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext", 
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}
 //# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 5889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38434);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87143);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25231);


// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function spanToTraceContext(span) {
    var ref = span.spanContext(), span_id = ref.spanId, trace_id = ref.traceId;
    var ref1 = spanToJSON(span), data = ref1.data, op = ref1.op, parent_span_id = ref1.parent_span_id, status = ref1.status, tags = ref1.tags, origin = ref1.origin;
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var ref = span.spanContext(), traceId = ref.traceId, spanId = ref.spanId;
    var sampled = spanIsSampled(span);
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === "number") {
        return ensureTimestampInSeconds(input);
    }
    if (Array.isArray(input)) {
        // See {@link HrTime} for the array-based time format
        return input[0] + input[1] / 1e9;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(input, Date)) {
        return ensureTimestampInSeconds(input.getTime());
    }
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .timestampInSeconds */ .ph)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function spanToJSON(span) {
    if (spanIsSpanClass(span)) {
        return span.getSpanJSON();
    }
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") {
        // eslint-disable-next-line deprecation/deprecation
        return span.toJSON();
    }
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}
 //# sourceMappingURL=spanUtils.js.map


/***/ }),

/***/ 32263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = "7.120.0";
 //# sourceMappingURL=version.js.map


/***/ }),

/***/ 41326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73159);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11436);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37745);




var BAGGAGE_HEADER_NAME = "baggage";
var SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
        return undefined;
    }
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    var baggageObject = {};
    if (Array.isArray(baggageHeader)) {
        // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
        baggageObject = baggageHeader.reduce(function(acc, curr) {
            var currBaggageObject = baggageHeaderToObject(curr);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(currBaggageObject)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    acc[key] = currBaggageObject[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return acc;
        }, {});
    } else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) {
            return undefined;
        }
        baggageObject = baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) {
        return dynamicSamplingContext;
    } else {
        return undefined;
    }
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) {
        return undefined;
    }
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) {
            acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)] = dscValue;
        }
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map(function(baggageEntry) {
        return baggageEntry.split("=").map(function(keyOrValue) {
            return decodeURIComponent(keyOrValue.trim());
        });
    }).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) {
        // An empty baggage header is not spec compliant: We return undefined.
        return undefined;
    }
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else {
            return newBaggageHeader;
        }
    }, "");
}
 //# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 90241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11436);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61745);



// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) {
        return "<unknown>";
    }
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return "";
    }
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(elem, HTMLElement) && elem.dataset && elem.dataset["sentryComponent"]) {
            return elem.dataset["sentryComponent"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function(keyAttrPair) {
            out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
        });
    } else {
        if (elem.id) {
            out.push("#".concat(elem.id));
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++){
                out.push(".".concat(classes[i]));
            }
        }
    }
    var allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[".concat(key, '="').concat(attr, '"]'));
        }
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
    if (WINDOW.document && WINDOW.document.querySelector) {
        return WINDOW.document.querySelector(selector);
    }
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) {
        return null;
    }
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) {
            return null;
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentElem, HTMLElement) && currentElem.dataset["sentryComponent"]) {
            return currentElem.dataset["sentryComponent"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
 //# sourceMappingURL=browser.js.map


/***/ }),

/***/ 73159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 11436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
// eslint-disable-next-line @typescript-eslint/unbound-method

var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isNaN(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(wat, base);
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
 //# sourceMappingURL=is.js.map


/***/ }),

/***/ 37745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73159);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61745);



/** Prefix for logging strings */ var PREFIX = "Sentry Logger ";
var CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace", 
];
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
        return callback();
    }
    var console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        },
        isEnabled: function() {
            return enabled;
        }
    };
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
        CONSOLE_LEVELS.forEach(function(name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (enabled) {
                    consoleSandbox(function() {
                        var _console;
                        (_console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console)[name].apply(_console, [
                            "".concat(PREFIX, "[").concat(name, "]:")
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)));
                    });
                }
            };
        });
    } else {
        CONSOLE_LEVELS.forEach(function(name) {
            logger[name] = function() {
                return undefined;
            };
        });
    }
    return logger;
}
var logger = makeLogger();
 //# sourceMappingURL=logger.js.map


/***/ }),

/***/ 78774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38434);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61745);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function uuid4() {
    var gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
    var crypto = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function() {
        return Math.random() * 16;
    };
    try {
        if (crypto && crypto.randomUUID) {
            return crypto.randomUUID().replace(/-/g, "");
        }
        if (crypto && crypto.getRandomValues) {
            getRandomByte = function() {
                // crypto.getRandomValues might return undefined instead of the typed array
                // in old Chromium versions (e.g. 23.0.1235.0 (151422))
                // However, `typedArray` is still filled in-place.
                // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
                var typedArray = new Uint8Array(1);
                crypto.getRandomValues(typedArray);
                return typedArray[0];
            };
        }
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return ([
        1e7
    ] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, function(c) {
        return (// eslint-disable-next-line no-bitwise
        c ^ (getRandomByte() & 15) >> c / 4).toString(16);
    });
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return "".concat(firstException.type, ": ").concat(firstException.value);
        }
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) {
        firstException.value = value || "";
    }
    if (!firstException.type) {
        firstException.type = type || "Error";
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) {
        return;
    }
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return snipLine(line, 0);
    });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return snipLine(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map


/***/ }),

/***/ 40465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase, walk

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(11436);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function memoBuilder() {
    var memoize = function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    };
    var unmemoize = function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        } else {
            for(var i = 0; i < inner.length; i++){
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    return [
        memoize,
        unmemoize
    ];
}
 //# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(38434);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(28848);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js






/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100 * 1024;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : +Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = (0,_sliced_to_array/* default */.Z)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) && !(0,is/* isNaN */.i2)(value)) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) {
        return stringified;
    }
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) {
        return value;
    }
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace("object ", "");
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return "[Circular ~]";
    }
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
        try {
            var jsonValue = valueWithToJSON.toJSON();
            // We need to normalize the return value of `.toJSON()` in case it has circular references
            return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
        } catch (err) {
        // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0,object/* convertToPlainObject */.Sh)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) {
            return "[Domain]";
        }
        if (key === "domainEmitter") {
            return "[DomainEmitter]";
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== "undefined" && value === __webpack_require__.g) {
            return "[Global]";
        }
        // eslint-disable-next-line no-restricted-globals
        if ( true && value === window) {
            return "[Window]";
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) {
            return "[Document]";
        }
        if ((0,is/* isVueViewModel */.y1)(value)) {
            return "[VueViewModel]";
        }
        // React's SyntheticEvent thingy
        if ((0,is/* isSyntheticEvent */.Cy)(value)) {
            return "[SyntheticEvent]";
        }
        if (typeof value === "number" && value !== value) {
            return "[NaN]";
        }
        if (typeof value === "function") {
            return "[Function: ".concat((0,stacktrace/* getFunctionName */.$P)(value), "]");
        }
        if ((typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) === "symbol") {
            return "[".concat(String(value), "]");
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) === "bigint") {
            return "[BigInt: ".concat(String(value), "]");
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) {
            return "[HTMLElement: ".concat(objName, "]");
        }
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), "ig"), "app:///");
}
 //# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 38434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90241);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73159);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11436);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37745);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35408);







/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") {
        markFunctionWrapped(wrapped, original);
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
    }).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, getOwnProperties(value));
    } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
        var newObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
            newObj.detail = value.detail;
        }
        return newObj;
    } else {
        return value;
    }
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_4__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj){
            if (Object.prototype.hasOwnProperty.call(obj, property)) {
                extractedProps[property] = obj[property];
            }
        }
        return extractedProps;
    } else {
        return {};
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return "[object has no keys]";
    }
    if (keys[0].length >= maxLength) {
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(keys[0], maxLength);
    }
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) {
            return memoVal;
        }
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== "undefined") {
                    returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) {
            return memoVal1;
        }
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
function isPojo(input) {
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
        return false;
    }
    try {
        var name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "symbol" || (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map


/***/ }),

/***/ 28848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);





var STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var frames = [];
        var lines = stack.split("\n");
        for(var i = skipFirst; i < lines.length; i++){
            var line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) {
                continue;
            }
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) {
                continue;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT) {
                break;
            }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) {
        return createStackParser.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stackParser));
    }
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
    }
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
            localStack.pop();
        }
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, frame), {
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        });
    });
}
var defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function nodeStackLineParser(getModule) {
    return [
        90,
        node(getModule)
    ];
}
 //# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 35408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11436);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== "string" || max === 0) {
        return str;
    }
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} ".concat(newLine);
    }
    if (end < lineLength) {
        newLine += " {snip}";
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return "";
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
                output.push("[VueViewModel]");
            } else {
                output.push(String(value));
            }
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
        return requireExactStringMatch ? value === pattern : value.includes(pattern);
    }
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}
 //# sourceMappingURL=string.js.map


/***/ }),

/***/ 58950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11436);



/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) {
                                // TODO: ¯\_(ツ)_/¯
                                // TODO: FIXME
                                resolve(result);
                            } else {
                                try {
                                    resolve(onfulfilled(result));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        },
                        function(reason) {
                            if (!onrejected) {
                                reject(reason);
                            } else {
                                try {
                                    resolve(onrejected(reason));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        }, 
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) {
                            onfinally();
                        }
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) {
                            onfinally();
                        }
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult(States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult(States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== States.PENDING) {
                        return;
                    }
                    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isThenable */ .J8)(value)) {
                        void value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === States.PENDING) {
                        return;
                    }
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) {
                            return;
                        }
                        if (_this._state === States.RESOLVED) {
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            handler[1](_this._value);
                        }
                        if (_this._state === States.REJECTED) {
                            handler[2](_this._value);
                        }
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();
 //# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 25231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61745);

var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.performance */ .n2.performance;
    if (!performance || !performance.now) {
        return dateTimestampInSeconds;
    }
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    var approxStartingTimeOrigin = Date.now() - performance.now();
    var timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.performance */ .n2.performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();
 //# sourceMappingURL=time.js.map


/***/ }),

/***/ 87143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "KA": function() { return /* binding */ tracingContextFromHeaders; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; },
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; }
/* harmony export */ });
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41326);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78774);


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*" + // whitespace
"([0-9a-f]{32})?" + // trace_id
"-?([0-9a-f]{16})?" + // span_id
"-?([01])?" + // sampled
"[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) {
        return undefined;
    }
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) {
        return undefined;
    }
    var parentSampled;
    if (matches[3] === "1") {
        parentSampled = true;
    } else if (matches[3] === "0") {
        parentSampled = false;
    }
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function tracingContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);
    var ref = traceparentData || {}, traceId = ref.traceId, parentSpanId = ref.parentSpanId, parentSampled = ref.parentSampled;
    if (!traceparentData) {
        return {
            traceparentData: traceparentData,
            dynamicSamplingContext: undefined,
            propagationContext: {
                traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
                spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16)
            }
        };
    } else {
        return {
            traceparentData: traceparentData,
            dynamicSamplingContext: dynamicSamplingContext || {},
            propagationContext: {
                traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
                parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
                spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
                sampled: parentSampled,
                dsc: dynamicSamplingContext || {}
            }
        };
    }
}
/**
 * Create a propagation context from incoming headers.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);
    var ref = traceparentData || {}, traceId = ref.traceId, parentSpanId = ref.parentSpanId, parentSampled = ref.parentSampled;
    if (!traceparentData) {
        return {
            traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
            spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16)
        };
    } else {
        return {
            traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
            parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
            spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        };
    }
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = "";
    if (sampled !== undefined) {
        sampledString = sampled ? "-1" : "-0";
    }
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
 //# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 61745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
 true && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof __webpack_require__.g == "object" && isGlobalObj(__webpack_require__.g) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function getGlobalObject() {
    return GLOBAL_OBJ;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj) {
    var gbl = obj || GLOBAL_OBJ;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
 //# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 68430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var strictUriEncode = __webpack_require__(11373);
var objectAssign = __webpack_require__(96086);
var decodeComponent = __webpack_require__(44020);
function encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, index) {
                return value === null ? [
                    encode(key, opts),
                    "[",
                    index,
                    "]"
                ].join("") : [
                    encode(key, opts),
                    "[",
                    encode(index, opts),
                    "]=",
                    encode(value, opts)
                ].join("");
            };
        case "bracket":
            return function(key, value) {
                return value === null ? encode(key, opts) : [
                    encode(key, opts),
                    "[]=",
                    encode(value, opts)
                ].join("");
            };
        default:
            return function(key, value) {
                return value === null ? encode(key, opts) : [
                    encode(key, opts),
                    "=",
                    encode(value, opts)
                ].join("");
            };
    }
}
function parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = {};
                }
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function encode(value, opts) {
    if (opts.encode) {
        return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) {
        return input.sort();
    } else if (typeof input === "object") {
        return keysSorter(Object.keys(input)).sort(function(a, b) {
            return Number(a) - Number(b);
        }).map(function(key) {
            return input[key];
        });
    }
    return input;
}
function extract(str) {
    var queryStart = str.indexOf("?");
    if (queryStart === -1) {
        return "";
    }
    return str.slice(queryStart + 1);
}
function parse(str, opts) {
    opts = objectAssign({
        arrayFormat: "none"
    }, opts);
    var formatter = parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== "string") {
        return ret;
    }
    str = str.trim().replace(/^[?#&]/, "");
    if (!str) {
        return ret;
    }
    str.split("&").forEach(function(param) {
        var parts = param.replace(/\+/g, " ").split("=");
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join("=") : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeComponent(val);
        formatter(decodeComponent(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === "object" && !Array.isArray(val)) {
            // Sort object keys, not values
            result[key] = keysSorter(val);
        } else {
            result[key] = val;
        }
        return result;
    }, Object.create(null));
}
__webpack_unused_export__ = extract;
__webpack_unused_export__ = parse;
exports.Pz = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: "none"
    };
    opts = objectAssign(defaults, opts);
    if (opts.sort === false) {
        opts.sort = function() {};
    }
    var formatter = encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) {
            return "";
        }
        if (val === null) {
            return encode(key, opts);
        }
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) {
                    return;
                }
                result.push(formatter(key, val2, result.length));
            });
            return result.join("&");
        }
        return encode(key, opts) + "=" + encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&") : "";
};
__webpack_unused_export__ = function(str, opts) {
    return {
        url: str.split("?")[0] || "",
        query: parse(extract(str), opts)
    };
};


/***/ }),

/***/ 11373:
/***/ (function(module) {

"use strict";

module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};


/***/ }),

/***/ 89833:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42338:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 52765:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 16703:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 67284:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 23262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
/* Returns React children into an array, flattening fragments. */
var react_1 = __webpack_require__(67294);
var react_is_1 = __webpack_require__(62994);
function flattenChildren(children, depth, keys) {
    if (depth === void 0) { depth = 0; }
    if (keys === void 0) { keys = []; }
    return react_1.Children.toArray(children).reduce(function (acc, node, nodeIndex) {
        if (react_is_1.isFragment(node)) {
            acc.push.apply(acc, flattenChildren(node.props.children, depth + 1, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (react_1.isValidElement(node)) {
                acc.push(react_1.cloneElement(node, {
                    key: keys.concat(String(node.key)).join('.')
                }));
            }
            else if (typeof node === "string" || typeof node === "number") {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}
exports.Z = flattenChildren;


/***/ }),

/***/ 74726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 62994:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(74726);
} else {}


/***/ }),

/***/ 59852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 46747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61284);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86755);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 36997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 41909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 81262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41909);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(101);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 40068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 61284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(81262);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(40068);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(36997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 21216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59852);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40068);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 52943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 86755:
/***/ (function() {



/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3407);



/***/ }),

/***/ 3407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(81262);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(36997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 67778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ToastContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(38047);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(59422);

var _ToastElement = __webpack_require__(5095);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
/** @jsx jsx */

var placements = {
  'top-left': { top: 0, left: 0 },
  'top-center': { top: 0, left: '50%', transform: 'translateX(-50%)' },
  'top-right': { top: 0, right: 0 },
  'bottom-left': { bottom: 0, left: 0 },
  'bottom-center': { bottom: 0, left: '50%', transform: 'translateX(-50%)' },
  'bottom-right': { bottom: 0, right: 0 }
};

var ToastContainer = function ToastContainer(_ref) {
  var hasToasts = _ref.hasToasts,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, ['hasToasts', 'placement']);

  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__container',
    css: _extends({
      boxSizing: 'border-box',
      maxHeight: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      padding: _ToastElement.gutter,
      pointerEvents: hasToasts ? null : 'none',
      position: 'fixed',
      zIndex: 1000
    }, placements[placement])
  }, props));
};
exports.ToastContainer = ToastContainer;

/***/ }),

/***/ 66198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ToastController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(59422);

var _utils = __webpack_require__(3155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultAutoDismissTimeout = 5000;

var TimerType = {
  clear: _utils.NOOP,
  pause: _utils.NOOP,
  resume: _utils.NOOP
};

function Timer(callback, delay) {
  var timerId = void 0;
  var start = delay;
  var remaining = delay;

  this.clear = function () {
    clearTimeout(timerId);
  };

  this.pause = function () {
    clearTimeout(timerId);
    remaining -= Date.now() - start;
  };

  this.resume = function () {
    start = Date.now();
    clearTimeout(timerId);
    timerId = setTimeout(callback, remaining);
  };

  this.resume();
}

var ToastController = exports.ToastController = function (_Component) {
  _inherits(ToastController, _Component);

  function ToastController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastController.__proto__ || Object.getPrototypeOf(ToastController)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isRunning: Boolean(_this.props.autoDismiss)
    }, _this.startTimer = function () {
      var _this$props = _this.props,
          autoDismiss = _this$props.autoDismiss,
          autoDismissTimeout = _this$props.autoDismissTimeout,
          onDismiss = _this$props.onDismiss;


      if (!autoDismiss) return;

      _this.setState({ isRunning: true });
      _this.timeout = new Timer(onDismiss, autoDismissTimeout);
    }, _this.clearTimer = function () {
      if (_this.timeout) _this.timeout.clear();
    }, _this.onMouseEnter = function () {
      _this.setState({ isRunning: false }, function () {
        if (_this.timeout) _this.timeout.pause();
      });
    }, _this.onMouseLeave = function () {
      _this.setState({ isRunning: true }, function () {
        if (_this.timeout) _this.timeout.resume();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToastController, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.autoDismiss !== this.props.autoDismiss) {
        var startOrClear = this.props.autoDismiss ? this.startTimer : this.clearTimer;

        startOrClear();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoDismiss = _props.autoDismiss,
          autoDismissTimeout = _props.autoDismissTimeout,
          Toast = _props.component,
          props = _objectWithoutProperties(_props, ['autoDismiss', 'autoDismissTimeout', 'component']);

      var isRunning = this.state.isRunning;

      // NOTE: conditions here so methods can be clean

      var handleMouseEnter = autoDismiss ? this.onMouseEnter : _utils.NOOP;
      var handleMouseLeave = autoDismiss ? this.onMouseLeave : _utils.NOOP;

      return _react2.default.createElement(Toast, _extends({
        autoDismiss: autoDismiss,
        autoDismissTimeout: autoDismissTimeout,
        isRunning: isRunning,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }, props));
    }
  }]);

  return ToastController;
}(_react.Component);

ToastController.defaultProps = {
  autoDismiss: false
};

/***/ }),

/***/ 5095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DefaultToast = exports.shrinkKeyframes = exports.toastWidth = exports.gutter = exports.borderRadius = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['from { height: 100%; } to { height: 0% }'], ['from { height: 100%; } to { height: 0% }']);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(38047);

var _icons = __webpack_require__(3468);

var _colors = __webpack_require__(75050);

var colors = _interopRequireWildcard(_colors);

var _utils = __webpack_require__(3155);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/** @jsx jsx */

// common
var borderRadius = exports.borderRadius = 4;
var gutter = exports.gutter = 8;
var toastWidth = exports.toastWidth = 360;
var shrinkKeyframes = exports.shrinkKeyframes = (0, _core.keyframes)(_templateObject);

// a11y helper
var A11yText = function A11yText(_ref) {
  var Tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ['tag']);

  return (0, _core.jsx)(Tag, _extends({
    css: {
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: 1
    }
  }, props));
};
A11yText.defaultProps = {
  tag: 'span'
};

// default appearances

var appearances = {
  success: {
    icon: _icons.CheckIcon,
    text: colors.G500,
    fg: colors.G300,
    bg: colors.G50
  },
  error: {
    icon: _icons.FlameIcon,
    text: colors.R500,
    fg: colors.R300,
    bg: colors.R50
  },
  warning: {
    icon: _icons.AlertIcon,
    text: colors.Y500,
    fg: colors.Y300,
    bg: colors.Y50
  },
  info: {
    icon: _icons.InfoIcon,
    text: colors.N400,
    fg: colors.B200,
    bg: 'white'
  }
};


var Button = function Button(props) {
  return (0, _core.jsx)('div', _extends({
    role: 'button',
    className: 'react-toast-notifications__toast__dismiss-button',
    css: {
      cursor: 'pointer',
      flexShrink: 0,
      opacity: 0.5,
      padding: gutter + 'px ' + gutter * 1.5 + 'px',
      transition: 'opacity 150ms',

      ':hover': { opacity: 1 }
    }
  }, props));
};

var Content = function Content(props) {
  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__toast__content',
    css: {
      flexGrow: 1,
      fontSize: 14,
      lineHeight: 1.4,
      minHeight: 40,
      padding: gutter + 'px ' + gutter * 1.5 + 'px'
    }
  }, props));
};

// NOTE: invoke animation when NOT `autoDismiss` with opacity of 0 to avoid a
// paint bug in FireFox.
// https://bugzilla.mozilla.org/show_bug.cgi?id=625289
var Countdown = function Countdown(_ref2) {
  var autoDismissTimeout = _ref2.autoDismissTimeout,
      opacity = _ref2.opacity,
      isRunning = _ref2.isRunning,
      props = _objectWithoutProperties(_ref2, ['autoDismissTimeout', 'opacity', 'isRunning']);

  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__toast__countdown',
    css: {
      animation: shrinkKeyframes + ' ' + autoDismissTimeout + 'ms linear',
      animationPlayState: isRunning ? 'running' : 'paused',
      backgroundColor: 'rgba(0,0,0,0.1)',
      bottom: 0,
      height: 0,
      left: 0,
      opacity: opacity,
      position: 'absolute',
      width: '100%'
    }
  }, props));
};

var Icon = function Icon(_ref3) {
  var appearance = _ref3.appearance,
      autoDismiss = _ref3.autoDismiss,
      autoDismissTimeout = _ref3.autoDismissTimeout,
      isRunning = _ref3.isRunning;

  var meta = appearances[appearance];
  var Glyph = meta.icon;

  return (0, _core.jsx)(
    'div',
    {
      className: 'react-toast-notifications__toast__icon-wrapper',
      css: {
        backgroundColor: meta.fg,
        borderTopLeftRadius: borderRadius,
        borderBottomLeftRadius: borderRadius,
        color: meta.bg,
        flexShrink: 0,
        paddingBottom: gutter,
        paddingTop: gutter,
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'center',
        width: 30
      }
    },
    (0, _core.jsx)(Countdown, {
      opacity: autoDismiss ? 1 : 0,
      autoDismissTimeout: autoDismissTimeout,
      isRunning: isRunning
    }),
    (0, _core.jsx)(Glyph, {
      className: 'react-toast-notifications__toast__icon',
      css: { position: 'relative', zIndex: 1 }
    })
  );
};

// Transitions
// ------------------------------

function getTranslate(placement) {
  var pos = placement.split('-');
  var relevantPlacement = pos[1] === 'center' ? pos[0] : pos[1];
  var translateMap = {
    right: 'translate3d(120%, 0, 0)',
    left: 'translate3d(-120%, 0, 0)',
    bottom: 'translate3d(0, 120%, 0)',
    top: 'translate3d(0, -120%, 0)'
  };

  return translateMap[relevantPlacement];
}

var toastStates = function toastStates(placement) {
  return {
    entering: { transform: getTranslate(placement) },
    entered: { transform: 'translate3d(0,0,0)' },
    exiting: { transform: 'scale(0.66)', opacity: 0 },
    exited: { transform: 'scale(0.66)', opacity: 0 }
  };
};

var ToastElement = function ToastElement(_ref4) {
  var appearance = _ref4.appearance,
      placement = _ref4.placement,
      transitionDuration = _ref4.transitionDuration,
      transitionState = _ref4.transitionState,
      props = _objectWithoutProperties(_ref4, ['appearance', 'placement', 'transitionDuration', 'transitionState']);

  var _useState = (0, _react.useState)('auto'),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var elementRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (transitionState === 'entered') {
      var el = elementRef.current;
      setHeight(el.offsetHeight + gutter);
    }
    if (transitionState === 'exiting') {
      setHeight(0);
    }
  }, [transitionState]);

  return (0, _core.jsx)(
    'div',
    {
      ref: elementRef,
      style: { height: height },
      css: {
        transition: 'height ' + (transitionDuration - 100) + 'ms 100ms'
      }
    },
    (0, _core.jsx)('div', _extends({
      className: 'react-toast-notifications__toast react-toast-notifications__toast--' + appearance,
      css: _extends({
        backgroundColor: appearances[appearance].bg,
        borderRadius: borderRadius,
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.175)',
        color: appearances[appearance].text,
        display: 'flex',
        marginBottom: gutter,
        maxWidth: '100%',
        transition: 'transform ' + transitionDuration + 'ms cubic-bezier(0.2, 0, 0, 1), opacity ' + transitionDuration + 'ms',
        width: toastWidth
      }, toastStates(placement)[transitionState])
    }, props))
  );
};

// ==============================
// DefaultToast
// ==============================

var DefaultToast = function DefaultToast(_ref5) {
  var _ref5$appearance = _ref5.appearance,
      appearance = _ref5$appearance === undefined ? 'info' : _ref5$appearance,
      autoDismiss = _ref5.autoDismiss,
      autoDismissTimeout = _ref5.autoDismissTimeout,
      children = _ref5.children,
      isRunning = _ref5.isRunning,
      onDismiss = _ref5.onDismiss,
      placement = _ref5.placement,
      transitionDuration = _ref5.transitionDuration,
      transitionState = _ref5.transitionState,
      onMouseEnter = _ref5.onMouseEnter,
      onMouseLeave = _ref5.onMouseLeave,
      otherProps = _objectWithoutProperties(_ref5, ['appearance', 'autoDismiss', 'autoDismissTimeout', 'children', 'isRunning', 'onDismiss', 'placement', 'transitionDuration', 'transitionState', 'onMouseEnter', 'onMouseLeave']);

  return (0, _core.jsx)(
    ToastElement,
    _extends({
      appearance: appearance,
      placement: placement,
      transitionState: transitionState,
      transitionDuration: transitionDuration,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, otherProps),
    (0, _core.jsx)(Icon, {
      appearance: appearance,
      autoDismiss: autoDismiss,
      autoDismissTimeout: autoDismissTimeout,
      isRunning: isRunning
    }),
    (0, _core.jsx)(
      Content,
      null,
      children
    ),
    onDismiss ? (0, _core.jsx)(
      Button,
      { onClick: onDismiss },
      (0, _core.jsx)(_icons.CloseIcon, { className: 'react-toast-notifications__toast__dismiss-icon' }),
      (0, _core.jsx)(
        A11yText,
        { className: 'react-toast-notifications__toast__dismiss-text' },
        'Close'
      )
    ) : null
  );
};

exports.DefaultToast = DefaultToast;
DefaultToast.defaultProps = {
  onDismiss: _utils.NOOP
};

/***/ }),

/***/ 25158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useToasts = exports.withToastManager = exports.ToastConsumer = exports.ToastProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactTransitionGroup = __webpack_require__(59422);

var _ToastController = __webpack_require__(66198);

var _ToastContainer = __webpack_require__(67778);

var _ToastElement = __webpack_require__(5095);

var _utils = __webpack_require__(3155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultComponents = { Toast: _ToastElement.DefaultToast, ToastContainer: _ToastContainer.ToastContainer };

// $FlowFixMe `createContext`
var ToastContext = _react2.default.createContext();
var Consumer = ToastContext.Consumer,
    Provider = ToastContext.Provider;


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Provider
// ==============================

var ToastProvider = exports.ToastProvider = function (_Component) {
  _inherits(ToastProvider, _Component);

  function ToastProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastProvider.__proto__ || Object.getPrototypeOf(ToastProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { toasts: [] }, _this.has = function (id) {
      if (!_this.state.toasts.length) {
        return false;
      }

      return Boolean(_this.state.toasts.filter(function (t) {
        return t.id === id;
      }).length);
    }, _this.onDismiss = function (id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.NOOP;
      return function () {
        cb(id);
        _this.remove(id);
      };
    }, _this.add = function (content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.NOOP;

      var id = options.id ? options.id : (0, _utils.generateUEID)();
      var callback = function callback() {
        return cb(id);
      };

      // bail if a toast exists with this ID
      if (_this.has(id)) {
        return;
      }

      // update the toast stack
      _this.setState(function (state) {
        var newToast = _extends({ content: content, id: id }, options);
        var toasts = _this.props.newestOnTop ? [newToast].concat(_toConsumableArray(state.toasts)) : [].concat(_toConsumableArray(state.toasts), [newToast]);

        return { toasts: toasts };
      }, callback);

      // consumer may want to do something with the generated ID (and not use the callback)
      return id;
    }, _this.remove = function (id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.NOOP;

      var callback = function callback() {
        return cb(id);
      };

      // bail if NO toasts exists with this ID
      if (!_this.has(id)) {
        return;
      }

      _this.setState(function (state) {
        var toasts = state.toasts.filter(function (t) {
          return t.id !== id;
        });
        return { toasts: toasts };
      }, callback);
    }, _this.removeAll = function () {
      if (!_this.state.toasts.length) {
        return;
      }

      _this.state.toasts.forEach(function (t) {
        return _this.remove(t.id);
      });
    }, _this.update = function (id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.NOOP;

      var callback = function callback() {
        return cb(id);
      };

      // bail if NO toasts exists with this ID
      if (!_this.has(id)) {
        return;
      }

      // update the toast stack
      _this.setState(function (state) {
        var old = state.toasts;
        var i = old.findIndex(function (t) {
          return t.id === id;
        });
        var updatedToast = _extends({}, old[i], options);
        var toasts = [].concat(_toConsumableArray(old.slice(0, i)), [updatedToast], _toConsumableArray(old.slice(i + 1)));

        return { toasts: toasts };
      }, callback);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Internal Helpers
  // ------------------------------

  // Public API
  // ------------------------------

  _createClass(ToastProvider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inheritedAutoDismiss = _props.autoDismiss,
          autoDismissTimeout = _props.autoDismissTimeout,
          children = _props.children,
          components = _props.components,
          placement = _props.placement,
          portalTargetSelector = _props.portalTargetSelector,
          transitionDuration = _props.transitionDuration;

      var _defaultComponents$co = _extends({}, defaultComponents, components),
          Toast = _defaultComponents$co.Toast,
          ToastContainer = _defaultComponents$co.ToastContainer;

      var add = this.add,
          remove = this.remove,
          removeAll = this.removeAll,
          update = this.update;

      var toasts = Object.freeze(this.state.toasts);

      var hasToasts = Boolean(toasts.length);
      var portalTarget = canUseDOM ? portalTargetSelector ? document.querySelector(portalTargetSelector) : document.body : null; // appease flow

      return _react2.default.createElement(
        Provider,
        { value: { add: add, remove: remove, removeAll: removeAll, update: update, toasts: toasts } },
        children,
        portalTarget ? (0, _reactDom.createPortal)(_react2.default.createElement(
          ToastContainer,
          { placement: placement, hasToasts: hasToasts },
          _react2.default.createElement(
            _reactTransitionGroup.TransitionGroup,
            { component: null },
            toasts.map(function (_ref2) {
              var appearance = _ref2.appearance,
                  autoDismiss = _ref2.autoDismiss,
                  content = _ref2.content,
                  id = _ref2.id,
                  onDismiss = _ref2.onDismiss,
                  unknownConsumerProps = _objectWithoutProperties(_ref2, ['appearance', 'autoDismiss', 'content', 'id', 'onDismiss']);

              return _react2.default.createElement(
                _reactTransitionGroup.Transition,
                {
                  appear: true,
                  key: id,
                  mountOnEnter: true,
                  timeout: transitionDuration,
                  unmountOnExit: true
                },
                function (transitionState) {
                  return _react2.default.createElement(
                    _ToastController.ToastController,
                    _extends({
                      appearance: appearance,
                      autoDismiss: autoDismiss !== undefined ? autoDismiss : inheritedAutoDismiss,
                      autoDismissTimeout: autoDismissTimeout,
                      component: Toast,
                      key: id,
                      onDismiss: _this2.onDismiss(id, onDismiss),
                      placement: placement,
                      transitionDuration: transitionDuration,
                      transitionState: transitionState
                    }, unknownConsumerProps),
                    content
                  );
                }
              );
            })
          )
        ), portalTarget) : _react2.default.createElement(ToastContainer, { placement: placement, hasToasts: hasToasts }) // keep ReactDOM.hydrate happy

      );
    }
  }]);

  return ToastProvider;
}(_react.Component);

ToastProvider.defaultProps = {
  autoDismiss: false,
  autoDismissTimeout: 5000,
  components: defaultComponents,
  newestOnTop: false,
  placement: 'top-right',
  transitionDuration: 220
};
var ToastConsumer = exports.ToastConsumer = function ToastConsumer(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    Consumer,
    null,
    function (context) {
      return children(context);
    }
  );
};

var withToastManager = exports.withToastManager = function withToastManager(Comp
// $FlowFixMe `forwardRef`
) {
  return _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(
      ToastConsumer,
      null,
      function (context) {
        return _react2.default.createElement(Comp, _extends({ toastManager: context }, props, { ref: ref }));
      }
    );
  });
};

var useToasts = exports.useToasts = function useToasts() {
  var ctx = (0, _react.useContext)(ToastContext);

  if (!ctx) {
    throw Error('The `useToasts` hook must be called from a descendent of the `ToastProvider`.');
  }

  return {
    addToast: ctx.add,
    removeToast: ctx.remove,
    removeAllToasts: ctx.removeAll,
    updateToast: ctx.update,
    toastStack: ctx.toasts
  };
};

/***/ }),

/***/ 75050:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
// Reds
var R50 = exports.R50 = '#FFEBE6';
var R75 = exports.R75 = '#FFBDAD';
var R100 = exports.R100 = '#FF8F73';
var R200 = exports.R200 = '#FF7452';
var R300 = exports.R300 = '#FF5630';
var R400 = exports.R400 = '#DE350B';
var R500 = exports.R500 = '#BF2600';

// Yellows
var Y50 = exports.Y50 = '#FFFAE6';
var Y75 = exports.Y75 = '#FFF0B3';
var Y100 = exports.Y100 = '#FFE380';
var Y200 = exports.Y200 = '#FFC400';
var Y300 = exports.Y300 = '#FFAB00';
var Y400 = exports.Y400 = '#FF991F';
var Y500 = exports.Y500 = '#FF8B00';

// Greens
var G50 = exports.G50 = '#E3FCEF';
var G75 = exports.G75 = '#ABF5D1';
var G100 = exports.G100 = '#79F2C0';
var G200 = exports.G200 = '#57D9A3';
var G300 = exports.G300 = '#36B37E';
var G400 = exports.G400 = '#00875A';
var G500 = exports.G500 = '#006644';

// Blues
var B50 = exports.B50 = '#DEEBFF';
var B75 = exports.B75 = '#B3D4FF';
var B100 = exports.B100 = '#4C9AFF';
var B200 = exports.B200 = '#2684FF';
var B300 = exports.B300 = '#0065FF';
var B400 = exports.B400 = '#0052CC';
var B500 = exports.B500 = '#0747A6';

// Purples
var P50 = exports.P50 = '#EAE6FF';
var P75 = exports.P75 = '#C0B6F2';
var P100 = exports.P100 = '#998DD9';
var P200 = exports.P200 = '#8777D9';
var P300 = exports.P300 = '#6554C0';
var P400 = exports.P400 = '#5243AA';
var P500 = exports.P500 = '#403294';

// Teals
var T50 = exports.T50 = '#E6FCFF';
var T75 = exports.T75 = '#B3F5FF';
var T100 = exports.T100 = '#79E2F2';
var T200 = exports.T200 = '#00C7E6';
var T300 = exports.T300 = '#00B8D9';
var T400 = exports.T400 = '#00A3BF';
var T500 = exports.T500 = '#008DA6';

// Neutrals
var N0 = exports.N0 = '#FFFFFF';
var N10 = exports.N10 = '#FAFBFC';
var N20 = exports.N20 = '#F4F5F7';
var N30 = exports.N30 = '#EBECF0';
var N40 = exports.N40 = '#DFE1E6';
var N50 = exports.N50 = '#C1C7D0';
var N60 = exports.N60 = '#B3BAC5';
var N70 = exports.N70 = '#A5ADBA';
var N80 = exports.N80 = '#97A0AF';
var N90 = exports.N90 = '#8993A4';
var N100 = exports.N100 = '#7A869A';
var N200 = exports.N200 = '#6B778C';
var N300 = exports.N300 = '#5E6C84';
var N400 = exports.N400 = '#505F79';
var N500 = exports.N500 = '#42526E';
var N600 = exports.N600 = '#344563';
var N700 = exports.N700 = '#253858';
var N800 = exports.N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = exports.N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = exports.N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = exports.N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = exports.N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = exports.N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = exports.N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = exports.N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = exports.N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = exports.N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = exports.N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = exports.N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = exports.N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = exports.N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = exports.N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = exports.N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = exports.N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = exports.N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = exports.N800A = 'rgba(9, 30, 66, 0.95)';

/***/ }),

/***/ 3468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CloseIcon = exports.InfoIcon = exports.FlameIcon = exports.CheckIcon = exports.AlertIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultProps(width) {
  return {
    'aria-hidden': true,
    height: 16,
    width: width,
    viewBox: '0 0 ' + width + ' 16',
    style: {
      display: 'inline-block',
      verticalAlign: 'text-top',
      fill: 'currentColor'
    }
  };
}

var AlertIcon = exports.AlertIcon = function AlertIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(16), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.893 1.5c-.183-.31-.52-.5-.887-.5s-.703.19-.886.5L.138 13.499a.98.98 0 0 0 0 1.001c.193.31.53.501.886.501h13.964c.367 0 .704-.19.877-.5a1.03 1.03 0 0 0 .01-1.002L8.893 1.5zm.133 11.497H6.987v-2.003h2.039v2.003zm0-3.004H6.987V5.987h2.039v4.006z'
    })
  );
};
var CheckIcon = exports.CheckIcon = function CheckIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(12), props),
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M12 5.5l-8 8-4-4L1.5 8 4 10.5 10.5 4 12 5.5z' })
  );
};
var FlameIcon = exports.FlameIcon = function FlameIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(12), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.05.01c.81 2.17.41 3.38-.52 4.31C3.55 5.37 1.98 6.15.9 7.68c-1.45 2.05-1.7 6.53 3.53 7.7-2.2-1.16-2.67-4.52-.3-6.61-.61 2.03.53 3.33 1.94 2.86 1.39-.47 2.3.53 2.27 1.67-.02.78-.31 1.44-1.13 1.81 3.42-.59 4.78-3.42 4.78-5.56 0-2.84-2.53-3.22-1.25-5.61-1.52.13-2.03 1.13-1.89 2.75.09 1.08-1.02 1.8-1.86 1.33-.67-.41-.66-1.19-.06-1.78C8.18 5.01 8.68 2.15 5.05.02L5.03 0l.02.01z'
    })
  );
};
var InfoIcon = exports.InfoIcon = function InfoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(14), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.3 5.71a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 8.01c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V8v.01zM7 2.32C3.86 2.32 1.3 4.86 1.3 8c0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z'
    })
  );
};
var CloseIcon = exports.CloseIcon = function CloseIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(14), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z'
    })
  );
};

/***/ }),

/***/ 85611:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _ToastContainer = __webpack_require__(67778);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ToastContainer.ToastContainer;
  }
});

var _ToastElement = __webpack_require__(5095);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ToastElement.DefaultToast;
  }
});

var _ToastProvider = __webpack_require__(25158);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ToastProvider.ToastConsumer;
  }
});
Object.defineProperty(exports, "VW", ({
  enumerable: true,
  get: function get() {
    return _ToastProvider.ToastProvider;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _ToastProvider.withToastManager;
  }
});
Object.defineProperty(exports, "e1", ({
  enumerable: true,
  get: function get() {
    return _ToastProvider.useToasts;
  }
}));

/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.generateUEID = generateUEID;
var NOOP = exports.NOOP = function NOOP() {};
function generateUEID() {
  var first = Math.random() * 46656 | 0;
  var second = Math.random() * 46656 | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);
  return first + second;
}

/***/ }),

/***/ 96630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ix": function() { return /* binding */ EXITING; },
/* harmony export */   "cn": function() { return /* binding */ ENTERED; },
/* harmony export */   "d0": function() { return /* binding */ ENTERING; }
/* harmony export */ });
/* unused harmony exports UNMOUNTED, EXITED */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94578);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6035);
/* harmony import */ var _TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(220);
/* harmony import */ var _utils_reflow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59391);









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,_utils_reflow__WEBPACK_IMPORTED_MODULE_3__/* .forceReflow */ .Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || _config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].disabled */ .Z.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || _config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].disabled */ .Z.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Provider */ .Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children), childProps))
    );
  };

  return Transition;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

Transition.contextType = _TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["ZP"] = (Transition);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 6035:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  disabled: false
});

/***/ }),

/***/ 59422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CSSTransition": function() { return /* reexport */ esm_CSSTransition; },
  "ReplaceTransition": function() { return /* reexport */ esm_ReplaceTransition; },
  "SwitchTransition": function() { return /* reexport */ esm_SwitchTransition; },
  "Transition": function() { return /* reexport */ Transition/* default */.ZP; },
  "TransitionGroup": function() { return /* reexport */ esm_TransitionGroup; },
  "config": function() { return /* reexport */ config/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js
var Transition = __webpack_require__(96630);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(59391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) (0,reflow/* forceReflow */.Q)(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(Transition/* default */.ZP, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/ReplaceTransition.js






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = react.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : react_dom.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in"]);

    var _React$Children$toArr = react.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/react.createElement(esm_TransitionGroup, props, inProp ? react.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : react.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(react.Component);

ReplaceTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_ReplaceTransition = (ReplaceTransition);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (react.isValidElement(oldChildren) && react.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(Transition/* ENTERING */.d0, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(Transition/* ENTERING */.d0);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(Transition/* ENTERED */.cn, react.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(Transition/* ENTERED */.cn, react.cloneElement(children, {
        in: true
      }));
    })
  }), react.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: Transition/* ENTERED */.cn,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === Transition/* ENTERING */.d0 && props.mode === modes.in) {
      return {
        status: Transition/* ENTERING */.d0
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: Transition/* EXITING */.Ix
      };
    }

    return {
      current: react.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case Transition/* ENTERING */.d0:
        component = enterRenders[mode](data);
        break;

      case Transition/* EXITING */.Ix:
        component = leaveRenders[mode](data);
        break;

      case Transition/* ENTERED */.cn:
        component = current;
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(react.Component);

SwitchTransition.propTypes =  false ? 0 : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ var esm_SwitchTransition = (SwitchTransition);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/config.js
var config = __webpack_require__(6035);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/index.js







/***/ }),

/***/ 59391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ forceReflow; }
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 89101:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _construct; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}


/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 25171:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 72955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ backToApp; },
/* harmony export */   "sF": function() { return /* binding */ storeAppInitialPath; }
/* harmony export */ });
/* unused harmony exports DEFAULT_INITIAL_PATH_STORAGE_KEY, getCurrentPathWithSearch */
var DEFAULT_INITIAL_PATH_STORAGE_KEY = "guru-initial-path";
/**
 * Get current page path and search.
 * @returns {string} path with query params/search
 */
function getCurrentPathWithSearch() {
    return window.location.pathname + window.location.search;
}
/**
 * Store initial path to storage when AndroidHandler is available.
 * Put this function on pages/_app.tsx in Next.js
 * or Layout component in other framework.
 * @param {string} customKey custom storage key
 */
function storeAppInitialPath(customKey) {
    var pathToStore = window.location.pathname;
    var key = customKey !== null && customKey !== void 0 ? customKey : DEFAULT_INITIAL_PATH_STORAGE_KEY;
    var currentPath = window.sessionStorage.getItem(key);
    if (!currentPath && window.AndroidHandler) {
        window.sessionStorage.setItem(key, pathToStore);
    }
}
/**
 * Back to app from webview using jsbridge AndroidHandler.
 * @param {function} backFn fallback back function for non-webview
 * @param {string} customKey custom storage key
 *
 * @example
 * ```typescript
 * backToApp(() => window.history.back())
 * ```
 */
function backToApp(backFn, customKey) {
    var key = customKey !== null && customKey !== void 0 ? customKey : DEFAULT_INITIAL_PATH_STORAGE_KEY;
    var initialPath = window.sessionStorage.getItem(key);
    var currentPath = window.location.pathname;
    if (initialPath === currentPath && window.AndroidHandler) {
        window.sessionStorage.removeItem(key);
        window.AndroidHandler.backToApp();
    }
    else {
        backFn();
    }
}




/***/ }),

/***/ 88593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(87209), __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);